import He, { useState as Je, useEffect as lt, useId as Fi, forwardRef as $i, useRef as on, useContext as Bi, createElement as Na, Component as Pa, createContext as Ia, useImperativeHandle as La, useCallback as jn } from "react";
import Ma from "react-dom";
function zi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vs = { exports: {} }, Xn = {};
var wo;
function Da() {
  if (wo) return Xn;
  wo = 1;
  var e = He, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(h, m, p) {
    var b, w = {}, E = null, I = null;
    p !== void 0 && (E = "" + p), m.key !== void 0 && (E = "" + m.key), m.ref !== void 0 && (I = m.ref);
    for (b in m) r.call(m, b) && !a.hasOwnProperty(b) && (w[b] = m[b]);
    if (h && h.defaultProps) for (b in m = h.defaultProps, m) w[b] === void 0 && (w[b] = m[b]);
    return { $$typeof: t, type: h, key: E, ref: I, props: w, _owner: i.current };
  }
  return Xn.Fragment = n, Xn.jsx = d, Xn.jsxs = d, Xn;
}
vs.exports = Da();
var f = vs.exports, ys = { exports: {} }, oi, So;
function Fa() {
  if (So) return oi;
  So = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return oi = e, oi;
}
var si, ko;
function $a() {
  if (ko) return si;
  ko = 1;
  var e = Fa();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, si = function() {
    function r(d, h, m, p, b, w) {
      if (w !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, si;
}
ys.exports = $a()();
var Ba = ys.exports;
const l = /* @__PURE__ */ zi(Ba), za = () => {
  const [e, t] = Je(null), [n, r] = Je(!1), [i, a] = Je(null), [d, h] = Je("");
  return lt(() => {
    if (!d) return;
    (() => {
      a(null), r(!0);
      try {
        fetch(d).then((p) => p.json()).then((p) => {
          t(p), r(!1);
        }).catch((p) => {
          a(p), r(!1);
        });
      } catch (p) {
        a(p);
      }
    })();
  }, [d]), [{ data: e, loading: n, error: i }, h];
};
function Ha(e) {
  const [t, n] = Je(!1);
  return lt(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const i = () => {
      n(r.matches);
    };
    return r.addEventListener("change", i), () => r.removeEventListener("change", i);
  }, [t, e]), t;
}
const To = (e, t, n) => e ? t : n, Ar = (e) => (e || []).join(" ");
const {
  entries: xs,
  setPrototypeOf: _o,
  isFrozen: Va,
  getPrototypeOf: Wa,
  getOwnPropertyDescriptor: Ua
} = Object;
let {
  freeze: ct,
  seal: bt,
  create: bs
} = Object, {
  apply: gi,
  construct: vi
} = typeof Reflect < "u" && Reflect;
ct || (ct = function(t) {
  return t;
});
bt || (bt = function(t) {
  return t;
});
gi || (gi = function(t, n, r) {
  return t.apply(n, r);
});
vi || (vi = function(t, n) {
  return new t(...n);
});
const Sr = ut(Array.prototype.forEach), qa = ut(Array.prototype.lastIndexOf), Eo = ut(Array.prototype.pop), Gn = ut(Array.prototype.push), Ya = ut(Array.prototype.splice), jr = ut(String.prototype.toLowerCase), ai = ut(String.prototype.toString), Co = ut(String.prototype.match), Kn = ut(String.prototype.replace), Xa = ut(String.prototype.indexOf), Ga = ut(String.prototype.trim), At = ut(Object.prototype.hasOwnProperty), at = ut(RegExp.prototype.test), Zn = Ka(TypeError);
function ut(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return gi(e, t, r);
  };
}
function Ka(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return vi(e, n);
  };
}
function me(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : jr;
  _o && _o(e, null);
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (Va(t) || (t[r] = a), i = a);
    }
    e[i] = !0;
  }
  return e;
}
function Za(e) {
  for (let t = 0; t < e.length; t++)
    At(e, t) || (e[t] = null);
  return e;
}
function xn(e) {
  const t = bs(null);
  for (const [n, r] of xs(e))
    At(e, n) && (Array.isArray(r) ? t[n] = Za(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = xn(r) : t[n] = r);
  return t;
}
function Jn(e, t) {
  for (; e !== null; ) {
    const r = Ua(e, t);
    if (r) {
      if (r.get)
        return ut(r.get);
      if (typeof r.value == "function")
        return ut(r.value);
    }
    e = Wa(e);
  }
  function n() {
    return null;
  }
  return n;
}
const Ro = ct(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), li = ct(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ci = ct(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ja = ct(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ui = ct(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Qa = ct(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Oo = ct(["#text"]), Ao = ct(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), di = ct(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), jo = ct(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), kr = ct(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), el = bt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), tl = bt(/<%[\w\W]*|[\w\W]*%>/gm), nl = bt(/\$\{[\w\W]*/gm), rl = bt(/^data-[\-\w.\u00B7-\uFFFF]+$/), il = bt(/^aria-[\-\w]+$/), ws = bt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ol = bt(/^(?:\w+script|data):/i), sl = bt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Ss = bt(/^html$/i), al = bt(/^[a-z][.\w]*(-[.\w]+)+$/i);
var No = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: il,
  ATTR_WHITESPACE: sl,
  CUSTOM_ELEMENT: al,
  DATA_ATTR: rl,
  DOCTYPE_NAME: Ss,
  ERB_EXPR: tl,
  IS_ALLOWED_URI: ws,
  IS_SCRIPT_OR_DATA: ol,
  MUSTACHE_EXPR: el,
  TMPLIT_EXPR: nl
});
const Qn = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ll = function() {
  return typeof window > "u" ? null : window;
}, cl = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Po = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function ks() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ll();
  const t = (G) => ks(G);
  if (t.version = "3.2.5", t.removed = [], !e || !e.document || e.document.nodeType !== Qn.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: d,
    Node: h,
    Element: m,
    NodeFilter: p,
    NamedNodeMap: b = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: w,
    DOMParser: E,
    trustedTypes: I
  } = e, O = m.prototype, k = Jn(O, "cloneNode"), N = Jn(O, "remove"), j = Jn(O, "nextSibling"), D = Jn(O, "childNodes"), V = Jn(O, "parentNode");
  if (typeof d == "function") {
    const G = n.createElement("template");
    G.content && G.content.ownerDocument && (n = G.content.ownerDocument);
  }
  let W, M = "";
  const {
    implementation: J,
    createNodeIterator: se,
    createDocumentFragment: Oe,
    getElementsByTagName: Fe
  } = n, {
    importNode: Ve
  } = r;
  let ke = Po();
  t.isSupported = typeof xs == "function" && typeof V == "function" && J && J.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: ye,
    ERB_EXPR: Q,
    TMPLIT_EXPR: he,
    DATA_ATTR: Ne,
    ARIA_ATTR: dt,
    IS_SCRIPT_OR_DATA: $e,
    ATTR_WHITESPACE: Be,
    CUSTOM_ELEMENT: Ye
  } = No;
  let {
    IS_ALLOWED_URI: ft
  } = No, we = null;
  const Y = me({}, [...Ro, ...li, ...ci, ...ui, ...Oo]);
  let B = null;
  const q = me({}, [...Ao, ...di, ...jo, ...kr]);
  let U = Object.seal(bs(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), A = null, ue = null, z = !0, pe = !0, re = !1, ie = !0, Z = !1, de = !0, xe = !1, ae = !1, Ae = !1, le = !1, Ee = !1, Ge = !1, je = !0, yt = !1;
  const Ke = "user-content-";
  let Se = !0, K = !1, be = {}, it = null;
  const wt = me({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ze = null;
  const an = me({}, ["audio", "video", "img", "source", "image", "track"]);
  let qt = null;
  const Tn = me({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nt = "http://www.w3.org/1998/Math/MathML", St = "http://www.w3.org/2000/svg", pt = "http://www.w3.org/1999/xhtml";
  let Pt = pt, ln = !1, cn = null;
  const Fn = me({}, [Nt, St, pt], ai);
  let Qe = me({}, ["mi", "mo", "mn", "ms", "mtext"]), It = me({}, ["annotation-xml"]);
  const Yt = me({}, ["title", "style", "font", "a", "script"]);
  let ge = null;
  const Ft = ["application/xhtml+xml", "text/html"], Xt = "text/html";
  let Pe = null, et = null;
  const Gt = n.createElement("form"), xt = function(S) {
    return S instanceof RegExp || S instanceof Function;
  }, Kt = function() {
    let S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(et && et === S)) {
      if ((!S || typeof S != "object") && (S = {}), S = xn(S), ge = // eslint-disable-next-line unicorn/prefer-includes
      Ft.indexOf(S.PARSER_MEDIA_TYPE) === -1 ? Xt : S.PARSER_MEDIA_TYPE, Pe = ge === "application/xhtml+xml" ? ai : jr, we = At(S, "ALLOWED_TAGS") ? me({}, S.ALLOWED_TAGS, Pe) : Y, B = At(S, "ALLOWED_ATTR") ? me({}, S.ALLOWED_ATTR, Pe) : q, cn = At(S, "ALLOWED_NAMESPACES") ? me({}, S.ALLOWED_NAMESPACES, ai) : Fn, qt = At(S, "ADD_URI_SAFE_ATTR") ? me(xn(Tn), S.ADD_URI_SAFE_ATTR, Pe) : Tn, Ze = At(S, "ADD_DATA_URI_TAGS") ? me(xn(an), S.ADD_DATA_URI_TAGS, Pe) : an, it = At(S, "FORBID_CONTENTS") ? me({}, S.FORBID_CONTENTS, Pe) : wt, A = At(S, "FORBID_TAGS") ? me({}, S.FORBID_TAGS, Pe) : {}, ue = At(S, "FORBID_ATTR") ? me({}, S.FORBID_ATTR, Pe) : {}, be = At(S, "USE_PROFILES") ? S.USE_PROFILES : !1, z = S.ALLOW_ARIA_ATTR !== !1, pe = S.ALLOW_DATA_ATTR !== !1, re = S.ALLOW_UNKNOWN_PROTOCOLS || !1, ie = S.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Z = S.SAFE_FOR_TEMPLATES || !1, de = S.SAFE_FOR_XML !== !1, xe = S.WHOLE_DOCUMENT || !1, le = S.RETURN_DOM || !1, Ee = S.RETURN_DOM_FRAGMENT || !1, Ge = S.RETURN_TRUSTED_TYPE || !1, Ae = S.FORCE_BODY || !1, je = S.SANITIZE_DOM !== !1, yt = S.SANITIZE_NAMED_PROPS || !1, Se = S.KEEP_CONTENT !== !1, K = S.IN_PLACE || !1, ft = S.ALLOWED_URI_REGEXP || ws, Pt = S.NAMESPACE || pt, Qe = S.MATHML_TEXT_INTEGRATION_POINTS || Qe, It = S.HTML_INTEGRATION_POINTS || It, U = S.CUSTOM_ELEMENT_HANDLING || {}, S.CUSTOM_ELEMENT_HANDLING && xt(S.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (U.tagNameCheck = S.CUSTOM_ELEMENT_HANDLING.tagNameCheck), S.CUSTOM_ELEMENT_HANDLING && xt(S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (U.attributeNameCheck = S.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), S.CUSTOM_ELEMENT_HANDLING && typeof S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (U.allowCustomizedBuiltInElements = S.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Z && (pe = !1), Ee && (le = !0), be && (we = me({}, Oo), B = [], be.html === !0 && (me(we, Ro), me(B, Ao)), be.svg === !0 && (me(we, li), me(B, di), me(B, kr)), be.svgFilters === !0 && (me(we, ci), me(B, di), me(B, kr)), be.mathMl === !0 && (me(we, ui), me(B, jo), me(B, kr))), S.ADD_TAGS && (we === Y && (we = xn(we)), me(we, S.ADD_TAGS, Pe)), S.ADD_ATTR && (B === q && (B = xn(B)), me(B, S.ADD_ATTR, Pe)), S.ADD_URI_SAFE_ATTR && me(qt, S.ADD_URI_SAFE_ATTR, Pe), S.FORBID_CONTENTS && (it === wt && (it = xn(it)), me(it, S.FORBID_CONTENTS, Pe)), Se && (we["#text"] = !0), xe && me(we, ["html", "head", "body"]), we.table && (me(we, ["tbody"]), delete A.tbody), S.TRUSTED_TYPES_POLICY) {
        if (typeof S.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Zn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof S.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Zn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        W = S.TRUSTED_TYPES_POLICY, M = W.createHTML("");
      } else
        W === void 0 && (W = cl(I, i)), W !== null && typeof M == "string" && (M = W.createHTML(""));
      ct && ct(S), et = S;
    }
  }, Zt = me({}, [...li, ...ci, ...Ja]), Jt = me({}, [...ui, ...Qa]), _n = function(S) {
    let F = V(S);
    (!F || !F.tagName) && (F = {
      namespaceURI: Pt,
      tagName: "template"
    });
    const X = jr(S.tagName), Ce = jr(F.tagName);
    return cn[S.namespaceURI] ? S.namespaceURI === St ? F.namespaceURI === pt ? X === "svg" : F.namespaceURI === Nt ? X === "svg" && (Ce === "annotation-xml" || Qe[Ce]) : !!Zt[X] : S.namespaceURI === Nt ? F.namespaceURI === pt ? X === "math" : F.namespaceURI === St ? X === "math" && It[Ce] : !!Jt[X] : S.namespaceURI === pt ? F.namespaceURI === St && !It[Ce] || F.namespaceURI === Nt && !Qe[Ce] ? !1 : !Jt[X] && (Yt[X] || !Zt[X]) : !!(ge === "application/xhtml+xml" && cn[S.namespaceURI]) : !1;
  }, ot = function(S) {
    Gn(t.removed, {
      element: S
    });
    try {
      V(S).removeChild(S);
    } catch {
      N(S);
    }
  }, $t = function(S, F) {
    try {
      Gn(t.removed, {
        attribute: F.getAttributeNode(S),
        from: F
      });
    } catch {
      Gn(t.removed, {
        attribute: null,
        from: F
      });
    }
    if (F.removeAttribute(S), S === "is")
      if (le || Ee)
        try {
          ot(F);
        } catch {
        }
      else
        try {
          F.setAttribute(S, "");
        } catch {
        }
  }, En = function(S) {
    let F = null, X = null;
    if (Ae)
      S = "<remove></remove>" + S;
    else {
      const ze = Co(S, /^[\r\n\t ]+/);
      X = ze && ze[0];
    }
    ge === "application/xhtml+xml" && Pt === pt && (S = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + S + "</body></html>");
    const Ce = W ? W.createHTML(S) : S;
    if (Pt === pt)
      try {
        F = new E().parseFromString(Ce, ge);
      } catch {
      }
    if (!F || !F.documentElement) {
      F = J.createDocument(Pt, "template", null);
      try {
        F.documentElement.innerHTML = ln ? M : Ce;
      } catch {
      }
    }
    const We = F.body || F.documentElement;
    return S && X && We.insertBefore(n.createTextNode(X), We.childNodes[0] || null), Pt === pt ? Fe.call(F, xe ? "html" : "body")[0] : xe ? F.documentElement : We;
  }, Cn = function(S) {
    return se.call(
      S.ownerDocument || S,
      S,
      // eslint-disable-next-line no-bitwise
      p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT | p.SHOW_PROCESSING_INSTRUCTION | p.SHOW_CDATA_SECTION,
      null
    );
  }, Lt = function(S) {
    return S instanceof w && (typeof S.nodeName != "string" || typeof S.textContent != "string" || typeof S.removeChild != "function" || !(S.attributes instanceof b) || typeof S.removeAttribute != "function" || typeof S.setAttribute != "function" || typeof S.namespaceURI != "string" || typeof S.insertBefore != "function" || typeof S.hasChildNodes != "function");
  }, un = function(S) {
    return typeof h == "function" && S instanceof h;
  };
  function nt(G, S, F) {
    Sr(G, (X) => {
      X.call(t, S, F, et);
    });
  }
  const Qt = function(S) {
    let F = null;
    if (nt(ke.beforeSanitizeElements, S, null), Lt(S))
      return ot(S), !0;
    const X = Pe(S.nodeName);
    if (nt(ke.uponSanitizeElement, S, {
      tagName: X,
      allowedTags: we
    }), S.hasChildNodes() && !un(S.firstElementChild) && at(/<[/\w!]/g, S.innerHTML) && at(/<[/\w!]/g, S.textContent) || S.nodeType === Qn.progressingInstruction || de && S.nodeType === Qn.comment && at(/<[/\w]/g, S.data))
      return ot(S), !0;
    if (!we[X] || A[X]) {
      if (!A[X] && Mt(X) && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, X) || U.tagNameCheck instanceof Function && U.tagNameCheck(X)))
        return !1;
      if (Se && !it[X]) {
        const Ce = V(S) || S.parentNode, We = D(S) || S.childNodes;
        if (We && Ce) {
          const ze = We.length;
          for (let Te = ze - 1; Te >= 0; --Te) {
            const st = k(We[Te], !0);
            st.__removalCount = (S.__removalCount || 0) + 1, Ce.insertBefore(st, j(S));
          }
        }
      }
      return ot(S), !0;
    }
    return S instanceof m && !_n(S) || (X === "noscript" || X === "noembed" || X === "noframes") && at(/<\/no(script|embed|frames)/i, S.innerHTML) ? (ot(S), !0) : (Z && S.nodeType === Qn.text && (F = S.textContent, Sr([ye, Q, he], (Ce) => {
      F = Kn(F, Ce, " ");
    }), S.textContent !== F && (Gn(t.removed, {
      element: S.cloneNode()
    }), S.textContent = F)), nt(ke.afterSanitizeElements, S, null), !1);
  }, Rn = function(S, F, X) {
    if (je && (F === "id" || F === "name") && (X in n || X in Gt))
      return !1;
    if (!(pe && !ue[F] && at(Ne, F))) {
      if (!(z && at(dt, F))) {
        if (!B[F] || ue[F]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Mt(S) && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, S) || U.tagNameCheck instanceof Function && U.tagNameCheck(S)) && (U.attributeNameCheck instanceof RegExp && at(U.attributeNameCheck, F) || U.attributeNameCheck instanceof Function && U.attributeNameCheck(F)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            F === "is" && U.allowCustomizedBuiltInElements && (U.tagNameCheck instanceof RegExp && at(U.tagNameCheck, X) || U.tagNameCheck instanceof Function && U.tagNameCheck(X)))
          ) return !1;
        } else if (!qt[F]) {
          if (!at(ft, Kn(X, Be, ""))) {
            if (!((F === "src" || F === "xlink:href" || F === "href") && S !== "script" && Xa(X, "data:") === 0 && Ze[S])) {
              if (!(re && !at($e, Kn(X, Be, "")))) {
                if (X)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Mt = function(S) {
    return S !== "annotation-xml" && Co(S, Ye);
  }, On = function(S) {
    nt(ke.beforeSanitizeAttributes, S, null);
    const {
      attributes: F
    } = S;
    if (!F || Lt(S))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: B,
      forceKeepAttr: void 0
    };
    let Ce = F.length;
    for (; Ce--; ) {
      const We = F[Ce], {
        name: ze,
        namespaceURI: Te,
        value: st
      } = We, kt = Pe(ze);
      let Ue = ze === "value" ? st : Ga(st);
      if (X.attrName = kt, X.attrValue = Ue, X.keepAttr = !0, X.forceKeepAttr = void 0, nt(ke.uponSanitizeAttribute, S, X), Ue = X.attrValue, yt && (kt === "id" || kt === "name") && ($t(ze, S), Ue = Ke + Ue), de && at(/((--!?|])>)|<\/(style|title)/i, Ue)) {
        $t(ze, S);
        continue;
      }
      if (X.forceKeepAttr || ($t(ze, S), !X.keepAttr))
        continue;
      if (!ie && at(/\/>/i, Ue)) {
        $t(ze, S);
        continue;
      }
      Z && Sr([ye, Q, he], (Tt) => {
        Ue = Kn(Ue, Tt, " ");
      });
      const fn = Pe(S.nodeName);
      if (Rn(fn, kt, Ue)) {
        if (W && typeof I == "object" && typeof I.getAttributeType == "function" && !Te)
          switch (I.getAttributeType(fn, kt)) {
            case "TrustedHTML": {
              Ue = W.createHTML(Ue);
              break;
            }
            case "TrustedScriptURL": {
              Ue = W.createScriptURL(Ue);
              break;
            }
          }
        try {
          Te ? S.setAttributeNS(Te, ze, Ue) : S.setAttribute(ze, Ue), Lt(S) ? ot(S) : Eo(t.removed);
        } catch {
        }
      }
    }
    nt(ke.afterSanitizeAttributes, S, null);
  }, dn = function G(S) {
    let F = null;
    const X = Cn(S);
    for (nt(ke.beforeSanitizeShadowDOM, S, null); F = X.nextNode(); )
      nt(ke.uponSanitizeShadowNode, F, null), Qt(F), On(F), F.content instanceof a && G(F.content);
    nt(ke.afterSanitizeShadowDOM, S, null);
  };
  return t.sanitize = function(G) {
    let S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = null, X = null, Ce = null, We = null;
    if (ln = !G, ln && (G = "<!-->"), typeof G != "string" && !un(G))
      if (typeof G.toString == "function") {
        if (G = G.toString(), typeof G != "string")
          throw Zn("dirty is not a string, aborting");
      } else
        throw Zn("toString is not a function");
    if (!t.isSupported)
      return G;
    if (ae || Kt(S), t.removed = [], typeof G == "string" && (K = !1), K) {
      if (G.nodeName) {
        const st = Pe(G.nodeName);
        if (!we[st] || A[st])
          throw Zn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (G instanceof h)
      F = En("<!---->"), X = F.ownerDocument.importNode(G, !0), X.nodeType === Qn.element && X.nodeName === "BODY" || X.nodeName === "HTML" ? F = X : F.appendChild(X);
    else {
      if (!le && !Z && !xe && // eslint-disable-next-line unicorn/prefer-includes
      G.indexOf("<") === -1)
        return W && Ge ? W.createHTML(G) : G;
      if (F = En(G), !F)
        return le ? null : Ge ? M : "";
    }
    F && Ae && ot(F.firstChild);
    const ze = Cn(K ? G : F);
    for (; Ce = ze.nextNode(); )
      Qt(Ce), On(Ce), Ce.content instanceof a && dn(Ce.content);
    if (K)
      return G;
    if (le) {
      if (Ee)
        for (We = Oe.call(F.ownerDocument); F.firstChild; )
          We.appendChild(F.firstChild);
      else
        We = F;
      return (B.shadowroot || B.shadowrootmode) && (We = Ve.call(r, We, !0)), We;
    }
    let Te = xe ? F.outerHTML : F.innerHTML;
    return xe && we["!doctype"] && F.ownerDocument && F.ownerDocument.doctype && F.ownerDocument.doctype.name && at(Ss, F.ownerDocument.doctype.name) && (Te = "<!DOCTYPE " + F.ownerDocument.doctype.name + `>
` + Te), Z && Sr([ye, Q, he], (st) => {
      Te = Kn(Te, st, " ");
    }), W && Ge ? W.createHTML(Te) : Te;
  }, t.setConfig = function() {
    let G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Kt(G), ae = !0;
  }, t.clearConfig = function() {
    et = null, ae = !1;
  }, t.isValidAttribute = function(G, S, F) {
    et || Kt({});
    const X = Pe(G), Ce = Pe(S);
    return Rn(X, Ce, F);
  }, t.addHook = function(G, S) {
    typeof S == "function" && Gn(ke[G], S);
  }, t.removeHook = function(G, S) {
    if (S !== void 0) {
      const F = qa(ke[G], S);
      return F === -1 ? void 0 : Ya(ke[G], F, 1)[0];
    }
    return Eo(ke[G]);
  }, t.removeHooks = function(G) {
    ke[G] = [];
  }, t.removeAllHooks = function() {
    ke = Po();
  }, t;
}
var Io = ks();
let Tr = null;
function ul() {
  return Tr || (typeof window < "u" ? Tr = Io(window) : Tr = Io), Tr;
}
function dl(e) {
  const t = e ? document.querySelector(e) : document;
  return t ? t.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const vt = (e) => ({ __html: ul().sanitize(e) }), Lo = (e, t, n) => {
  let r = e;
  const i = [];
  for (; r < t; )
    r > 0 && r <= n && i.push(r), r += 1;
  return i;
};
let fi = !1;
const yi = (e, t) => {
  fi || (fi = !0, setTimeout(() => {
    e(), fi = !1;
  }, t));
};
let Mo;
const xi = (e, t) => {
  window.clearTimeout(Mo), Mo = window.setTimeout(e, t);
};
function fl(e) {
  if (e && typeof e.getBoundingClientRect == "function") {
    const { bottom: t, top: n } = e.getBoundingClientRect(), { offsetTop: r } = e;
    if (n < 0 && t > 0) {
      const i = e.style;
      e.style = `${i};transition: height 0s !important; overflow:hidden; height:${t}px!important;max-height:${t}px!important`, window.scrollTo({ behavior: "instant", top: r }), setTimeout(() => {
        e.style = i, window.scrollTo({
          behavior: "smooth",
          top: e.offsetTop - t / 2
        });
      }, 50);
    }
  }
}
l.shape({
  event: l.string,
  action: l.string,
  name: l.string,
  region: l.string,
  section: l.string,
  component: l.string,
  type: l.string,
  text: l.string
});
const Ts = ({
  event: e = "",
  action: t = "",
  name: n = "",
  type: r = "",
  section: i = "",
  text: a = "",
  region: d = "",
  component: h = ""
}) => {
  const { dataLayer: m } = window, p = {
    event: e.toLowerCase(),
    action: t.toLowerCase(),
    name: n.toLowerCase(),
    type: r.toLowerCase(),
    region: d.toLowerCase(),
    section: i.toLowerCase(),
    text: a.toLowerCase(),
    component: h.toLowerCase()
  };
  m && m.push(p);
}, rr = ({ children: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e });
rr.propTypes = {
  children: l.oneOfType([
    l.arrayOf(l.node),
    l.node,
    l.string
  ])
};
var _s = { exports: {} };
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", d = 0; d < arguments.length; d++) {
        var h = arguments[d];
        h && (a = i(a, r(h)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var d = "";
      for (var h in a)
        t.call(a, h) && a[h] && (d = i(d, h));
      return d;
    }
    function i(a, d) {
      return d ? a ? a + " " + d : a + d : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(_s);
var pl = _s.exports;
const ve = /* @__PURE__ */ zi(pl);
({
  ...rr.propTypes
});
const Es = ({ children: e, className: t = "container", ...n }) => /* @__PURE__ */ f.jsx("div", { className: t, ...n, children: /* @__PURE__ */ f.jsx("div", { className: "row", children: e }) });
Es.propTypes = {
  children: rr.propTypes.children
};
({
  ...Es.propTypes
});
rr.propTypes.children, l.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
rr.propTypes.children;
const hl = l.shape({
  url: l.string,
  altText: l.string,
  cssClass: l.arrayOf(l.string),
  size: l.oneOf(["small", "medium", "large"])
}), pi = l.shape({
  text: l.string,
  maxWidth: l.string,
  cssClass: l.arrayOf(l.string),
  highlightColor: l.oneOf(["gold", "black"])
}), Cs = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  content: l.shape({
    icon: l.arrayOf(l.string),
    header: l.string,
    body: l.string
  })
}), Hi = l.shape({
  text: l.string,
  name: l.string,
  event: l.string,
  action: l.string,
  type: l.string,
  region: l.string,
  section: l.string,
  component: l.string
});
var yn = {};
var Do;
function ml() {
  if (Do) return yn;
  Do = 1;
  var e = He;
  function t(o) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, v = 1; v < arguments.length; v++) u += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + o + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, a = {};
  function d(o) {
    return n.call(a, o) ? !0 : n.call(i, o) ? !1 : r.test(o) ? a[o] = !0 : (i[o] = !0, !1);
  }
  function h(o, u, v, x, R, T, P) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = x, this.attributeNamespace = R, this.mustUseProperty = v, this.propertyName = o, this.type = u, this.sanitizeURL = T, this.removeEmptyString = P;
  }
  var m = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    m[o] = new h(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var u = o[0];
    m[u] = new h(u, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    m[o] = new h(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    m[o] = new h(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    m[o] = new h(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    m[o] = new h(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    m[o] = new h(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    m[o] = new h(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    m[o] = new h(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var p = /[\-:]([a-z])/g;
  function b(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var u = o.replace(
      p,
      b
    );
    m[u] = new h(u, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var u = o.replace(p, b);
    m[u] = new h(u, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var u = o.replace(p, b);
    m[u] = new h(u, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    m[o] = new h(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), m.xlinkHref = new h("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    m[o] = new h(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  var w = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, E = ["Webkit", "ms", "Moz", "O"];
  Object.keys(w).forEach(function(o) {
    E.forEach(function(u) {
      u = u + o.charAt(0).toUpperCase() + o.substring(1), w[u] = w[o];
    });
  });
  var I = /["'&<>]/;
  function O(o) {
    if (typeof o == "boolean" || typeof o == "number") return "" + o;
    o = "" + o;
    var u = I.exec(o);
    if (u) {
      var v = "", x, R = 0;
      for (x = u.index; x < o.length; x++) {
        switch (o.charCodeAt(x)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        R !== x && (v += o.substring(R, x)), R = x + 1, v += u;
      }
      o = R !== x ? v + o.substring(R, x) : v;
    }
    return o;
  }
  var k = /([A-Z])/g, N = /^ms-/, j = Array.isArray;
  function D(o, u) {
    return { insertionMode: o, selectedValue: u };
  }
  function V(o, u, v) {
    switch (u) {
      case "select":
        return D(1, v.value != null ? v.value : v.defaultValue);
      case "svg":
        return D(2, null);
      case "math":
        return D(3, null);
      case "foreignObject":
        return D(1, null);
      case "table":
        return D(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return D(5, null);
      case "colgroup":
        return D(7, null);
      case "tr":
        return D(6, null);
    }
    return 4 <= o.insertionMode || o.insertionMode === 0 ? D(1, null) : o;
  }
  var W = /* @__PURE__ */ new Map();
  function M(o, u, v) {
    if (typeof v != "object") throw Error(t(62));
    u = !0;
    for (var x in v) if (n.call(v, x)) {
      var R = v[x];
      if (R != null && typeof R != "boolean" && R !== "") {
        if (x.indexOf("--") === 0) {
          var T = O(x);
          R = O(("" + R).trim());
        } else {
          T = x;
          var P = W.get(T);
          P !== void 0 || (P = O(T.replace(k, "-$1").toLowerCase().replace(N, "-ms-")), W.set(T, P)), T = P, R = typeof R == "number" ? R === 0 || n.call(w, x) ? "" + R : R + "px" : O(("" + R).trim());
        }
        u ? (u = !1, o.push(' style="', T, ":", R)) : o.push(";", T, ":", R);
      }
    }
    u || o.push('"');
  }
  function J(o, u, v, x) {
    switch (v) {
      case "style":
        M(o, u, x);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") {
      if (u = m.hasOwnProperty(v) ? m[v] : null, u !== null) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!u.acceptsBooleans) return;
        }
        switch (v = u.attributeName, u.type) {
          case 3:
            x && o.push(" ", v, '=""');
            break;
          case 4:
            x === !0 ? o.push(" ", v, '=""') : x !== !1 && o.push(" ", v, '="', O(x), '"');
            break;
          case 5:
            isNaN(x) || o.push(" ", v, '="', O(x), '"');
            break;
          case 6:
            !isNaN(x) && 1 <= x && o.push(" ", v, '="', O(x), '"');
            break;
          default:
            u.sanitizeURL && (x = "" + x), o.push(" ", v, '="', O(x), '"');
        }
      } else if (d(v)) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (u = v.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") return;
        }
        o.push(" ", v, '="', O(x), '"');
      }
    }
  }
  function se(o, u, v) {
    if (u != null) {
      if (v != null) throw Error(t(60));
      if (typeof u != "object" || !("__html" in u)) throw Error(t(61));
      u = u.__html, u != null && o.push("" + u);
    }
  }
  function Oe(o) {
    var u = "";
    return e.Children.forEach(o, function(v) {
      v != null && (u += v);
    }), u;
  }
  function Fe(o, u, v, x) {
    o.push(ye(v));
    var R = v = null, T;
    for (T in u) if (n.call(u, T)) {
      var P = u[T];
      if (P != null) switch (T) {
        case "children":
          v = P;
          break;
        case "dangerouslySetInnerHTML":
          R = P;
          break;
        default:
          J(o, x, T, P);
      }
    }
    return o.push(">"), se(o, R, v), typeof v == "string" ? (o.push(O(v)), null) : v;
  }
  var Ve = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ke = /* @__PURE__ */ new Map();
  function ye(o) {
    var u = ke.get(o);
    if (u === void 0) {
      if (!Ve.test(o)) throw Error(t(65, o));
      u = "<" + o, ke.set(o, u);
    }
    return u;
  }
  function Q(o, u, v, x, R) {
    switch (u) {
      case "select":
        o.push(ye("select"));
        var T = null, P = null;
        for (oe in v) if (n.call(v, oe)) {
          var H = v[oe];
          if (H != null) switch (oe) {
            case "children":
              T = H;
              break;
            case "dangerouslySetInnerHTML":
              P = H;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              J(o, x, oe, H);
          }
        }
        return o.push(">"), se(o, P, T), T;
      case "option":
        P = R.selectedValue, o.push(ye("option"));
        var ee = H = null, ne = null, oe = null;
        for (T in v) if (n.call(v, T)) {
          var Me = v[T];
          if (Me != null) switch (T) {
            case "children":
              H = Me;
              break;
            case "selected":
              ne = Me;
              break;
            case "dangerouslySetInnerHTML":
              oe = Me;
              break;
            case "value":
              ee = Me;
            default:
              J(o, x, T, Me);
          }
        }
        if (P != null) if (v = ee !== null ? "" + ee : Oe(H), j(P)) {
          for (x = 0; x < P.length; x++)
            if ("" + P[x] === v) {
              o.push(' selected=""');
              break;
            }
        } else "" + P === v && o.push(' selected=""');
        else ne && o.push(' selected=""');
        return o.push(">"), se(o, oe, H), H;
      case "textarea":
        o.push(ye("textarea")), oe = P = T = null;
        for (H in v) if (n.call(v, H) && (ee = v[H], ee != null)) switch (H) {
          case "children":
            oe = ee;
            break;
          case "value":
            T = ee;
            break;
          case "defaultValue":
            P = ee;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            J(
              o,
              x,
              H,
              ee
            );
        }
        if (T === null && P !== null && (T = P), o.push(">"), oe != null) {
          if (T != null) throw Error(t(92));
          if (j(oe) && 1 < oe.length) throw Error(t(93));
          T = "" + oe;
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T !== null && o.push(O("" + T)), null;
      case "input":
        o.push(ye("input")), ee = oe = H = T = null;
        for (P in v) if (n.call(v, P) && (ne = v[P], ne != null)) switch (P) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            ee = ne;
            break;
          case "defaultValue":
            H = ne;
            break;
          case "checked":
            oe = ne;
            break;
          case "value":
            T = ne;
            break;
          default:
            J(o, x, P, ne);
        }
        return oe !== null ? J(o, x, "checked", oe) : ee !== null && J(o, x, "checked", ee), T !== null ? J(o, x, "value", T) : H !== null && J(o, x, "value", H), o.push("/>"), null;
      case "menuitem":
        o.push(ye("menuitem"));
        for (var _t in v) if (n.call(v, _t) && (T = v[_t], T != null)) switch (_t) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            J(o, x, _t, T);
        }
        return o.push(">"), null;
      case "title":
        o.push(ye("title")), T = null;
        for (Me in v) if (n.call(v, Me) && (P = v[Me], P != null)) switch (Me) {
          case "children":
            T = P;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            J(o, x, Me, P);
        }
        return o.push(">"), T;
      case "listing":
      case "pre":
        o.push(ye(u)), P = T = null;
        for (ee in v) if (n.call(v, ee) && (H = v[ee], H != null)) switch (ee) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          default:
            J(o, x, ee, H);
        }
        if (o.push(">"), P != null) {
          if (T != null) throw Error(t(60));
          if (typeof P != "object" || !("__html" in P)) throw Error(t(61));
          v = P.__html, v != null && (typeof v == "string" && 0 < v.length && v[0] === `
` ? o.push(`
`, v) : o.push("" + v));
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        o.push(ye(u));
        for (var Et in v) if (n.call(v, Et) && (T = v[Et], T != null)) switch (Et) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, u));
          default:
            J(o, x, Et, T);
        }
        return o.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Fe(
          o,
          v,
          u,
          x
        );
      case "html":
        return R.insertionMode === 0 && o.push("<!DOCTYPE html>"), Fe(o, v, u, x);
      default:
        if (u.indexOf("-") === -1 && typeof v.is != "string") return Fe(o, v, u, x);
        o.push(ye(u)), P = T = null;
        for (ne in v) if (n.call(v, ne) && (H = v[ne], H != null)) switch (ne) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            P = H;
            break;
          case "style":
            M(o, x, H);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            d(ne) && typeof H != "function" && typeof H != "symbol" && o.push(" ", ne, '="', O(H), '"');
        }
        return o.push(">"), se(o, P, T), T;
    }
  }
  function he(o, u, v) {
    if (o.push('<!--$?--><template id="'), v === null) throw Error(t(395));
    return o.push(v), o.push('"></template>');
  }
  function Ne(o, u, v, x) {
    switch (v.insertionMode) {
      case 0:
      case 1:
        return o.push('<div hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 2:
        return o.push('<svg aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 3:
        return o.push('<math aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 4:
        return o.push('<table hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 5:
        return o.push('<table hidden><tbody id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 6:
        return o.push('<table hidden><tr id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 7:
        return o.push('<table hidden><colgroup id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      default:
        throw Error(t(397));
    }
  }
  function dt(o, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
        return o.push("</div>");
      case 2:
        return o.push("</svg>");
      case 3:
        return o.push("</math>");
      case 4:
        return o.push("</table>");
      case 5:
        return o.push("</tbody></table>");
      case 6:
        return o.push("</tr></table>");
      case 7:
        return o.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var $e = /[<\u2028\u2029]/g;
  function Be(o) {
    return JSON.stringify(o).replace($e, function(u) {
      switch (u) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Ye(o, u) {
    return u = u === void 0 ? "" : u, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: u + "P:", segmentPrefix: u + "S:", boundaryPrefix: u + "B:", idPrefix: u, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: o };
  }
  function ft(o, u, v, x) {
    return v.generateStaticMarkup ? (o.push(O(u)), !1) : (u === "" ? o = x : (x && o.push("<!-- -->"), o.push(O(u)), o = !0), o);
  }
  var we = Object.assign, Y = Symbol.for("react.element"), B = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), U = Symbol.for("react.strict_mode"), A = Symbol.for("react.profiler"), ue = Symbol.for("react.provider"), z = Symbol.for("react.context"), pe = Symbol.for("react.forward_ref"), re = Symbol.for("react.suspense"), ie = Symbol.for("react.suspense_list"), Z = Symbol.for("react.memo"), de = Symbol.for("react.lazy"), xe = Symbol.for("react.scope"), ae = Symbol.for("react.debug_trace_mode"), Ae = Symbol.for("react.legacy_hidden"), le = Symbol.for("react.default_value"), Ee = Symbol.iterator;
  function Ge(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case q:
        return "Fragment";
      case B:
        return "Portal";
      case A:
        return "Profiler";
      case U:
        return "StrictMode";
      case re:
        return "Suspense";
      case ie:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case z:
        return (o.displayName || "Context") + ".Consumer";
      case ue:
        return (o._context.displayName || "Context") + ".Provider";
      case pe:
        var u = o.render;
        return o = o.displayName, o || (o = u.displayName || u.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case Z:
        return u = o.displayName || null, u !== null ? u : Ge(o.type) || "Memo";
      case de:
        u = o._payload, o = o._init;
        try {
          return Ge(o(u));
        } catch {
        }
    }
    return null;
  }
  var je = {};
  function yt(o, u) {
    if (o = o.contextTypes, !o) return je;
    var v = {}, x;
    for (x in o) v[x] = u[x];
    return v;
  }
  var Ke = null;
  function Se(o, u) {
    if (o !== u) {
      o.context._currentValue2 = o.parentValue, o = o.parent;
      var v = u.parent;
      if (o === null) {
        if (v !== null) throw Error(t(401));
      } else {
        if (v === null) throw Error(t(401));
        Se(o, v);
      }
      u.context._currentValue2 = u.value;
    }
  }
  function K(o) {
    o.context._currentValue2 = o.parentValue, o = o.parent, o !== null && K(o);
  }
  function be(o) {
    var u = o.parent;
    u !== null && be(u), o.context._currentValue2 = o.value;
  }
  function it(o, u) {
    if (o.context._currentValue2 = o.parentValue, o = o.parent, o === null) throw Error(t(402));
    o.depth === u.depth ? Se(o, u) : it(o, u);
  }
  function wt(o, u) {
    var v = u.parent;
    if (v === null) throw Error(t(402));
    o.depth === v.depth ? Se(o, v) : wt(o, v), u.context._currentValue2 = u.value;
  }
  function Ze(o) {
    var u = Ke;
    u !== o && (u === null ? be(o) : o === null ? K(u) : u.depth === o.depth ? Se(u, o) : u.depth > o.depth ? it(u, o) : wt(u, o), Ke = o);
  }
  var an = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(o, u) {
    o = o._reactInternals, o.queue !== null && o.queue.push(u);
  }, enqueueReplaceState: function(o, u) {
    o = o._reactInternals, o.replace = !0, o.queue = [u];
  }, enqueueForceUpdate: function() {
  } };
  function qt(o, u, v, x) {
    var R = o.state !== void 0 ? o.state : null;
    o.updater = an, o.props = v, o.state = R;
    var T = { queue: [], replace: !1 };
    o._reactInternals = T;
    var P = u.contextType;
    if (o.context = typeof P == "object" && P !== null ? P._currentValue2 : x, P = u.getDerivedStateFromProps, typeof P == "function" && (P = P(v, R), R = P == null ? R : we({}, R, P), o.state = R), typeof u.getDerivedStateFromProps != "function" && typeof o.getSnapshotBeforeUpdate != "function" && (typeof o.UNSAFE_componentWillMount == "function" || typeof o.componentWillMount == "function")) if (u = o.state, typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), u !== o.state && an.enqueueReplaceState(o, o.state, null), T.queue !== null && 0 < T.queue.length) if (u = T.queue, P = T.replace, T.queue = null, T.replace = !1, P && u.length === 1) o.state = u[0];
    else {
      for (T = P ? u[0] : o.state, R = !0, P = P ? 1 : 0; P < u.length; P++) {
        var H = u[P];
        H = typeof H == "function" ? H.call(o, T, v, x) : H, H != null && (R ? (R = !1, T = we({}, T, H)) : we(T, H));
      }
      o.state = T;
    }
    else T.queue = null;
  }
  var Tn = { id: 1, overflow: "" };
  function Nt(o, u, v) {
    var x = o.id;
    o = o.overflow;
    var R = 32 - St(x) - 1;
    x &= ~(1 << R), v += 1;
    var T = 32 - St(u) + R;
    if (30 < T) {
      var P = R - R % 5;
      return T = (x & (1 << P) - 1).toString(32), x >>= P, R -= P, { id: 1 << 32 - St(u) + R | v << R | x, overflow: T + o };
    }
    return { id: 1 << T | v << R | x, overflow: o };
  }
  var St = Math.clz32 ? Math.clz32 : ln, pt = Math.log, Pt = Math.LN2;
  function ln(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (pt(o) / Pt | 0) | 0;
  }
  function cn(o, u) {
    return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
  }
  var Fn = typeof Object.is == "function" ? Object.is : cn, Qe = null, It = null, Yt = null, ge = null, Ft = !1, Xt = !1, Pe = 0, et = null, Gt = 0;
  function xt() {
    if (Qe === null) throw Error(t(321));
    return Qe;
  }
  function Kt() {
    if (0 < Gt) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Zt() {
    return ge === null ? Yt === null ? (Ft = !1, Yt = ge = Kt()) : (Ft = !0, ge = Yt) : ge.next === null ? (Ft = !1, ge = ge.next = Kt()) : (Ft = !0, ge = ge.next), ge;
  }
  function Jt() {
    It = Qe = null, Xt = !1, Yt = null, Gt = 0, ge = et = null;
  }
  function _n(o, u) {
    return typeof u == "function" ? u(o) : u;
  }
  function ot(o, u, v) {
    if (Qe = xt(), ge = Zt(), Ft) {
      var x = ge.queue;
      if (u = x.dispatch, et !== null && (v = et.get(x), v !== void 0)) {
        et.delete(x), x = ge.memoizedState;
        do
          x = o(x, v.action), v = v.next;
        while (v !== null);
        return ge.memoizedState = x, [x, u];
      }
      return [ge.memoizedState, u];
    }
    return o = o === _n ? typeof u == "function" ? u() : u : v !== void 0 ? v(u) : u, ge.memoizedState = o, o = ge.queue = { last: null, dispatch: null }, o = o.dispatch = En.bind(null, Qe, o), [ge.memoizedState, o];
  }
  function $t(o, u) {
    if (Qe = xt(), ge = Zt(), u = u === void 0 ? null : u, ge !== null) {
      var v = ge.memoizedState;
      if (v !== null && u !== null) {
        var x = v[1];
        e: if (x === null) x = !1;
        else {
          for (var R = 0; R < x.length && R < u.length; R++) if (!Fn(u[R], x[R])) {
            x = !1;
            break e;
          }
          x = !0;
        }
        if (x) return v[0];
      }
    }
    return o = o(), ge.memoizedState = [o, u], o;
  }
  function En(o, u, v) {
    if (25 <= Gt) throw Error(t(301));
    if (o === Qe) if (Xt = !0, o = { action: v, next: null }, et === null && (et = /* @__PURE__ */ new Map()), v = et.get(u), v === void 0) et.set(u, o);
    else {
      for (u = v; u.next !== null; ) u = u.next;
      u.next = o;
    }
  }
  function Cn() {
    throw Error(t(394));
  }
  function Lt() {
  }
  var un = { readContext: function(o) {
    return o._currentValue2;
  }, useContext: function(o) {
    return xt(), o._currentValue2;
  }, useMemo: $t, useReducer: ot, useRef: function(o) {
    Qe = xt(), ge = Zt();
    var u = ge.memoizedState;
    return u === null ? (o = { current: o }, ge.memoizedState = o) : u;
  }, useState: function(o) {
    return ot(_n, o);
  }, useInsertionEffect: Lt, useLayoutEffect: function() {
  }, useCallback: function(o, u) {
    return $t(function() {
      return o;
    }, u);
  }, useImperativeHandle: Lt, useEffect: Lt, useDebugValue: Lt, useDeferredValue: function(o) {
    return xt(), o;
  }, useTransition: function() {
    return xt(), [
      !1,
      Cn
    ];
  }, useId: function() {
    var o = It.treeContext, u = o.overflow;
    o = o.id, o = (o & ~(1 << 32 - St(o) - 1)).toString(32) + u;
    var v = nt;
    if (v === null) throw Error(t(404));
    return u = Pe++, o = ":" + v.idPrefix + "R" + o, 0 < u && (o += "H" + u.toString(32)), o + ":";
  }, useMutableSource: function(o, u) {
    return xt(), u(o._source);
  }, useSyncExternalStore: function(o, u, v) {
    if (v === void 0) throw Error(t(407));
    return v();
  } }, nt = null, Qt = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Rn(o) {
    return console.error(o), null;
  }
  function Mt() {
  }
  function On(o, u, v, x, R, T, P, H, ee) {
    var ne = [], oe = /* @__PURE__ */ new Set();
    return u = { destination: null, responseState: u, progressiveChunkSize: x === void 0 ? 12800 : x, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: oe, pingedTasks: ne, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: R === void 0 ? Rn : R, onAllReady: Mt, onShellReady: P === void 0 ? Mt : P, onShellError: Mt, onFatalError: Mt }, v = G(u, 0, null, v, !1, !1), v.parentFlushed = !0, o = dn(u, o, null, v, oe, je, null, Tn), ne.push(o), u;
  }
  function dn(o, u, v, x, R, T, P, H) {
    o.allPendingTasks++, v === null ? o.pendingRootTasks++ : v.pendingTasks++;
    var ee = { node: u, ping: function() {
      var ne = o.pingedTasks;
      ne.push(ee), ne.length === 1 && sr(o);
    }, blockedBoundary: v, blockedSegment: x, abortSet: R, legacyContext: T, context: P, treeContext: H };
    return R.add(ee), ee;
  }
  function G(o, u, v, x, R, T) {
    return { status: 0, id: -1, index: u, parentFlushed: !1, chunks: [], children: [], formatContext: x, boundary: v, lastPushedText: R, textEmbedded: T };
  }
  function S(o, u) {
    if (o = o.onError(u), o != null && typeof o != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof o + '" instead');
    return o;
  }
  function F(o, u) {
    var v = o.onShellError;
    v(u), v = o.onFatalError, v(u), o.destination !== null ? (o.status = 2, o.destination.destroy(u)) : (o.status = 1, o.fatalError = u);
  }
  function X(o, u, v, x, R) {
    for (Qe = {}, It = u, Pe = 0, o = v(x, R); Xt; ) Xt = !1, Pe = 0, Gt += 1, ge = null, o = v(x, R);
    return Jt(), o;
  }
  function Ce(o, u, v, x) {
    var R = v.render(), T = x.childContextTypes;
    if (T != null) {
      var P = u.legacyContext;
      if (typeof v.getChildContext != "function") x = P;
      else {
        v = v.getChildContext();
        for (var H in v) if (!(H in T)) throw Error(t(108, Ge(x) || "Unknown", H));
        x = we({}, P, v);
      }
      u.legacyContext = x, Te(o, u, R), u.legacyContext = P;
    } else Te(o, u, R);
  }
  function We(o, u) {
    if (o && o.defaultProps) {
      u = we({}, u), o = o.defaultProps;
      for (var v in o) u[v] === void 0 && (u[v] = o[v]);
      return u;
    }
    return u;
  }
  function ze(o, u, v, x, R) {
    if (typeof v == "function") if (v.prototype && v.prototype.isReactComponent) {
      R = yt(v, u.legacyContext);
      var T = v.contextType;
      T = new v(x, typeof T == "object" && T !== null ? T._currentValue2 : R), qt(T, v, x, R), Ce(o, u, T, v);
    } else {
      T = yt(v, u.legacyContext), R = X(o, u, v, x, T);
      var P = Pe !== 0;
      if (typeof R == "object" && R !== null && typeof R.render == "function" && R.$$typeof === void 0) qt(R, v, x, T), Ce(o, u, R, v);
      else if (P) {
        x = u.treeContext, u.treeContext = Nt(x, 1, 0);
        try {
          Te(o, u, R);
        } finally {
          u.treeContext = x;
        }
      } else Te(o, u, R);
    }
    else if (typeof v == "string") {
      switch (R = u.blockedSegment, T = Q(R.chunks, v, x, o.responseState, R.formatContext), R.lastPushedText = !1, P = R.formatContext, R.formatContext = V(P, v, x), kt(o, u, T), R.formatContext = P, v) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          R.chunks.push("</", v, ">");
      }
      R.lastPushedText = !1;
    } else {
      switch (v) {
        case Ae:
        case ae:
        case U:
        case A:
        case q:
          Te(o, u, x.children);
          return;
        case ie:
          Te(o, u, x.children);
          return;
        case xe:
          throw Error(t(343));
        case re:
          e: {
            v = u.blockedBoundary, R = u.blockedSegment, T = x.fallback, x = x.children, P = /* @__PURE__ */ new Set();
            var H = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: P, errorDigest: null }, ee = G(o, R.chunks.length, H, R.formatContext, !1, !1);
            R.children.push(ee), R.lastPushedText = !1;
            var ne = G(o, 0, null, R.formatContext, !1, !1);
            ne.parentFlushed = !0, u.blockedBoundary = H, u.blockedSegment = ne;
            try {
              if (kt(
                o,
                u,
                x
              ), o.responseState.generateStaticMarkup || ne.lastPushedText && ne.textEmbedded && ne.chunks.push("<!-- -->"), ne.status = 1, Tt(H, ne), H.pendingTasks === 0) break e;
            } catch (oe) {
              ne.status = 4, H.forceClientRender = !0, H.errorDigest = S(o, oe);
            } finally {
              u.blockedBoundary = v, u.blockedSegment = R;
            }
            u = dn(o, T, v, ee, P, u.legacyContext, u.context, u.treeContext), o.pingedTasks.push(u);
          }
          return;
      }
      if (typeof v == "object" && v !== null) switch (v.$$typeof) {
        case pe:
          if (x = X(o, u, v.render, x, R), Pe !== 0) {
            v = u.treeContext, u.treeContext = Nt(v, 1, 0);
            try {
              Te(o, u, x);
            } finally {
              u.treeContext = v;
            }
          } else Te(o, u, x);
          return;
        case Z:
          v = v.type, x = We(v, x), ze(o, u, v, x, R);
          return;
        case ue:
          if (R = x.children, v = v._context, x = x.value, T = v._currentValue2, v._currentValue2 = x, P = Ke, Ke = x = { parent: P, depth: P === null ? 0 : P.depth + 1, context: v, parentValue: T, value: x }, u.context = x, Te(o, u, R), o = Ke, o === null) throw Error(t(403));
          x = o.parentValue, o.context._currentValue2 = x === le ? o.context._defaultValue : x, o = Ke = o.parent, u.context = o;
          return;
        case z:
          x = x.children, x = x(v._currentValue2), Te(o, u, x);
          return;
        case de:
          R = v._init, v = R(v._payload), x = We(v, x), ze(
            o,
            u,
            v,
            x,
            void 0
          );
          return;
      }
      throw Error(t(130, v == null ? v : typeof v, ""));
    }
  }
  function Te(o, u, v) {
    if (u.node = v, typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case Y:
          ze(o, u, v.type, v.props, v.ref);
          return;
        case B:
          throw Error(t(257));
        case de:
          var x = v._init;
          v = x(v._payload), Te(o, u, v);
          return;
      }
      if (j(v)) {
        st(o, u, v);
        return;
      }
      if (v === null || typeof v != "object" ? x = null : (x = Ee && v[Ee] || v["@@iterator"], x = typeof x == "function" ? x : null), x && (x = x.call(v))) {
        if (v = x.next(), !v.done) {
          var R = [];
          do
            R.push(v.value), v = x.next();
          while (!v.done);
          st(o, u, R);
        }
        return;
      }
      throw o = Object.prototype.toString.call(v), Error(t(31, o === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : o));
    }
    typeof v == "string" ? (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, v, o.responseState, x.lastPushedText)) : typeof v == "number" && (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, "" + v, o.responseState, x.lastPushedText));
  }
  function st(o, u, v) {
    for (var x = v.length, R = 0; R < x; R++) {
      var T = u.treeContext;
      u.treeContext = Nt(T, x, R);
      try {
        kt(o, u, v[R]);
      } finally {
        u.treeContext = T;
      }
    }
  }
  function kt(o, u, v) {
    var x = u.blockedSegment.formatContext, R = u.legacyContext, T = u.context;
    try {
      return Te(o, u, v);
    } catch (ee) {
      if (Jt(), typeof ee == "object" && ee !== null && typeof ee.then == "function") {
        v = ee;
        var P = u.blockedSegment, H = G(o, P.chunks.length, null, P.formatContext, P.lastPushedText, !0);
        P.children.push(H), P.lastPushedText = !1, o = dn(o, u.node, u.blockedBoundary, H, u.abortSet, u.legacyContext, u.context, u.treeContext).ping, v.then(o, o), u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Ze(T);
      } else throw u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Ze(T), ee;
    }
  }
  function Ue(o) {
    var u = o.blockedBoundary;
    o = o.blockedSegment, o.status = 3, en(this, u, o);
  }
  function fn(o, u, v) {
    var x = o.blockedBoundary;
    o.blockedSegment.status = 3, x === null ? (u.allPendingTasks--, u.status !== 2 && (u.status = 2, u.destination !== null && u.destination.push(null))) : (x.pendingTasks--, x.forceClientRender || (x.forceClientRender = !0, o = v === void 0 ? Error(t(432)) : v, x.errorDigest = u.onError(o), x.parentFlushed && u.clientRenderedBoundaries.push(x)), x.fallbackAbortableTasks.forEach(function(R) {
      return fn(R, u, v);
    }), x.fallbackAbortableTasks.clear(), u.allPendingTasks--, u.allPendingTasks === 0 && (x = u.onAllReady, x()));
  }
  function Tt(o, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null) {
      var v = u.children[0];
      v.id = u.id, v.parentFlushed = !0, v.status === 1 && Tt(o, v);
    } else o.completedSegments.push(u);
  }
  function en(o, u, v) {
    if (u === null) {
      if (v.parentFlushed) {
        if (o.completedRootSegment !== null) throw Error(t(389));
        o.completedRootSegment = v;
      }
      o.pendingRootTasks--, o.pendingRootTasks === 0 && (o.onShellError = Mt, u = o.onShellReady, u());
    } else u.pendingTasks--, u.forceClientRender || (u.pendingTasks === 0 ? (v.parentFlushed && v.status === 1 && Tt(u, v), u.parentFlushed && o.completedBoundaries.push(u), u.fallbackAbortableTasks.forEach(Ue, o), u.fallbackAbortableTasks.clear()) : v.parentFlushed && v.status === 1 && (Tt(u, v), u.completedSegments.length === 1 && u.parentFlushed && o.partialBoundaries.push(u)));
    o.allPendingTasks--, o.allPendingTasks === 0 && (o = o.onAllReady, o());
  }
  function sr(o) {
    if (o.status !== 2) {
      var u = Ke, v = Qt.current;
      Qt.current = un;
      var x = nt;
      nt = o.responseState;
      try {
        var R = o.pingedTasks, T;
        for (T = 0; T < R.length; T++) {
          var P = R[T], H = o, ee = P.blockedSegment;
          if (ee.status === 0) {
            Ze(P.context);
            try {
              Te(H, P, P.node), H.responseState.generateStaticMarkup || ee.lastPushedText && ee.textEmbedded && ee.chunks.push("<!-- -->"), P.abortSet.delete(P), ee.status = 1, en(H, P.blockedBoundary, ee);
            } catch (ht) {
              if (Jt(), typeof ht == "object" && ht !== null && typeof ht.then == "function") {
                var ne = P.ping;
                ht.then(ne, ne);
              } else {
                P.abortSet.delete(P), ee.status = 4;
                var oe = P.blockedBoundary, Me = ht, _t = S(H, Me);
                if (oe === null ? F(H, Me) : (oe.pendingTasks--, oe.forceClientRender || (oe.forceClientRender = !0, oe.errorDigest = _t, oe.parentFlushed && H.clientRenderedBoundaries.push(oe))), H.allPendingTasks--, H.allPendingTasks === 0) {
                  var Et = H.onAllReady;
                  Et();
                }
              }
            } finally {
            }
          }
        }
        R.splice(0, T), o.destination !== null && An(o, o.destination);
      } catch (ht) {
        S(o, ht), F(o, ht);
      } finally {
        nt = x, Qt.current = v, v === un && Ze(u);
      }
    }
  }
  function pn(o, u, v) {
    switch (v.parentFlushed = !0, v.status) {
      case 0:
        var x = v.id = o.nextSegmentId++;
        return v.lastPushedText = !1, v.textEmbedded = !1, o = o.responseState, u.push('<template id="'), u.push(o.placeholderPrefix), o = x.toString(16), u.push(o), u.push('"></template>');
      case 1:
        v.status = 2;
        var R = !0;
        x = v.chunks;
        var T = 0;
        v = v.children;
        for (var P = 0; P < v.length; P++) {
          for (R = v[P]; T < R.index; T++) u.push(x[T]);
          R = hn(o, u, R);
        }
        for (; T < x.length - 1; T++) u.push(x[T]);
        return T < x.length && (R = u.push(x[T])), R;
      default:
        throw Error(t(390));
    }
  }
  function hn(o, u, v) {
    var x = v.boundary;
    if (x === null) return pn(o, u, v);
    if (x.parentFlushed = !0, x.forceClientRender) return o.responseState.generateStaticMarkup || (x = x.errorDigest, u.push("<!--$!-->"), u.push("<template"), x && (u.push(' data-dgst="'), x = O(x), u.push(x), u.push('"')), u.push("></template>")), pn(o, u, v), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
    if (0 < x.pendingTasks) {
      x.rootSegmentID = o.nextSegmentId++, 0 < x.completedSegments.length && o.partialBoundaries.push(x);
      var R = o.responseState, T = R.nextSuspenseID++;
      return R = R.boundaryPrefix + T.toString(16), x = x.id = R, he(u, o.responseState, x), pn(o, u, v), u.push("<!--/$-->");
    }
    if (x.byteSize > o.progressiveChunkSize) return x.rootSegmentID = o.nextSegmentId++, o.completedBoundaries.push(x), he(u, o.responseState, x.id), pn(o, u, v), u.push("<!--/$-->");
    if (o.responseState.generateStaticMarkup || u.push("<!--$-->"), v = x.completedSegments, v.length !== 1) throw Error(t(391));
    return hn(o, u, v[0]), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
  }
  function $n(o, u, v) {
    return Ne(u, o.responseState, v.formatContext, v.id), hn(o, u, v), dt(u, v.formatContext);
  }
  function Bn(o, u, v) {
    for (var x = v.completedSegments, R = 0; R < x.length; R++) zn(o, u, v, x[R]);
    if (x.length = 0, o = o.responseState, x = v.id, v = v.rootSegmentID, u.push(o.startInlineScript), o.sentCompleteBoundaryFunction ? u.push('$RC("') : (o.sentCompleteBoundaryFunction = !0, u.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), x === null) throw Error(t(395));
    return v = v.toString(16), u.push(x), u.push('","'), u.push(o.segmentPrefix), u.push(v), u.push('")<\/script>');
  }
  function zn(o, u, v, x) {
    if (x.status === 2) return !0;
    var R = x.id;
    if (R === -1) {
      if ((x.id = v.rootSegmentID) === -1) throw Error(t(392));
      return $n(o, u, x);
    }
    return $n(o, u, x), o = o.responseState, u.push(o.startInlineScript), o.sentCompleteSegmentFunction ? u.push('$RS("') : (o.sentCompleteSegmentFunction = !0, u.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), u.push(o.segmentPrefix), R = R.toString(16), u.push(R), u.push('","'), u.push(o.placeholderPrefix), u.push(R), u.push('")<\/script>');
  }
  function An(o, u) {
    try {
      var v = o.completedRootSegment;
      if (v !== null && o.pendingRootTasks === 0) {
        hn(o, u, v), o.completedRootSegment = null;
        var x = o.responseState.bootstrapChunks;
        for (v = 0; v < x.length - 1; v++) u.push(x[v]);
        v < x.length && u.push(x[v]);
      }
      var R = o.clientRenderedBoundaries, T;
      for (T = 0; T < R.length; T++) {
        var P = R[T];
        x = u;
        var H = o.responseState, ee = P.id, ne = P.errorDigest, oe = P.errorMessage, Me = P.errorComponentStack;
        if (x.push(H.startInlineScript), H.sentClientRenderFunction ? x.push('$RX("') : (H.sentClientRenderFunction = !0, x.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), ee === null) throw Error(t(395));
        if (x.push(ee), x.push('"'), ne || oe || Me) {
          x.push(",");
          var _t = Be(ne || "");
          x.push(_t);
        }
        if (oe || Me) {
          x.push(",");
          var Et = Be(oe || "");
          x.push(Et);
        }
        if (Me) {
          x.push(",");
          var ht = Be(Me);
          x.push(ht);
        }
        if (!x.push(")<\/script>")) {
          o.destination = null, T++, R.splice(0, T);
          return;
        }
      }
      R.splice(0, T);
      var mn = o.completedBoundaries;
      for (T = 0; T < mn.length; T++) if (!Bn(o, u, mn[T])) {
        o.destination = null, T++, mn.splice(0, T);
        return;
      }
      mn.splice(0, T);
      var Bt = o.partialBoundaries;
      for (T = 0; T < Bt.length; T++) {
        var Vn = Bt[T];
        e: {
          R = o, P = u;
          var gn = Vn.completedSegments;
          for (H = 0; H < gn.length; H++) if (!zn(R, P, Vn, gn[H])) {
            H++, gn.splice(0, H);
            var cr = !1;
            break e;
          }
          gn.splice(0, H), cr = !0;
        }
        if (!cr) {
          o.destination = null, T++, Bt.splice(0, T);
          return;
        }
      }
      Bt.splice(0, T);
      var tn = o.completedBoundaries;
      for (T = 0; T < tn.length; T++) if (!Bn(o, u, tn[T])) {
        o.destination = null, T++, tn.splice(0, T);
        return;
      }
      tn.splice(0, T);
    } finally {
      o.allPendingTasks === 0 && o.pingedTasks.length === 0 && o.clientRenderedBoundaries.length === 0 && o.completedBoundaries.length === 0 && u.push(null);
    }
  }
  function ar(o, u) {
    try {
      var v = o.abortableTasks;
      v.forEach(function(x) {
        return fn(x, o, u);
      }), v.clear(), o.destination !== null && An(o, o.destination);
    } catch (x) {
      S(o, x), F(o, x);
    }
  }
  function lr() {
  }
  function Hn(o, u, v, x) {
    var R = !1, T = null, P = "", H = { push: function(ne) {
      return ne !== null && (P += ne), !0;
    }, destroy: function(ne) {
      R = !0, T = ne;
    } }, ee = !1;
    if (o = On(o, Ye(v, u ? u.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, lr, void 0, function() {
      ee = !0;
    }), sr(o), ar(o, x), o.status === 1) o.status = 2, H.destroy(o.fatalError);
    else if (o.status !== 2 && o.destination === null) {
      o.destination = H;
      try {
        An(o, H);
      } catch (ne) {
        S(o, ne), F(o, ne);
      }
    }
    if (R) throw T;
    if (!ee) throw Error(t(426));
    return P;
  }
  return yn.renderToNodeStream = function() {
    throw Error(t(207));
  }, yn.renderToStaticMarkup = function(o, u) {
    return Hn(o, u, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, yn.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, yn.renderToString = function(o, u) {
    return Hn(o, u, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, yn.version = "18.3.1", yn;
}
var _r = {};
var Fo;
function gl() {
  if (Fo) return _r;
  Fo = 1;
  var e = He;
  function t(s) {
    for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + s, g = 1; g < arguments.length; g++) c += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + s + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = null, r = 0;
  function i(s, c) {
    if (c.length !== 0) if (512 < c.length) 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = new Uint8Array(512), r = 0), s.enqueue(c);
    else {
      var g = n.length - r;
      g < c.length && (g === 0 ? s.enqueue(n) : (n.set(c.subarray(0, g), r), s.enqueue(n), c = c.subarray(g)), n = new Uint8Array(512), r = 0), n.set(c, r), r += c.length;
    }
  }
  function a(s, c) {
    return i(s, c), !0;
  }
  function d(s) {
    n && 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = null, r = 0);
  }
  var h = new TextEncoder();
  function m(s) {
    return h.encode(s);
  }
  function p(s) {
    return h.encode(s);
  }
  function b(s, c) {
    typeof s.error == "function" ? s.error(c) : s.close();
  }
  var w = Object.prototype.hasOwnProperty, E = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, I = {}, O = {};
  function k(s) {
    return w.call(O, s) ? !0 : w.call(I, s) ? !1 : E.test(s) ? O[s] = !0 : (I[s] = !0, !1);
  }
  function N(s, c, g, y, C, _, L) {
    this.acceptsBooleans = c === 2 || c === 3 || c === 4, this.attributeName = y, this.attributeNamespace = C, this.mustUseProperty = g, this.propertyName = s, this.type = c, this.sanitizeURL = _, this.removeEmptyString = L;
  }
  var j = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(s) {
    j[s] = new N(s, 0, !1, s, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
    var c = s[0];
    j[c] = new N(c, 1, !1, s[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(s) {
    j[s] = new N(s, 3, !1, s.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(s) {
    j[s] = new N(s, 3, !0, s, null, !1, !1);
  }), ["capture", "download"].forEach(function(s) {
    j[s] = new N(s, 4, !1, s, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(s) {
    j[s] = new N(s, 6, !1, s, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(s) {
    j[s] = new N(s, 5, !1, s.toLowerCase(), null, !1, !1);
  });
  var D = /[\-:]([a-z])/g;
  function V(s) {
    return s[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(s) {
    var c = s.replace(
      D,
      V
    );
    j[c] = new N(c, 1, !1, s, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !1, !1);
  }), j.xlinkHref = new N("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !0, !0);
  });
  var W = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, M = ["Webkit", "ms", "Moz", "O"];
  Object.keys(W).forEach(function(s) {
    M.forEach(function(c) {
      c = c + s.charAt(0).toUpperCase() + s.substring(1), W[c] = W[s];
    });
  });
  var J = /["'&<>]/;
  function se(s) {
    if (typeof s == "boolean" || typeof s == "number") return "" + s;
    s = "" + s;
    var c = J.exec(s);
    if (c) {
      var g = "", y, C = 0;
      for (y = c.index; y < s.length; y++) {
        switch (s.charCodeAt(y)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        C !== y && (g += s.substring(C, y)), C = y + 1, g += c;
      }
      s = C !== y ? g + s.substring(C, y) : g;
    }
    return s;
  }
  var Oe = /([A-Z])/g, Fe = /^ms-/, Ve = Array.isArray, ke = p("<script>"), ye = p("<\/script>"), Q = p('<script src="'), he = p('<script type="module" src="'), Ne = p('" async=""><\/script>'), dt = /(<\/|<)(s)(cript)/gi;
  function $e(s, c, g, y) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + y;
  }
  function Be(s, c, g, y, C) {
    s = s === void 0 ? "" : s, c = c === void 0 ? ke : p('<script nonce="' + se(c) + '">');
    var _ = [];
    if (g !== void 0 && _.push(c, m(("" + g).replace(dt, $e)), ye), y !== void 0) for (g = 0; g < y.length; g++) _.push(Q, m(se(y[g])), Ne);
    if (C !== void 0) for (y = 0; y < C.length; y++) _.push(he, m(se(C[y])), Ne);
    return { bootstrapChunks: _, startInlineScript: c, placeholderPrefix: p(s + "P:"), segmentPrefix: p(s + "S:"), boundaryPrefix: s + "B:", idPrefix: s, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Ye(s, c) {
    return { insertionMode: s, selectedValue: c };
  }
  function ft(s) {
    return Ye(s === "http://www.w3.org/2000/svg" ? 2 : s === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function we(s, c, g) {
    switch (c) {
      case "select":
        return Ye(1, g.value != null ? g.value : g.defaultValue);
      case "svg":
        return Ye(2, null);
      case "math":
        return Ye(3, null);
      case "foreignObject":
        return Ye(1, null);
      case "table":
        return Ye(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ye(5, null);
      case "colgroup":
        return Ye(7, null);
      case "tr":
        return Ye(6, null);
    }
    return 4 <= s.insertionMode || s.insertionMode === 0 ? Ye(1, null) : s;
  }
  var Y = p("<!-- -->");
  function B(s, c, g, y) {
    return c === "" ? y : (y && s.push(Y), s.push(m(se(c))), !0);
  }
  var q = /* @__PURE__ */ new Map(), U = p(' style="'), A = p(":"), ue = p(";");
  function z(s, c, g) {
    if (typeof g != "object") throw Error(t(62));
    c = !0;
    for (var y in g) if (w.call(g, y)) {
      var C = g[y];
      if (C != null && typeof C != "boolean" && C !== "") {
        if (y.indexOf("--") === 0) {
          var _ = m(se(y));
          C = m(se(("" + C).trim()));
        } else {
          _ = y;
          var L = q.get(_);
          L !== void 0 || (L = p(se(_.replace(Oe, "-$1").toLowerCase().replace(Fe, "-ms-"))), q.set(_, L)), _ = L, C = typeof C == "number" ? C === 0 || w.call(W, y) ? m("" + C) : m(C + "px") : m(se(("" + C).trim()));
        }
        c ? (c = !1, s.push(U, _, A, C)) : s.push(ue, _, A, C);
      }
    }
    c || s.push(ie);
  }
  var pe = p(" "), re = p('="'), ie = p('"'), Z = p('=""');
  function de(s, c, g, y) {
    switch (g) {
      case "style":
        z(s, c, y);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < g.length) || g[0] !== "o" && g[0] !== "O" || g[1] !== "n" && g[1] !== "N") {
      if (c = j.hasOwnProperty(g) ? j[g] : null, c !== null) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!c.acceptsBooleans) return;
        }
        switch (g = m(c.attributeName), c.type) {
          case 3:
            y && s.push(pe, g, Z);
            break;
          case 4:
            y === !0 ? s.push(pe, g, Z) : y !== !1 && s.push(pe, g, re, m(se(y)), ie);
            break;
          case 5:
            isNaN(y) || s.push(pe, g, re, m(se(y)), ie);
            break;
          case 6:
            !isNaN(y) && 1 <= y && s.push(pe, g, re, m(se(y)), ie);
            break;
          default:
            c.sanitizeURL && (y = "" + y), s.push(pe, g, re, m(se(y)), ie);
        }
      } else if (k(g)) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (c = g.toLowerCase().slice(0, 5), c !== "data-" && c !== "aria-") return;
        }
        s.push(pe, m(g), re, m(se(y)), ie);
      }
    }
  }
  var xe = p(">"), ae = p("/>");
  function Ae(s, c, g) {
    if (c != null) {
      if (g != null) throw Error(t(60));
      if (typeof c != "object" || !("__html" in c)) throw Error(t(61));
      c = c.__html, c != null && s.push(m("" + c));
    }
  }
  function le(s) {
    var c = "";
    return e.Children.forEach(s, function(g) {
      g != null && (c += g);
    }), c;
  }
  var Ee = p(' selected=""');
  function Ge(s, c, g, y) {
    s.push(Se(g));
    var C = g = null, _;
    for (_ in c) if (w.call(c, _)) {
      var L = c[_];
      if (L != null) switch (_) {
        case "children":
          g = L;
          break;
        case "dangerouslySetInnerHTML":
          C = L;
          break;
        default:
          de(s, y, _, L);
      }
    }
    return s.push(xe), Ae(s, C, g), typeof g == "string" ? (s.push(m(se(g))), null) : g;
  }
  var je = p(`
`), yt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ke = /* @__PURE__ */ new Map();
  function Se(s) {
    var c = Ke.get(s);
    if (c === void 0) {
      if (!yt.test(s)) throw Error(t(65, s));
      c = p("<" + s), Ke.set(s, c);
    }
    return c;
  }
  var K = p("<!DOCTYPE html>");
  function be(s, c, g, y, C) {
    switch (c) {
      case "select":
        s.push(Se("select"));
        var _ = null, L = null;
        for (ce in g) if (w.call(g, ce)) {
          var $ = g[ce];
          if ($ != null) switch (ce) {
            case "children":
              _ = $;
              break;
            case "dangerouslySetInnerHTML":
              L = $;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              de(s, y, ce, $);
          }
        }
        return s.push(xe), Ae(s, L, _), _;
      case "option":
        L = C.selectedValue, s.push(Se("option"));
        var te = $ = null, fe = null, ce = null;
        for (_ in g) if (w.call(g, _)) {
          var Le = g[_];
          if (Le != null) switch (_) {
            case "children":
              $ = Le;
              break;
            case "selected":
              fe = Le;
              break;
            case "dangerouslySetInnerHTML":
              ce = Le;
              break;
            case "value":
              te = Le;
            default:
              de(s, y, _, Le);
          }
        }
        if (L != null) if (g = te !== null ? "" + te : le($), Ve(L)) {
          for (y = 0; y < L.length; y++)
            if ("" + L[y] === g) {
              s.push(Ee);
              break;
            }
        } else "" + L === g && s.push(Ee);
        else fe && s.push(Ee);
        return s.push(xe), Ae(s, ce, $), $;
      case "textarea":
        s.push(Se("textarea")), ce = L = _ = null;
        for ($ in g) if (w.call(g, $) && (te = g[$], te != null)) switch ($) {
          case "children":
            ce = te;
            break;
          case "value":
            _ = te;
            break;
          case "defaultValue":
            L = te;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            de(s, y, $, te);
        }
        if (_ === null && L !== null && (_ = L), s.push(xe), ce != null) {
          if (_ != null) throw Error(t(92));
          if (Ve(ce) && 1 < ce.length) throw Error(t(93));
          _ = "" + ce;
        }
        return typeof _ == "string" && _[0] === `
` && s.push(je), _ !== null && s.push(m(se("" + _))), null;
      case "input":
        s.push(Se("input")), te = ce = $ = _ = null;
        for (L in g) if (w.call(g, L) && (fe = g[L], fe != null)) switch (L) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            te = fe;
            break;
          case "defaultValue":
            $ = fe;
            break;
          case "checked":
            ce = fe;
            break;
          case "value":
            _ = fe;
            break;
          default:
            de(s, y, L, fe);
        }
        return ce !== null ? de(
          s,
          y,
          "checked",
          ce
        ) : te !== null && de(s, y, "checked", te), _ !== null ? de(s, y, "value", _) : $ !== null && de(s, y, "value", $), s.push(ae), null;
      case "menuitem":
        s.push(Se("menuitem"));
        for (var gt in g) if (w.call(g, gt) && (_ = g[gt], _ != null)) switch (gt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            de(s, y, gt, _);
        }
        return s.push(xe), null;
      case "title":
        s.push(Se("title")), _ = null;
        for (Le in g) if (w.call(g, Le) && (L = g[Le], L != null)) switch (Le) {
          case "children":
            _ = L;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            de(s, y, Le, L);
        }
        return s.push(xe), _;
      case "listing":
      case "pre":
        s.push(Se(c)), L = _ = null;
        for (te in g) if (w.call(g, te) && ($ = g[te], $ != null)) switch (te) {
          case "children":
            _ = $;
            break;
          case "dangerouslySetInnerHTML":
            L = $;
            break;
          default:
            de(s, y, te, $);
        }
        if (s.push(xe), L != null) {
          if (_ != null) throw Error(t(60));
          if (typeof L != "object" || !("__html" in L)) throw Error(t(61));
          g = L.__html, g != null && (typeof g == "string" && 0 < g.length && g[0] === `
` ? s.push(je, m(g)) : s.push(m("" + g)));
        }
        return typeof _ == "string" && _[0] === `
` && s.push(je), _;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        s.push(Se(c));
        for (var Ct in g) if (w.call(g, Ct) && (_ = g[Ct], _ != null)) switch (Ct) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, c));
          default:
            de(s, y, Ct, _);
        }
        return s.push(ae), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Ge(s, g, c, y);
      case "html":
        return C.insertionMode === 0 && s.push(K), Ge(s, g, c, y);
      default:
        if (c.indexOf("-") === -1 && typeof g.is != "string") return Ge(s, g, c, y);
        s.push(Se(c)), L = _ = null;
        for (fe in g) if (w.call(g, fe) && ($ = g[fe], $ != null)) switch (fe) {
          case "children":
            _ = $;
            break;
          case "dangerouslySetInnerHTML":
            L = $;
            break;
          case "style":
            z(s, y, $);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            k(fe) && typeof $ != "function" && typeof $ != "symbol" && s.push(pe, m(fe), re, m(se($)), ie);
        }
        return s.push(xe), Ae(s, L, _), _;
    }
  }
  var it = p("</"), wt = p(">"), Ze = p('<template id="'), an = p('"></template>'), qt = p("<!--$-->"), Tn = p('<!--$?--><template id="'), Nt = p('"></template>'), St = p("<!--$!-->"), pt = p("<!--/$-->"), Pt = p("<template"), ln = p('"'), cn = p(' data-dgst="');
  p(' data-msg="'), p(' data-stck="');
  var Fn = p("></template>");
  function Qe(s, c, g) {
    if (i(s, Tn), g === null) throw Error(t(395));
    return i(s, g), a(s, Nt);
  }
  var It = p('<div hidden id="'), Yt = p('">'), ge = p("</div>"), Ft = p('<svg aria-hidden="true" style="display:none" id="'), Xt = p('">'), Pe = p("</svg>"), et = p('<math aria-hidden="true" style="display:none" id="'), Gt = p('">'), xt = p("</math>"), Kt = p('<table hidden id="'), Zt = p('">'), Jt = p("</table>"), _n = p('<table hidden><tbody id="'), ot = p('">'), $t = p("</tbody></table>"), En = p('<table hidden><tr id="'), Cn = p('">'), Lt = p("</tr></table>"), un = p('<table hidden><colgroup id="'), nt = p('">'), Qt = p("</colgroup></table>");
  function Rn(s, c, g, y) {
    switch (g.insertionMode) {
      case 0:
      case 1:
        return i(s, It), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Yt);
      case 2:
        return i(s, Ft), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Xt);
      case 3:
        return i(s, et), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Gt);
      case 4:
        return i(s, Kt), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Zt);
      case 5:
        return i(s, _n), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, ot);
      case 6:
        return i(s, En), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Cn);
      case 7:
        return i(
          s,
          un
        ), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, nt);
      default:
        throw Error(t(397));
    }
  }
  function Mt(s, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
        return a(s, ge);
      case 2:
        return a(s, Pe);
      case 3:
        return a(s, xt);
      case 4:
        return a(s, Jt);
      case 5:
        return a(s, $t);
      case 6:
        return a(s, Lt);
      case 7:
        return a(s, Qt);
      default:
        throw Error(t(397));
    }
  }
  var On = p('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), dn = p('$RS("'), G = p('","'), S = p('")<\/script>'), F = p('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), X = p('$RC("'), Ce = p('","'), We = p('")<\/script>'), ze = p('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Te = p('$RX("'), st = p('"'), kt = p(")<\/script>"), Ue = p(","), fn = /[<\u2028\u2029]/g;
  function Tt(s) {
    return JSON.stringify(s).replace(fn, function(c) {
      switch (c) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var en = Object.assign, sr = Symbol.for("react.element"), pn = Symbol.for("react.portal"), hn = Symbol.for("react.fragment"), $n = Symbol.for("react.strict_mode"), Bn = Symbol.for("react.profiler"), zn = Symbol.for("react.provider"), An = Symbol.for("react.context"), ar = Symbol.for("react.forward_ref"), lr = Symbol.for("react.suspense"), Hn = Symbol.for("react.suspense_list"), o = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), v = Symbol.for("react.scope"), x = Symbol.for("react.debug_trace_mode"), R = Symbol.for("react.legacy_hidden"), T = Symbol.for("react.default_value"), P = Symbol.iterator;
  function H(s) {
    if (s == null) return null;
    if (typeof s == "function") return s.displayName || s.name || null;
    if (typeof s == "string") return s;
    switch (s) {
      case hn:
        return "Fragment";
      case pn:
        return "Portal";
      case Bn:
        return "Profiler";
      case $n:
        return "StrictMode";
      case lr:
        return "Suspense";
      case Hn:
        return "SuspenseList";
    }
    if (typeof s == "object") switch (s.$$typeof) {
      case An:
        return (s.displayName || "Context") + ".Consumer";
      case zn:
        return (s._context.displayName || "Context") + ".Provider";
      case ar:
        var c = s.render;
        return s = s.displayName, s || (s = c.displayName || c.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
      case o:
        return c = s.displayName || null, c !== null ? c : H(s.type) || "Memo";
      case u:
        c = s._payload, s = s._init;
        try {
          return H(s(c));
        } catch {
        }
    }
    return null;
  }
  var ee = {};
  function ne(s, c) {
    if (s = s.contextTypes, !s) return ee;
    var g = {}, y;
    for (y in s) g[y] = c[y];
    return g;
  }
  var oe = null;
  function Me(s, c) {
    if (s !== c) {
      s.context._currentValue = s.parentValue, s = s.parent;
      var g = c.parent;
      if (s === null) {
        if (g !== null) throw Error(t(401));
      } else {
        if (g === null) throw Error(t(401));
        Me(s, g);
      }
      c.context._currentValue = c.value;
    }
  }
  function _t(s) {
    s.context._currentValue = s.parentValue, s = s.parent, s !== null && _t(s);
  }
  function Et(s) {
    var c = s.parent;
    c !== null && Et(c), s.context._currentValue = s.value;
  }
  function ht(s, c) {
    if (s.context._currentValue = s.parentValue, s = s.parent, s === null) throw Error(t(402));
    s.depth === c.depth ? Me(s, c) : ht(s, c);
  }
  function mn(s, c) {
    var g = c.parent;
    if (g === null) throw Error(t(402));
    s.depth === g.depth ? Me(s, g) : mn(s, g), c.context._currentValue = c.value;
  }
  function Bt(s) {
    var c = oe;
    c !== s && (c === null ? Et(s) : s === null ? _t(c) : c.depth === s.depth ? Me(c, s) : c.depth > s.depth ? ht(c, s) : mn(c, s), oe = s);
  }
  var Vn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(s, c) {
    s = s._reactInternals, s.queue !== null && s.queue.push(c);
  }, enqueueReplaceState: function(s, c) {
    s = s._reactInternals, s.replace = !0, s.queue = [c];
  }, enqueueForceUpdate: function() {
  } };
  function gn(s, c, g, y) {
    var C = s.state !== void 0 ? s.state : null;
    s.updater = Vn, s.props = g, s.state = C;
    var _ = { queue: [], replace: !1 };
    s._reactInternals = _;
    var L = c.contextType;
    if (s.context = typeof L == "object" && L !== null ? L._currentValue : y, L = c.getDerivedStateFromProps, typeof L == "function" && (L = L(g, C), C = L == null ? C : en({}, C, L), s.state = C), typeof c.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function")) if (c = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), c !== s.state && Vn.enqueueReplaceState(s, s.state, null), _.queue !== null && 0 < _.queue.length) if (c = _.queue, L = _.replace, _.queue = null, _.replace = !1, L && c.length === 1) s.state = c[0];
    else {
      for (_ = L ? c[0] : s.state, C = !0, L = L ? 1 : 0; L < c.length; L++) {
        var $ = c[L];
        $ = typeof $ == "function" ? $.call(s, _, g, y) : $, $ != null && (C ? (C = !1, _ = en({}, _, $)) : en(_, $));
      }
      s.state = _;
    }
    else _.queue = null;
  }
  var cr = { id: 1, overflow: "" };
  function tn(s, c, g) {
    var y = s.id;
    s = s.overflow;
    var C = 32 - ur(y) - 1;
    y &= ~(1 << C), g += 1;
    var _ = 32 - ur(c) + C;
    if (30 < _) {
      var L = C - C % 5;
      return _ = (y & (1 << L) - 1).toString(32), y >>= L, C -= L, { id: 1 << 32 - ur(c) + C | g << C | y, overflow: _ + s };
    }
    return { id: 1 << _ | g << C | y, overflow: s };
  }
  var ur = Math.clz32 ? Math.clz32 : Ta, Sa = Math.log, ka = Math.LN2;
  function Ta(s) {
    return s >>>= 0, s === 0 ? 32 : 31 - (Sa(s) / ka | 0) | 0;
  }
  function _a(s, c) {
    return s === c && (s !== 0 || 1 / s === 1 / c) || s !== s && c !== c;
  }
  var Ea = typeof Object.is == "function" ? Object.is : _a, zt = null, Kr = null, dr = null, Ie = null, Wn = !1, fr = !1, Un = 0, nn = null, pr = 0;
  function vn() {
    if (zt === null) throw Error(t(321));
    return zt;
  }
  function ro() {
    if (0 < pr) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Zr() {
    return Ie === null ? dr === null ? (Wn = !1, dr = Ie = ro()) : (Wn = !0, Ie = dr) : Ie.next === null ? (Wn = !1, Ie = Ie.next = ro()) : (Wn = !0, Ie = Ie.next), Ie;
  }
  function Jr() {
    Kr = zt = null, fr = !1, dr = null, pr = 0, Ie = nn = null;
  }
  function io(s, c) {
    return typeof c == "function" ? c(s) : c;
  }
  function oo(s, c, g) {
    if (zt = vn(), Ie = Zr(), Wn) {
      var y = Ie.queue;
      if (c = y.dispatch, nn !== null && (g = nn.get(y), g !== void 0)) {
        nn.delete(y), y = Ie.memoizedState;
        do
          y = s(y, g.action), g = g.next;
        while (g !== null);
        return Ie.memoizedState = y, [y, c];
      }
      return [Ie.memoizedState, c];
    }
    return s = s === io ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, Ie.memoizedState = s, s = Ie.queue = { last: null, dispatch: null }, s = s.dispatch = Ca.bind(null, zt, s), [Ie.memoizedState, s];
  }
  function so(s, c) {
    if (zt = vn(), Ie = Zr(), c = c === void 0 ? null : c, Ie !== null) {
      var g = Ie.memoizedState;
      if (g !== null && c !== null) {
        var y = g[1];
        e: if (y === null) y = !1;
        else {
          for (var C = 0; C < y.length && C < c.length; C++) if (!Ea(c[C], y[C])) {
            y = !1;
            break e;
          }
          y = !0;
        }
        if (y) return g[0];
      }
    }
    return s = s(), Ie.memoizedState = [s, c], s;
  }
  function Ca(s, c, g) {
    if (25 <= pr) throw Error(t(301));
    if (s === zt) if (fr = !0, s = { action: g, next: null }, nn === null && (nn = /* @__PURE__ */ new Map()), g = nn.get(c), g === void 0) nn.set(c, s);
    else {
      for (c = g; c.next !== null; ) c = c.next;
      c.next = s;
    }
  }
  function Ra() {
    throw Error(t(394));
  }
  function hr() {
  }
  var ao = { readContext: function(s) {
    return s._currentValue;
  }, useContext: function(s) {
    return vn(), s._currentValue;
  }, useMemo: so, useReducer: oo, useRef: function(s) {
    zt = vn(), Ie = Zr();
    var c = Ie.memoizedState;
    return c === null ? (s = { current: s }, Ie.memoizedState = s) : c;
  }, useState: function(s) {
    return oo(io, s);
  }, useInsertionEffect: hr, useLayoutEffect: function() {
  }, useCallback: function(s, c) {
    return so(function() {
      return s;
    }, c);
  }, useImperativeHandle: hr, useEffect: hr, useDebugValue: hr, useDeferredValue: function(s) {
    return vn(), s;
  }, useTransition: function() {
    return vn(), [!1, Ra];
  }, useId: function() {
    var s = Kr.treeContext, c = s.overflow;
    s = s.id, s = (s & ~(1 << 32 - ur(s) - 1)).toString(32) + c;
    var g = mr;
    if (g === null) throw Error(t(404));
    return c = Un++, s = ":" + g.idPrefix + "R" + s, 0 < c && (s += "H" + c.toString(32)), s + ":";
  }, useMutableSource: function(s, c) {
    return vn(), c(s._source);
  }, useSyncExternalStore: function(s, c, g) {
    if (g === void 0) throw Error(t(407));
    return g();
  } }, mr = null, Qr = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Oa(s) {
    return console.error(s), null;
  }
  function qn() {
  }
  function Aa(s, c, g, y, C, _, L, $, te) {
    var fe = [], ce = /* @__PURE__ */ new Set();
    return c = { destination: null, responseState: c, progressiveChunkSize: y === void 0 ? 12800 : y, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ce, pingedTasks: fe, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: C === void 0 ? Oa : C, onAllReady: _ === void 0 ? qn : _, onShellReady: L === void 0 ? qn : L, onShellError: $ === void 0 ? qn : $, onFatalError: te === void 0 ? qn : te }, g = gr(c, 0, null, g, !1, !1), g.parentFlushed = !0, s = ei(c, s, null, g, ce, ee, null, cr), fe.push(s), c;
  }
  function ei(s, c, g, y, C, _, L, $) {
    s.allPendingTasks++, g === null ? s.pendingRootTasks++ : g.pendingTasks++;
    var te = { node: c, ping: function() {
      var fe = s.pingedTasks;
      fe.push(te), fe.length === 1 && mo(s);
    }, blockedBoundary: g, blockedSegment: y, abortSet: C, legacyContext: _, context: L, treeContext: $ };
    return C.add(te), te;
  }
  function gr(s, c, g, y, C, _) {
    return { status: 0, id: -1, index: c, parentFlushed: !1, chunks: [], children: [], formatContext: y, boundary: g, lastPushedText: C, textEmbedded: _ };
  }
  function Yn(s, c) {
    if (s = s.onError(c), s != null && typeof s != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof s + '" instead');
    return s;
  }
  function vr(s, c) {
    var g = s.onShellError;
    g(c), g = s.onFatalError, g(c), s.destination !== null ? (s.status = 2, b(s.destination, c)) : (s.status = 1, s.fatalError = c);
  }
  function lo(s, c, g, y, C) {
    for (zt = {}, Kr = c, Un = 0, s = g(y, C); fr; ) fr = !1, Un = 0, pr += 1, Ie = null, s = g(y, C);
    return Jr(), s;
  }
  function co(s, c, g, y) {
    var C = g.render(), _ = y.childContextTypes;
    if (_ != null) {
      var L = c.legacyContext;
      if (typeof g.getChildContext != "function") y = L;
      else {
        g = g.getChildContext();
        for (var $ in g) if (!($ in _)) throw Error(t(108, H(y) || "Unknown", $));
        y = en({}, L, g);
      }
      c.legacyContext = y, mt(s, c, C), c.legacyContext = L;
    } else mt(s, c, C);
  }
  function uo(s, c) {
    if (s && s.defaultProps) {
      c = en({}, c), s = s.defaultProps;
      for (var g in s) c[g] === void 0 && (c[g] = s[g]);
      return c;
    }
    return c;
  }
  function ti(s, c, g, y, C) {
    if (typeof g == "function") if (g.prototype && g.prototype.isReactComponent) {
      C = ne(g, c.legacyContext);
      var _ = g.contextType;
      _ = new g(y, typeof _ == "object" && _ !== null ? _._currentValue : C), gn(_, g, y, C), co(s, c, _, g);
    } else {
      _ = ne(g, c.legacyContext), C = lo(s, c, g, y, _);
      var L = Un !== 0;
      if (typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0) gn(C, g, y, _), co(s, c, C, g);
      else if (L) {
        y = c.treeContext, c.treeContext = tn(y, 1, 0);
        try {
          mt(s, c, C);
        } finally {
          c.treeContext = y;
        }
      } else mt(s, c, C);
    }
    else if (typeof g == "string") {
      switch (C = c.blockedSegment, _ = be(C.chunks, g, y, s.responseState, C.formatContext), C.lastPushedText = !1, L = C.formatContext, C.formatContext = we(L, g, y), ni(s, c, _), C.formatContext = L, g) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          C.chunks.push(it, m(g), wt);
      }
      C.lastPushedText = !1;
    } else {
      switch (g) {
        case R:
        case x:
        case $n:
        case Bn:
        case hn:
          mt(s, c, y.children);
          return;
        case Hn:
          mt(s, c, y.children);
          return;
        case v:
          throw Error(t(343));
        case lr:
          e: {
            g = c.blockedBoundary, C = c.blockedSegment, _ = y.fallback, y = y.children, L = /* @__PURE__ */ new Set();
            var $ = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: L, errorDigest: null }, te = gr(s, C.chunks.length, $, C.formatContext, !1, !1);
            C.children.push(te), C.lastPushedText = !1;
            var fe = gr(s, 0, null, C.formatContext, !1, !1);
            fe.parentFlushed = !0, c.blockedBoundary = $, c.blockedSegment = fe;
            try {
              if (ni(
                s,
                c,
                y
              ), fe.lastPushedText && fe.textEmbedded && fe.chunks.push(Y), fe.status = 1, yr($, fe), $.pendingTasks === 0) break e;
            } catch (ce) {
              fe.status = 4, $.forceClientRender = !0, $.errorDigest = Yn(s, ce);
            } finally {
              c.blockedBoundary = g, c.blockedSegment = C;
            }
            c = ei(s, _, g, te, L, c.legacyContext, c.context, c.treeContext), s.pingedTasks.push(c);
          }
          return;
      }
      if (typeof g == "object" && g !== null) switch (g.$$typeof) {
        case ar:
          if (y = lo(s, c, g.render, y, C), Un !== 0) {
            g = c.treeContext, c.treeContext = tn(g, 1, 0);
            try {
              mt(s, c, y);
            } finally {
              c.treeContext = g;
            }
          } else mt(s, c, y);
          return;
        case o:
          g = g.type, y = uo(g, y), ti(s, c, g, y, C);
          return;
        case zn:
          if (C = y.children, g = g._context, y = y.value, _ = g._currentValue, g._currentValue = y, L = oe, oe = y = { parent: L, depth: L === null ? 0 : L.depth + 1, context: g, parentValue: _, value: y }, c.context = y, mt(s, c, C), s = oe, s === null) throw Error(t(403));
          y = s.parentValue, s.context._currentValue = y === T ? s.context._defaultValue : y, s = oe = s.parent, c.context = s;
          return;
        case An:
          y = y.children, y = y(g._currentValue), mt(s, c, y);
          return;
        case u:
          C = g._init, g = C(g._payload), y = uo(g, y), ti(s, c, g, y, void 0);
          return;
      }
      throw Error(t(
        130,
        g == null ? g : typeof g,
        ""
      ));
    }
  }
  function mt(s, c, g) {
    if (c.node = g, typeof g == "object" && g !== null) {
      switch (g.$$typeof) {
        case sr:
          ti(s, c, g.type, g.props, g.ref);
          return;
        case pn:
          throw Error(t(257));
        case u:
          var y = g._init;
          g = y(g._payload), mt(s, c, g);
          return;
      }
      if (Ve(g)) {
        fo(s, c, g);
        return;
      }
      if (g === null || typeof g != "object" ? y = null : (y = P && g[P] || g["@@iterator"], y = typeof y == "function" ? y : null), y && (y = y.call(g))) {
        if (g = y.next(), !g.done) {
          var C = [];
          do
            C.push(g.value), g = y.next();
          while (!g.done);
          fo(s, c, C);
        }
        return;
      }
      throw s = Object.prototype.toString.call(g), Error(t(31, s === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : s));
    }
    typeof g == "string" ? (y = c.blockedSegment, y.lastPushedText = B(c.blockedSegment.chunks, g, s.responseState, y.lastPushedText)) : typeof g == "number" && (y = c.blockedSegment, y.lastPushedText = B(c.blockedSegment.chunks, "" + g, s.responseState, y.lastPushedText));
  }
  function fo(s, c, g) {
    for (var y = g.length, C = 0; C < y; C++) {
      var _ = c.treeContext;
      c.treeContext = tn(_, y, C);
      try {
        ni(s, c, g[C]);
      } finally {
        c.treeContext = _;
      }
    }
  }
  function ni(s, c, g) {
    var y = c.blockedSegment.formatContext, C = c.legacyContext, _ = c.context;
    try {
      return mt(s, c, g);
    } catch (te) {
      if (Jr(), typeof te == "object" && te !== null && typeof te.then == "function") {
        g = te;
        var L = c.blockedSegment, $ = gr(s, L.chunks.length, null, L.formatContext, L.lastPushedText, !0);
        L.children.push($), L.lastPushedText = !1, s = ei(s, c.node, c.blockedBoundary, $, c.abortSet, c.legacyContext, c.context, c.treeContext).ping, g.then(s, s), c.blockedSegment.formatContext = y, c.legacyContext = C, c.context = _, Bt(_);
      } else throw c.blockedSegment.formatContext = y, c.legacyContext = C, c.context = _, Bt(_), te;
    }
  }
  function ja(s) {
    var c = s.blockedBoundary;
    s = s.blockedSegment, s.status = 3, ho(this, c, s);
  }
  function po(s, c, g) {
    var y = s.blockedBoundary;
    s.blockedSegment.status = 3, y === null ? (c.allPendingTasks--, c.status !== 2 && (c.status = 2, c.destination !== null && c.destination.close())) : (y.pendingTasks--, y.forceClientRender || (y.forceClientRender = !0, s = g === void 0 ? Error(t(432)) : g, y.errorDigest = c.onError(s), y.parentFlushed && c.clientRenderedBoundaries.push(y)), y.fallbackAbortableTasks.forEach(function(C) {
      return po(C, c, g);
    }), y.fallbackAbortableTasks.clear(), c.allPendingTasks--, c.allPendingTasks === 0 && (y = c.onAllReady, y()));
  }
  function yr(s, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status === 1 && yr(s, g);
    } else s.completedSegments.push(c);
  }
  function ho(s, c, g) {
    if (c === null) {
      if (g.parentFlushed) {
        if (s.completedRootSegment !== null) throw Error(t(389));
        s.completedRootSegment = g;
      }
      s.pendingRootTasks--, s.pendingRootTasks === 0 && (s.onShellError = qn, c = s.onShellReady, c());
    } else c.pendingTasks--, c.forceClientRender || (c.pendingTasks === 0 ? (g.parentFlushed && g.status === 1 && yr(c, g), c.parentFlushed && s.completedBoundaries.push(c), c.fallbackAbortableTasks.forEach(ja, s), c.fallbackAbortableTasks.clear()) : g.parentFlushed && g.status === 1 && (yr(c, g), c.completedSegments.length === 1 && c.parentFlushed && s.partialBoundaries.push(c)));
    s.allPendingTasks--, s.allPendingTasks === 0 && (s = s.onAllReady, s());
  }
  function mo(s) {
    if (s.status !== 2) {
      var c = oe, g = Qr.current;
      Qr.current = ao;
      var y = mr;
      mr = s.responseState;
      try {
        var C = s.pingedTasks, _;
        for (_ = 0; _ < C.length; _++) {
          var L = C[_], $ = s, te = L.blockedSegment;
          if (te.status === 0) {
            Bt(L.context);
            try {
              mt($, L, L.node), te.lastPushedText && te.textEmbedded && te.chunks.push(Y), L.abortSet.delete(L), te.status = 1, ho($, L.blockedBoundary, te);
            } catch (Rt) {
              if (Jr(), typeof Rt == "object" && Rt !== null && typeof Rt.then == "function") {
                var fe = L.ping;
                Rt.then(fe, fe);
              } else {
                L.abortSet.delete(L), te.status = 4;
                var ce = L.blockedBoundary, Le = Rt, gt = Yn($, Le);
                if (ce === null ? vr($, Le) : (ce.pendingTasks--, ce.forceClientRender || (ce.forceClientRender = !0, ce.errorDigest = gt, ce.parentFlushed && $.clientRenderedBoundaries.push(ce))), $.allPendingTasks--, $.allPendingTasks === 0) {
                  var Ct = $.onAllReady;
                  Ct();
                }
              }
            } finally {
            }
          }
        }
        C.splice(0, _), s.destination !== null && ri(s, s.destination);
      } catch (Rt) {
        Yn(s, Rt), vr(s, Rt);
      } finally {
        mr = y, Qr.current = g, g === ao && Bt(c);
      }
    }
  }
  function xr(s, c, g) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        var y = g.id = s.nextSegmentId++;
        return g.lastPushedText = !1, g.textEmbedded = !1, s = s.responseState, i(c, Ze), i(c, s.placeholderPrefix), s = m(y.toString(16)), i(c, s), a(c, an);
      case 1:
        g.status = 2;
        var C = !0;
        y = g.chunks;
        var _ = 0;
        g = g.children;
        for (var L = 0; L < g.length; L++) {
          for (C = g[L]; _ < C.index; _++) i(c, y[_]);
          C = br(s, c, C);
        }
        for (; _ < y.length - 1; _++) i(c, y[_]);
        return _ < y.length && (C = a(c, y[_])), C;
      default:
        throw Error(t(390));
    }
  }
  function br(s, c, g) {
    var y = g.boundary;
    if (y === null) return xr(s, c, g);
    if (y.parentFlushed = !0, y.forceClientRender) y = y.errorDigest, a(c, St), i(c, Pt), y && (i(c, cn), i(c, m(se(y))), i(c, ln)), a(c, Fn), xr(s, c, g);
    else if (0 < y.pendingTasks) {
      y.rootSegmentID = s.nextSegmentId++, 0 < y.completedSegments.length && s.partialBoundaries.push(y);
      var C = s.responseState, _ = C.nextSuspenseID++;
      C = p(C.boundaryPrefix + _.toString(16)), y = y.id = C, Qe(c, s.responseState, y), xr(s, c, g);
    } else if (y.byteSize > s.progressiveChunkSize) y.rootSegmentID = s.nextSegmentId++, s.completedBoundaries.push(y), Qe(c, s.responseState, y.id), xr(s, c, g);
    else {
      if (a(c, qt), g = y.completedSegments, g.length !== 1) throw Error(t(391));
      br(s, c, g[0]);
    }
    return a(c, pt);
  }
  function go(s, c, g) {
    return Rn(c, s.responseState, g.formatContext, g.id), br(s, c, g), Mt(c, g.formatContext);
  }
  function vo(s, c, g) {
    for (var y = g.completedSegments, C = 0; C < y.length; C++) yo(s, c, g, y[C]);
    if (y.length = 0, s = s.responseState, y = g.id, g = g.rootSegmentID, i(c, s.startInlineScript), s.sentCompleteBoundaryFunction ? i(c, X) : (s.sentCompleteBoundaryFunction = !0, i(c, F)), y === null) throw Error(t(395));
    return g = m(g.toString(16)), i(c, y), i(c, Ce), i(c, s.segmentPrefix), i(c, g), a(c, We);
  }
  function yo(s, c, g, y) {
    if (y.status === 2) return !0;
    var C = y.id;
    if (C === -1) {
      if ((y.id = g.rootSegmentID) === -1) throw Error(t(392));
      return go(s, c, y);
    }
    return go(s, c, y), s = s.responseState, i(c, s.startInlineScript), s.sentCompleteSegmentFunction ? i(c, dn) : (s.sentCompleteSegmentFunction = !0, i(c, On)), i(c, s.segmentPrefix), C = m(C.toString(16)), i(c, C), i(c, G), i(c, s.placeholderPrefix), i(c, C), a(c, S);
  }
  function ri(s, c) {
    n = new Uint8Array(512), r = 0;
    try {
      var g = s.completedRootSegment;
      if (g !== null && s.pendingRootTasks === 0) {
        br(s, c, g), s.completedRootSegment = null;
        var y = s.responseState.bootstrapChunks;
        for (g = 0; g < y.length - 1; g++) i(c, y[g]);
        g < y.length && a(c, y[g]);
      }
      var C = s.clientRenderedBoundaries, _;
      for (_ = 0; _ < C.length; _++) {
        var L = C[_];
        y = c;
        var $ = s.responseState, te = L.id, fe = L.errorDigest, ce = L.errorMessage, Le = L.errorComponentStack;
        if (i(y, $.startInlineScript), $.sentClientRenderFunction ? i(y, Te) : ($.sentClientRenderFunction = !0, i(
          y,
          ze
        )), te === null) throw Error(t(395));
        i(y, te), i(y, st), (fe || ce || Le) && (i(y, Ue), i(y, m(Tt(fe || "")))), (ce || Le) && (i(y, Ue), i(y, m(Tt(ce || "")))), Le && (i(y, Ue), i(y, m(Tt(Le)))), a(y, kt);
      }
      C.splice(0, _);
      var gt = s.completedBoundaries;
      for (_ = 0; _ < gt.length; _++) vo(s, c, gt[_]);
      gt.splice(0, _), d(c), n = new Uint8Array(512), r = 0;
      var Ct = s.partialBoundaries;
      for (_ = 0; _ < Ct.length; _++) {
        var Rt = Ct[_];
        e: {
          C = s, L = c;
          var wr = Rt.completedSegments;
          for ($ = 0; $ < wr.length; $++) if (!yo(
            C,
            L,
            Rt,
            wr[$]
          )) {
            $++, wr.splice(0, $);
            var bo = !1;
            break e;
          }
          wr.splice(0, $), bo = !0;
        }
        if (!bo) {
          s.destination = null, _++, Ct.splice(0, _);
          return;
        }
      }
      Ct.splice(0, _);
      var ii = s.completedBoundaries;
      for (_ = 0; _ < ii.length; _++) vo(s, c, ii[_]);
      ii.splice(0, _);
    } finally {
      d(c), s.allPendingTasks === 0 && s.pingedTasks.length === 0 && s.clientRenderedBoundaries.length === 0 && s.completedBoundaries.length === 0 && c.close();
    }
  }
  function xo(s, c) {
    try {
      var g = s.abortableTasks;
      g.forEach(function(y) {
        return po(y, s, c);
      }), g.clear(), s.destination !== null && ri(s, s.destination);
    } catch (y) {
      Yn(s, y), vr(s, y);
    }
  }
  return _r.renderToReadableStream = function(s, c) {
    return new Promise(function(g, y) {
      var C, _, L = new Promise(function(ce, Le) {
        _ = ce, C = Le;
      }), $ = Aa(s, Be(c ? c.identifierPrefix : void 0, c ? c.nonce : void 0, c ? c.bootstrapScriptContent : void 0, c ? c.bootstrapScripts : void 0, c ? c.bootstrapModules : void 0), ft(c ? c.namespaceURI : void 0), c ? c.progressiveChunkSize : void 0, c ? c.onError : void 0, _, function() {
        var ce = new ReadableStream({ type: "bytes", pull: function(Le) {
          if ($.status === 1) $.status = 2, b(Le, $.fatalError);
          else if ($.status !== 2 && $.destination === null) {
            $.destination = Le;
            try {
              ri($, Le);
            } catch (gt) {
              Yn($, gt), vr($, gt);
            }
          }
        }, cancel: function() {
          xo($);
        } }, { highWaterMark: 0 });
        ce.allReady = L, g(ce);
      }, function(ce) {
        L.catch(function() {
        }), y(ce);
      }, C);
      if (c && c.signal) {
        var te = c.signal, fe = function() {
          xo($, te.reason), te.removeEventListener("abort", fe);
        };
        te.addEventListener("abort", fe);
      }
      mo($);
    });
  }, _r.version = "18.3.1", _r;
}
var Dn, Rs;
Dn = ml(), Rs = gl();
Dn.version;
Dn.renderToString;
Dn.renderToStaticMarkup;
Dn.renderToNodeStream;
Dn.renderToStaticNodeStream;
Rs.renderToReadableStream;
const vl = "staticMarkup";
function kn() {
  const t = Fi().indexOf(vl) > -1 ? !0 : void 0;
  return {
    isBootstrap: t,
    isReact: t ? void 0 : !0
  };
}
const Xe = ({ gaData: e, prefix: t = "", children: n }) => {
  const { isReact: r } = kn(), { onClick: i, ...a } = n.props;
  if (r)
    return He.cloneElement(n, {
      ...a,
      onClick: (m) => (e && e.event && e.action && Ts(e), i ? i(m) : !0)
    });
  let d = "";
  ["input", "header", "header-input"].includes(t) && (d = `-${t}`);
  const h = {
    [`data-ga${d}`]: e.text,
    [`data-ga${d}-name`]: e.name,
    [`data-ga${d}-event`]: e.event,
    [`data-ga${d}-action`]: e.action,
    [`data-ga${d}-type`]: e.type,
    [`data-ga${d}-region`]: e.region,
    [`data-ga${d}-section`]: e.section,
    [`data-ga${d}-component`]: e.component
  };
  return He.cloneElement(n, {
    ...a,
    onClick: i,
    ...h
  });
}, Os = $i(
  ({
    id: e,
    parentId: t,
    /** @type {AccordionCard} */
    item: n,
    openCard: r,
    onClick: i,
    gaData: a
  }, d) => {
    var p, b, w, E, I, O;
    const h = e === r, m = h ? "open" : "close";
    return /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: d,
        className: ve("accordion-item", "mt-3", {
          [`accordion-item-${n.color}`]: n.color,
          "accordion-header-icon": (p = n.content) == null ? void 0 : p.icon
        }),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ f.jsx("h4", { children: /* @__PURE__ */ f.jsx(
            Xe,
            {
              gaData: {
                ...a,
                action: m,
                text: n.content.header
              },
              children: /* @__PURE__ */ f.jsxs(
                "button",
                {
                  "data-testid": "accordion-opener",
                  className: ve({ collapsed: !h }),
                  "data-bs-toggle": "collapse",
                  href: `#card-body-${e}`,
                  type: "button",
                  "aria-expanded": h,
                  "aria-controls": `card-body-${e}`,
                  onClick: (k) => i(k, e),
                  children: [
                    (b = n.content) != null && b.icon ? /* @__PURE__ */ f.jsxs("span", { className: "accordion-icon", children: [
                      /* @__PURE__ */ f.jsx(
                        "i",
                        {
                          className: `${(w = n.content.icon) == null ? void 0 : w[0]} fa-${(E = n.content.icon) == null ? void 0 : E[1]} me-2`
                        }
                      ),
                      n.content.header
                    ] }) : (I = n.content) == null ? void 0 : I.header,
                    /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                  ]
                }
              )
            }
          ) }) }),
          ((O = n.content) == null ? void 0 : O.body) && /* @__PURE__ */ f.jsx(
            "div",
            {
              "data-bs-parent": `#${t}`,
              id: `card-body-${e}`,
              className: ve("collapse", { show: h }),
              children: /* @__PURE__ */ f.jsx(
                "div",
                {
                  className: "accordion-body",
                  dangerouslySetInnerHTML: vt(
                    n.content.body
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
);
Os.propTypes = {
  id: l.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: Cs,
  parentId: l.string,
  openCard: l.number,
  onClick: l.func,
  gaData: l.object
};
const yl = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, As = ({ cards: e, openedCard: t }) => {
  const [n, r] = Je(t), i = `accordion-${Fi()}`, a = on(
    /** @type { HTMLDivElement[]} */
    []
  ), d = (h, m) => {
    if (h.preventDefault(), n !== m) {
      const p = a.current[n - 1], b = p == null ? void 0 : p.lastElementChild;
      fl(b), r(m);
    } else
      r(null);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "accordion", id: i, children: e == null ? void 0 : e.map(
    (h, m) => h.content.body && h.content.header && /* @__PURE__ */ f.jsx(
      Os,
      {
        ref: (p) => {
          a.current[m] = p;
        },
        id: m + 1,
        parentId: i,
        item: h,
        openCard: n,
        onClick: d,
        gaData: yl
      },
      m + 1
    )
  ) });
};
As.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: l.arrayOf(Cs).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: l.number
};
const $o = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, wn = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  block: i,
  color: a = "gray",
  disabled: d,
  element: h = "button",
  href: m,
  icon: p,
  innerRef: b,
  onClick: w,
  size: E = "default",
  variant: I,
  classes: O,
  target: k = "_self",
  ...N
}) => {
  if (I) {
    const V = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, W = ve("btn", V[I], {
      [`btn-${V[I]}-${a}`]: !0,
      "btn-medium": E === "medium",
      "btn-small": E === "small",
      "btn-large": E === "large" || E === "default",
      disabled: d
    });
    let M = h;
    return m && h === "button" && (M = "a"), /* @__PURE__ */ f.jsx(
      Xe,
      {
        gaData: {
          ...$o,
          section: t,
          ...n,
          text: e
        },
        children: /* @__PURE__ */ f.jsxs(
          M,
          {
            type: M === "button" && w ? "button" : void 0,
            ...N,
            className: ve(O) || W,
            href: m,
            ref: b,
            onClick: w,
            "aria-label": r,
            target: M === "a" ? k : null,
            disabled: d,
            children: [
              p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` }),
              e
            ]
          }
        )
      }
    );
  }
  const j = ve("btn", {
    [`btn-${a}`]: !0,
    "btn-md": E === "small",
    "btn-sm": E === "xsmall",
    "btn-block": i,
    disabled: d
  });
  let D = h;
  return m && h === "button" && (D = "a"), /* @__PURE__ */ f.jsx(
    Xe,
    {
      gaData: {
        ...$o,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsxs(
        D,
        {
          type: D === "button" && w ? "button" : void 0,
          ...N,
          className: ve(O) || j,
          href: m,
          ref: b,
          onClick: w,
          "aria-label": r,
          target: D === "a" ? k : null,
          children: [
            p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` }),
            e
          ]
        }
      )
    }
  );
};
wn.propTypes = {
  /**
   * Button label
   */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Render button as a block-button?
  */
  block: l.bool,
  /**
    Button background color
  */
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: l.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: l.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: l.arrayOf(l.string),
  /**
   Link target type
   */
  target: l.oneOf(["_blank", "_self", "_top", "_parent"])
};
var js = { exports: {} }, Re = {};
var Bo;
function xl() {
  if (Bo) return Re;
  Bo = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), d = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), I = Symbol.for("react.client.reference");
  function O(k) {
    if (typeof k == "object" && k !== null) {
      var N = k.$$typeof;
      switch (N) {
        case e:
          switch (k = k.type, k) {
            case n:
            case i:
            case r:
            case m:
            case p:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case d:
                case h:
                case w:
                case b:
                  return k;
                case a:
                  return k;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  return Re.ContextConsumer = a, Re.ContextProvider = d, Re.Element = e, Re.ForwardRef = h, Re.Fragment = n, Re.Lazy = w, Re.Memo = b, Re.Portal = t, Re.Profiler = i, Re.StrictMode = r, Re.Suspense = m, Re.SuspenseList = p, Re.isContextConsumer = function(k) {
    return O(k) === a;
  }, Re.isContextProvider = function(k) {
    return O(k) === d;
  }, Re.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, Re.isForwardRef = function(k) {
    return O(k) === h;
  }, Re.isFragment = function(k) {
    return O(k) === n;
  }, Re.isLazy = function(k) {
    return O(k) === w;
  }, Re.isMemo = function(k) {
    return O(k) === b;
  }, Re.isPortal = function(k) {
    return O(k) === t;
  }, Re.isProfiler = function(k) {
    return O(k) === i;
  }, Re.isStrictMode = function(k) {
    return O(k) === r;
  }, Re.isSuspense = function(k) {
    return O(k) === m;
  }, Re.isSuspenseList = function(k) {
    return O(k) === p;
  }, Re.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === i || k === r || k === m || k === p || k === E || typeof k == "object" && k !== null && (k.$$typeof === w || k.$$typeof === b || k.$$typeof === d || k.$$typeof === a || k.$$typeof === h || k.$$typeof === I || k.getModuleId !== void 0);
  }, Re.typeOf = O, Re;
}
js.exports = xl();
var Ns = js.exports;
function bl(e) {
  function t(Y, B, q, U, A) {
    for (var ue = 0, z = 0, pe = 0, re = 0, ie, Z, de = 0, xe = 0, ae, Ae = ae = ie = 0, le = 0, Ee = 0, Ge = 0, je = 0, yt = q.length, Ke = yt - 1, Se, K = "", be = "", it = "", wt = "", Ze; le < yt; ) {
      if (Z = q.charCodeAt(le), le === Ke && z + re + pe + ue !== 0 && (z !== 0 && (Z = z === 47 ? 10 : 47), re = pe = ue = 0, yt++, Ke++), z + re + pe + ue === 0) {
        if (le === Ke && (0 < Ee && (K = K.replace(E, "")), 0 < K.trim().length)) {
          switch (Z) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              K += q.charAt(le);
          }
          Z = 59;
        }
        switch (Z) {
          case 123:
            for (K = K.trim(), ie = K.charCodeAt(0), ae = 1, je = ++le; le < yt; ) {
              switch (Z = q.charCodeAt(le)) {
                case 123:
                  ae++;
                  break;
                case 125:
                  ae--;
                  break;
                case 47:
                  switch (Z = q.charCodeAt(le + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ae = le + 1; Ae < Ke; ++Ae)
                          switch (q.charCodeAt(Ae)) {
                            case 47:
                              if (Z === 42 && q.charCodeAt(Ae - 1) === 42 && le + 2 !== Ae) {
                                le = Ae + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Z === 47) {
                                le = Ae + 1;
                                break e;
                              }
                          }
                        le = Ae;
                      }
                  }
                  break;
                case 91:
                  Z++;
                case 40:
                  Z++;
                case 34:
                case 39:
                  for (; le++ < Ke && q.charCodeAt(le) !== Z; )
                    ;
              }
              if (ae === 0) break;
              le++;
            }
            switch (ae = q.substring(je, le), ie === 0 && (ie = (K = K.replace(w, "").trim()).charCodeAt(0)), ie) {
              case 64:
                switch (0 < Ee && (K = K.replace(E, "")), Z = K.charCodeAt(1), Z) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Ee = B;
                    break;
                  default:
                    Ee = dt;
                }
                if (ae = t(B, Ee, ae, Z, A + 1), je = ae.length, 0 < Be && (Ee = n(dt, K, Ge), Ze = h(3, ae, Ee, B, Q, ye, je, Z, A, U), K = Ee.join(""), Ze !== void 0 && (je = (ae = Ze.trim()).length) === 0 && (Z = 0, ae = "")), 0 < je) switch (Z) {
                  case 115:
                    K = K.replace(J, d);
                  case 100:
                  case 109:
                  case 45:
                    ae = K + "{" + ae + "}";
                    break;
                  case 107:
                    K = K.replace(D, "$1 $2"), ae = K + "{" + ae + "}", ae = Ne === 1 || Ne === 2 && a("@" + ae, 3) ? "@-webkit-" + ae + "@" + ae : "@" + ae;
                    break;
                  default:
                    ae = K + ae, U === 112 && (ae = (be += ae, ""));
                }
                else ae = "";
                break;
              default:
                ae = t(B, n(B, K, Ge), ae, U, A + 1);
            }
            it += ae, ae = Ge = Ee = Ae = ie = 0, K = "", Z = q.charCodeAt(++le);
            break;
          case 125:
          case 59:
            if (K = (0 < Ee ? K.replace(E, "") : K).trim(), 1 < (je = K.length)) switch (Ae === 0 && (ie = K.charCodeAt(0), ie === 45 || 96 < ie && 123 > ie) && (je = (K = K.replace(" ", ":")).length), 0 < Be && (Ze = h(1, K, B, Y, Q, ye, be.length, U, A, U)) !== void 0 && (je = (K = Ze.trim()).length) === 0 && (K = "\0\0"), ie = K.charCodeAt(0), Z = K.charCodeAt(1), ie) {
              case 0:
                break;
              case 64:
                if (Z === 105 || Z === 99) {
                  wt += K + q.charAt(le);
                  break;
                }
              default:
                K.charCodeAt(je - 1) !== 58 && (be += i(K, ie, Z, K.charCodeAt(2)));
            }
            Ge = Ee = Ae = ie = 0, K = "", Z = q.charCodeAt(++le);
        }
      }
      switch (Z) {
        case 13:
        case 10:
          z === 47 ? z = 0 : 1 + ie === 0 && U !== 107 && 0 < K.length && (Ee = 1, K += "\0"), 0 < Be * ft && h(0, K, B, Y, Q, ye, be.length, U, A, U), ye = 1, Q++;
          break;
        case 59:
        case 125:
          if (z + re + pe + ue === 0) {
            ye++;
            break;
          }
        default:
          switch (ye++, Se = q.charAt(le), Z) {
            case 9:
            case 32:
              if (re + ue + z === 0) switch (de) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Se = "";
                  break;
                default:
                  Z !== 32 && (Se = " ");
              }
              break;
            case 0:
              Se = "\\0";
              break;
            case 12:
              Se = "\\f";
              break;
            case 11:
              Se = "\\v";
              break;
            case 38:
              re + z + ue === 0 && (Ee = Ge = 1, Se = "\f" + Se);
              break;
            case 108:
              if (re + z + ue + he === 0 && 0 < Ae) switch (le - Ae) {
                case 2:
                  de === 112 && q.charCodeAt(le - 3) === 58 && (he = de);
                case 8:
                  xe === 111 && (he = xe);
              }
              break;
            case 58:
              re + z + ue === 0 && (Ae = le);
              break;
            case 44:
              z + pe + re + ue === 0 && (Ee = 1, Se += "\r");
              break;
            case 34:
            case 39:
              z === 0 && (re = re === Z ? 0 : re === 0 ? Z : re);
              break;
            case 91:
              re + z + pe === 0 && ue++;
              break;
            case 93:
              re + z + pe === 0 && ue--;
              break;
            case 41:
              re + z + ue === 0 && pe--;
              break;
            case 40:
              if (re + z + ue === 0) {
                if (ie === 0) switch (2 * de + 3 * xe) {
                  case 533:
                    break;
                  default:
                    ie = 1;
                }
                pe++;
              }
              break;
            case 64:
              z + pe + re + ue + Ae + ae === 0 && (ae = 1);
              break;
            case 42:
            case 47:
              if (!(0 < re + ue + pe)) switch (z) {
                case 0:
                  switch (2 * Z + 3 * q.charCodeAt(le + 1)) {
                    case 235:
                      z = 47;
                      break;
                    case 220:
                      je = le, z = 42;
                  }
                  break;
                case 42:
                  Z === 47 && de === 42 && je + 2 !== le && (q.charCodeAt(je + 2) === 33 && (be += q.substring(je, le + 1)), Se = "", z = 0);
              }
          }
          z === 0 && (K += Se);
      }
      xe = de, de = Z, le++;
    }
    if (je = be.length, 0 < je) {
      if (Ee = B, 0 < Be && (Ze = h(2, be, Ee, Y, Q, ye, je, U, A, U), Ze !== void 0 && (be = Ze).length === 0)) return wt + be + it;
      if (be = Ee.join(",") + "{" + be + "}", Ne * he !== 0) {
        switch (Ne !== 2 || a(be, 2) || (he = 0), he) {
          case 111:
            be = be.replace(W, ":-moz-$1") + be;
            break;
          case 112:
            be = be.replace(V, "::-webkit-input-$1") + be.replace(V, "::-moz-$1") + be.replace(V, ":-ms-input-$1") + be;
        }
        he = 0;
      }
    }
    return wt + be + it;
  }
  function n(Y, B, q) {
    var U = B.trim().split(N);
    B = U;
    var A = U.length, ue = Y.length;
    switch (ue) {
      case 0:
      case 1:
        var z = 0;
        for (Y = ue === 0 ? "" : Y[0] + " "; z < A; ++z)
          B[z] = r(Y, B[z], q).trim();
        break;
      default:
        var pe = z = 0;
        for (B = []; z < A; ++z)
          for (var re = 0; re < ue; ++re)
            B[pe++] = r(Y[re] + " ", U[z], q).trim();
    }
    return B;
  }
  function r(Y, B, q) {
    var U = B.charCodeAt(0);
    switch (33 > U && (U = (B = B.trim()).charCodeAt(0)), U) {
      case 38:
        return B.replace(j, "$1" + Y.trim());
      case 58:
        return Y.trim() + B.replace(j, "$1" + Y.trim());
      default:
        if (0 < 1 * q && 0 < B.indexOf("\f")) return B.replace(j, (Y.charCodeAt(0) === 58 ? "" : "$1") + Y.trim());
    }
    return Y + B;
  }
  function i(Y, B, q, U) {
    var A = Y + ";", ue = 2 * B + 3 * q + 4 * U;
    if (ue === 944) {
      Y = A.indexOf(":", 9) + 1;
      var z = A.substring(Y, A.length - 1).trim();
      return z = A.substring(0, Y).trim() + z + ";", Ne === 1 || Ne === 2 && a(z, 1) ? "-webkit-" + z + z : z;
    }
    if (Ne === 0 || Ne === 2 && !a(A, 1)) return A;
    switch (ue) {
      case 1015:
        return A.charCodeAt(10) === 97 ? "-webkit-" + A + A : A;
      case 951:
        return A.charCodeAt(3) === 116 ? "-webkit-" + A + A : A;
      case 963:
        return A.charCodeAt(5) === 110 ? "-webkit-" + A + A : A;
      case 1009:
        if (A.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + A + A;
      case 978:
        return "-webkit-" + A + "-moz-" + A + A;
      case 1019:
      case 983:
        return "-webkit-" + A + "-moz-" + A + "-ms-" + A + A;
      case 883:
        if (A.charCodeAt(8) === 45) return "-webkit-" + A + A;
        if (0 < A.indexOf("image-set(", 11)) return A.replace(ke, "$1-webkit-$2") + A;
        break;
      case 932:
        if (A.charCodeAt(4) === 45) switch (A.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + A.replace("-grow", "") + "-webkit-" + A + "-ms-" + A.replace("grow", "positive") + A;
          case 115:
            return "-webkit-" + A + "-ms-" + A.replace("shrink", "negative") + A;
          case 98:
            return "-webkit-" + A + "-ms-" + A.replace("basis", "preferred-size") + A;
        }
        return "-webkit-" + A + "-ms-" + A + A;
      case 964:
        return "-webkit-" + A + "-ms-flex-" + A + A;
      case 1023:
        if (A.charCodeAt(8) !== 99) break;
        return z = A.substring(A.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + z + "-webkit-" + A + "-ms-flex-pack" + z + A;
      case 1005:
        return O.test(A) ? A.replace(I, ":-webkit-") + A.replace(I, ":-moz-") + A : A;
      case 1e3:
        switch (z = A.substring(13).trim(), B = z.indexOf("-") + 1, z.charCodeAt(0) + z.charCodeAt(B)) {
          case 226:
            z = A.replace(M, "tb");
            break;
          case 232:
            z = A.replace(M, "tb-rl");
            break;
          case 220:
            z = A.replace(M, "lr");
            break;
          default:
            return A;
        }
        return "-webkit-" + A + "-ms-" + z + A;
      case 1017:
        if (A.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (B = (A = Y).length - 10, z = (A.charCodeAt(B) === 33 ? A.substring(0, B) : A).substring(Y.indexOf(":", 7) + 1).trim(), ue = z.charCodeAt(0) + (z.charCodeAt(7) | 0)) {
          case 203:
            if (111 > z.charCodeAt(8)) break;
          case 115:
            A = A.replace(z, "-webkit-" + z) + ";" + A;
            break;
          case 207:
          case 102:
            A = A.replace(z, "-webkit-" + (102 < ue ? "inline-" : "") + "box") + ";" + A.replace(z, "-webkit-" + z) + ";" + A.replace(z, "-ms-" + z + "box") + ";" + A;
        }
        return A + ";";
      case 938:
        if (A.charCodeAt(5) === 45) switch (A.charCodeAt(6)) {
          case 105:
            return z = A.replace("-items", ""), "-webkit-" + A + "-webkit-box-" + z + "-ms-flex-" + z + A;
          case 115:
            return "-webkit-" + A + "-ms-flex-item-" + A.replace(Oe, "") + A;
          default:
            return "-webkit-" + A + "-ms-flex-line-pack" + A.replace("align-content", "").replace(Oe, "") + A;
        }
        break;
      case 973:
      case 989:
        if (A.charCodeAt(3) !== 45 || A.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (Ve.test(Y) === !0) return (z = Y.substring(Y.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(Y.replace("stretch", "fill-available"), B, q, U).replace(":fill-available", ":stretch") : A.replace(z, "-webkit-" + z) + A.replace(z, "-moz-" + z.replace("fill-", "")) + A;
        break;
      case 962:
        if (A = "-webkit-" + A + (A.charCodeAt(5) === 102 ? "-ms-" + A : "") + A, q + U === 211 && A.charCodeAt(13) === 105 && 0 < A.indexOf("transform", 10)) return A.substring(0, A.indexOf(";", 27) + 1).replace(k, "$1-webkit-$2") + A;
    }
    return A;
  }
  function a(Y, B) {
    var q = Y.indexOf(B === 1 ? ":" : "{"), U = Y.substring(0, B !== 3 ? q : 10);
    return q = Y.substring(q + 1, Y.length - 1), Ye(B !== 2 ? U : U.replace(Fe, "$1"), q, B);
  }
  function d(Y, B) {
    var q = i(B, B.charCodeAt(0), B.charCodeAt(1), B.charCodeAt(2));
    return q !== B + ";" ? q.replace(se, " or ($1)").substring(4) : "(" + B + ")";
  }
  function h(Y, B, q, U, A, ue, z, pe, re, ie) {
    for (var Z = 0, de = B, xe; Z < Be; ++Z)
      switch (xe = $e[Z].call(b, Y, de, q, U, A, ue, z, pe, re, ie)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          de = xe;
      }
    if (de !== B) return de;
  }
  function m(Y) {
    switch (Y) {
      case void 0:
      case null:
        Be = $e.length = 0;
        break;
      default:
        if (typeof Y == "function") $e[Be++] = Y;
        else if (typeof Y == "object") for (var B = 0, q = Y.length; B < q; ++B)
          m(Y[B]);
        else ft = !!Y | 0;
    }
    return m;
  }
  function p(Y) {
    return Y = Y.prefix, Y !== void 0 && (Ye = null, Y ? typeof Y != "function" ? Ne = 1 : (Ne = 2, Ye = Y) : Ne = 0), p;
  }
  function b(Y, B) {
    var q = Y;
    if (33 > q.charCodeAt(0) && (q = q.trim()), we = q, q = [we], 0 < Be) {
      var U = h(-1, B, q, q, Q, ye, 0, 0, 0, 0);
      U !== void 0 && typeof U == "string" && (B = U);
    }
    var A = t(dt, q, B, 0, 0);
    return 0 < Be && (U = h(-2, A, q, q, Q, ye, A.length, 0, 0, 0), U !== void 0 && (A = U)), we = "", he = 0, ye = Q = 1, A;
  }
  var w = /^\0+/g, E = /[\0\r\f]/g, I = /: */g, O = /zoo|gra/, k = /([,: ])(transform)/g, N = /,\r+?/g, j = /([\t\r\n ])*\f?&/g, D = /@(k\w+)\s*(\S*)\s*/, V = /::(place)/g, W = /:(read-only)/g, M = /[svh]\w+-[tblr]{2}/, J = /\(\s*(.*)\s*\)/g, se = /([\s\S]*?);/g, Oe = /-self|flex-/g, Fe = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Ve = /stretch|:\s*\w+\-(?:conte|avail)/, ke = /([^-])(image-set\()/, ye = 1, Q = 1, he = 0, Ne = 1, dt = [], $e = [], Be = 0, Ye = null, ft = 0, we = "";
  return b.use = m, b.set = p, e !== void 0 && p(e), b;
}
var wl = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Sl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var kl = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, zo = /* @__PURE__ */ Sl(
  function(e) {
    return kl.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ps = { exports: {} }, _e = {};
var Ho;
function Tl() {
  if (Ho) return _e;
  Ho = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, h = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, I = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, k = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function V(M) {
    if (typeof M == "object" && M !== null) {
      var J = M.$$typeof;
      switch (J) {
        case t:
          switch (M = M.type, M) {
            case m:
            case p:
            case r:
            case a:
            case i:
            case w:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case h:
                case b:
                case O:
                case I:
                case d:
                  return M;
                default:
                  return J;
              }
          }
        case n:
          return J;
      }
    }
  }
  function W(M) {
    return V(M) === p;
  }
  return _e.AsyncMode = m, _e.ConcurrentMode = p, _e.ContextConsumer = h, _e.ContextProvider = d, _e.Element = t, _e.ForwardRef = b, _e.Fragment = r, _e.Lazy = O, _e.Memo = I, _e.Portal = n, _e.Profiler = a, _e.StrictMode = i, _e.Suspense = w, _e.isAsyncMode = function(M) {
    return W(M) || V(M) === m;
  }, _e.isConcurrentMode = W, _e.isContextConsumer = function(M) {
    return V(M) === h;
  }, _e.isContextProvider = function(M) {
    return V(M) === d;
  }, _e.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, _e.isForwardRef = function(M) {
    return V(M) === b;
  }, _e.isFragment = function(M) {
    return V(M) === r;
  }, _e.isLazy = function(M) {
    return V(M) === O;
  }, _e.isMemo = function(M) {
    return V(M) === I;
  }, _e.isPortal = function(M) {
    return V(M) === n;
  }, _e.isProfiler = function(M) {
    return V(M) === a;
  }, _e.isStrictMode = function(M) {
    return V(M) === i;
  }, _e.isSuspense = function(M) {
    return V(M) === w;
  }, _e.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === r || M === p || M === a || M === i || M === w || M === E || typeof M == "object" && M !== null && (M.$$typeof === O || M.$$typeof === I || M.$$typeof === d || M.$$typeof === h || M.$$typeof === b || M.$$typeof === N || M.$$typeof === j || M.$$typeof === D || M.$$typeof === k);
  }, _e.typeOf = V, _e;
}
Ps.exports = Tl();
var _l = Ps.exports, Vi = _l, El = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Cl = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Rl = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Is = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Wi = {};
Wi[Vi.ForwardRef] = Rl;
Wi[Vi.Memo] = Is;
function Vo(e) {
  return Vi.isMemo(e) ? Is : Wi[e.$$typeof] || El;
}
var Ol = Object.defineProperty, Al = Object.getOwnPropertyNames, Wo = Object.getOwnPropertySymbols, jl = Object.getOwnPropertyDescriptor, Nl = Object.getPrototypeOf, Uo = Object.prototype;
function Ls(e, t, n) {
  if (typeof t != "string") {
    if (Uo) {
      var r = Nl(t);
      r && r !== Uo && Ls(e, r, n);
    }
    var i = Al(t);
    Wo && (i = i.concat(Wo(t)));
    for (var a = Vo(e), d = Vo(t), h = 0; h < i.length; ++h) {
      var m = i[h];
      if (!Cl[m] && !(n && n[m]) && !(d && d[m]) && !(a && a[m])) {
        var p = jl(t, m);
        try {
          Ol(e, m, p);
        } catch {
        }
      }
    }
  }
  return e;
}
var Pl = Ls;
const Il = /* @__PURE__ */ zi(Pl);
var rt = { env: { NODE_ENV: "production" } };
function Wt() {
  return (Wt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var qo = function(e, t) {
  for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);
  return n;
}, bi = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Ns.typeOf(e);
}, Fr = Object.freeze([]), rn = Object.freeze({});
function nr(e) {
  return typeof e == "function";
}
function Yo(e) {
  return e.displayName || e.name || "Component";
}
function Ui(e) {
  return e && typeof e.styledComponentId == "string";
}
var Pn = typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_ATTR || rt.env.SC_ATTR) || "data-styled", qi = typeof window < "u" && "HTMLElement" in window, Ll = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof rt < "u" && rt.env !== void 0 && (rt.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? rt.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && rt.env.REACT_APP_SC_DISABLE_SPEEDY : rt.env.SC_DISABLE_SPEEDY !== void 0 && rt.env.SC_DISABLE_SPEEDY !== "" ? rt.env.SC_DISABLE_SPEEDY !== "false" && rt.env.SC_DISABLE_SPEEDY : rt.env.NODE_ENV !== "production"));
function ir(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var Ml = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, i = 0; i < n; i++) r += this.groupSizes[i];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var i = this.groupSizes, a = i.length, d = a; n >= d; ) (d <<= 1) < 0 && ir(16, "" + n);
      this.groupSizes = new Uint32Array(d), this.groupSizes.set(i), this.length = d;
      for (var h = a; h < d; h++) this.groupSizes[h] = 0;
    }
    for (var m = this.indexOfGroup(n + 1), p = 0, b = r.length; p < b; p++) this.tag.insertRule(m, r[p]) && (this.groupSizes[n]++, m++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], i = this.indexOfGroup(n), a = i + r;
      this.groupSizes[n] = 0;
      for (var d = i; d < a; d++) this.tag.deleteRule(i);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0) return r;
    for (var i = this.groupSizes[n], a = this.indexOfGroup(n), d = a + i, h = a; h < d; h++) r += this.tag.getRule(h) + `/*!sc*/
`;
    return r;
  }, e;
}(), Nr = /* @__PURE__ */ new Map(), $r = /* @__PURE__ */ new Map(), er = 1, Er = function(e) {
  if (Nr.has(e)) return Nr.get(e);
  for (; $r.has(er); ) er++;
  var t = er++;
  return Nr.set(e, t), $r.set(t, e), t;
}, Dl = function(e) {
  return $r.get(e);
}, Fl = function(e, t) {
  t >= er && (er = t + 1), Nr.set(e, t), $r.set(t, e);
}, $l = "style[" + Pn + '][data-styled-version="5.3.11"]', Bl = new RegExp("^" + Pn + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), zl = function(e, t, n) {
  for (var r, i = n.split(","), a = 0, d = i.length; a < d; a++) (r = i[a]) && e.registerName(t, r);
}, Hl = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], i = 0, a = n.length; i < a; i++) {
    var d = n[i].trim();
    if (d) {
      var h = d.match(Bl);
      if (h) {
        var m = 0 | parseInt(h[1], 10), p = h[2];
        m !== 0 && (Fl(p, m), zl(e, p, h[3]), e.getTag().insertRules(m, r)), r.length = 0;
      } else r.push(d);
    }
  }
}, Vl = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Ms = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), i = function(h) {
    for (var m = h.childNodes, p = m.length; p >= 0; p--) {
      var b = m[p];
      if (b && b.nodeType === 1 && b.hasAttribute(Pn)) return b;
    }
  }(n), a = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(Pn, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var d = Vl();
  return d && r.setAttribute("nonce", d), n.insertBefore(r, a), r;
}, Wl = function() {
  function e(n) {
    var r = this.element = Ms(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet) return i.sheet;
      for (var a = document.styleSheets, d = 0, h = a.length; d < h; d++) {
        var m = a[d];
        if (m.ownerNode === i) return m;
      }
      ir(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), Ul = function() {
  function e(n) {
    var r = this.element = Ms(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var i = document.createTextNode(r), a = this.nodes[n];
      return this.element.insertBefore(i, a || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), ql = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), Xo = qi, Yl = { isServer: !qi, useCSSOMInjection: !Ll }, Ds = function() {
  function e(n, r, i) {
    n === void 0 && (n = rn), r === void 0 && (r = {}), this.options = Wt({}, Yl, {}, n), this.gs = r, this.names = new Map(i), this.server = !!n.isServer, !this.server && qi && Xo && (Xo = !1, function(a) {
      for (var d = document.querySelectorAll($l), h = 0, m = d.length; h < m; h++) {
        var p = d[h];
        p && p.getAttribute(Pn) !== "active" && (Hl(a, p), p.parentNode && p.parentNode.removeChild(p));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Er(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Wt({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (i = (r = this.options).isServer, a = r.useCSSOMInjection, d = r.target, n = i ? new ql(d) : a ? new Wl(d) : new Ul(d), new Ml(n)));
    var n, r, i, a, d;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Er(n), this.names.has(n)) this.names.get(n).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(n, i);
    }
  }, t.insertRules = function(n, r, i) {
    this.registerName(n, r), this.getTag().insertRules(Er(n), i);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Er(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), i = r.length, a = "", d = 0; d < i; d++) {
        var h = Dl(d);
        if (h !== void 0) {
          var m = n.names.get(h), p = r.getGroup(d);
          if (m && p && m.size) {
            var b = Pn + ".g" + d + '[id="' + h + '"]', w = "";
            m !== void 0 && m.forEach(function(E) {
              E.length > 0 && (w += E + ",");
            }), a += "" + p + b + '{content:"' + w + `"}/*!sc*/
`;
          }
        }
      }
      return a;
    }(this);
  }, e;
}(), Xl = /(a)(d)/gi, Go = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function wi(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Go(t % 52) + n;
  return (Go(t % 52) + n).replace(Xl, "$1-$2");
}
var Nn = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Fs = function(e) {
  return Nn(5381, e);
};
function Gl(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (nr(n) && !Ui(n)) return !1;
  }
  return !0;
}
var Kl = Fs("5.3.11"), Zl = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && Gl(t), this.componentId = n, this.baseHash = Nn(Kl, n), this.baseStyle = r, Ds.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var i = this.componentId, a = [];
    if (this.baseStyle && a.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(i, this.staticRulesId)) a.push(this.staticRulesId);
    else {
      var d = In(this.rules, t, n, r).join(""), h = wi(Nn(this.baseHash, d) >>> 0);
      if (!n.hasNameForId(i, h)) {
        var m = r(d, "." + h, void 0, i);
        n.insertRules(i, h, m);
      }
      a.push(h), this.staticRulesId = h;
    }
    else {
      for (var p = this.rules.length, b = Nn(this.baseHash, r.hash), w = "", E = 0; E < p; E++) {
        var I = this.rules[E];
        if (typeof I == "string") w += I;
        else if (I) {
          var O = In(I, t, n, r), k = Array.isArray(O) ? O.join("") : O;
          b = Nn(b, k + E), w += k;
        }
      }
      if (w) {
        var N = wi(b >>> 0);
        if (!n.hasNameForId(i, N)) {
          var j = r(w, "." + N, void 0, i);
          n.insertRules(i, N, j);
        }
        a.push(N);
      }
    }
    return a.join(" ");
  }, e;
}(), Jl = /^\s*\/\/.*$/gm, Ql = [":", "[", ".", "#"];
function ec(e) {
  var t, n, r, i, a = rn, d = a.options, h = d === void 0 ? rn : d, m = a.plugins, p = m === void 0 ? Fr : m, b = new bl(h), w = [], E = /* @__PURE__ */ function(k) {
    function N(j) {
      if (j) try {
        k(j + "}");
      } catch {
      }
    }
    return function(j, D, V, W, M, J, se, Oe, Fe, Ve) {
      switch (j) {
        case 1:
          if (Fe === 0 && D.charCodeAt(0) === 64) return k(D + ";"), "";
          break;
        case 2:
          if (Oe === 0) return D + "/*|*/";
          break;
        case 3:
          switch (Oe) {
            case 102:
            case 112:
              return k(V[0] + D), "";
            default:
              return D + (Ve === 0 ? "/*|*/" : "");
          }
        case -2:
          D.split("/*|*/}").forEach(N);
      }
    };
  }(function(k) {
    w.push(k);
  }), I = function(k, N, j) {
    return N === 0 && Ql.indexOf(j[n.length]) !== -1 || j.match(i) ? k : "." + t;
  };
  function O(k, N, j, D) {
    D === void 0 && (D = "&");
    var V = k.replace(Jl, ""), W = N && j ? j + " " + N + " { " + V + " }" : V;
    return t = D, n = N, r = new RegExp("\\" + n + "\\b", "g"), i = new RegExp("(\\" + n + "\\b){2,}"), b(j || !N ? "" : N, W);
  }
  return b.use([].concat(p, [function(k, N, j) {
    k === 2 && j.length && j[0].lastIndexOf(n) > 0 && (j[0] = j[0].replace(r, I));
  }, E, function(k) {
    if (k === -2) {
      var N = w;
      return w = [], N;
    }
  }])), O.hash = p.length ? p.reduce(function(k, N) {
    return N.name || ir(15), Nn(k, N.name);
  }, 5381).toString() : "", O;
}
var $s = He.createContext();
$s.Consumer;
var Bs = He.createContext(), tc = (Bs.Consumer, new Ds()), Si = ec();
function nc() {
  return Bi($s) || tc;
}
function rc() {
  return Bi(Bs) || Si;
}
var ic = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(i, a) {
      a === void 0 && (a = Si);
      var d = r.name + a.hash;
      i.hasNameForId(r.id, d) || i.insertRules(r.id, d, a(r.rules, d, "@keyframes"));
    }, this.toString = function() {
      return ir(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Si), this.name + t.hash;
  }, e;
}(), oc = /([A-Z])/, sc = /([A-Z])/g, ac = /^ms-/, lc = function(e) {
  return "-" + e.toLowerCase();
};
function Ko(e) {
  return oc.test(e) ? e.replace(sc, lc).replace(ac, "-ms-") : e;
}
var Zo = function(e) {
  return e == null || e === !1 || e === "";
};
function In(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i, a = [], d = 0, h = e.length; d < h; d += 1) (i = In(e[d], t, n, r)) !== "" && (Array.isArray(i) ? a.push.apply(a, i) : a.push(i));
    return a;
  }
  if (Zo(e)) return "";
  if (Ui(e)) return "." + e.styledComponentId;
  if (nr(e)) {
    if (typeof (p = e) != "function" || p.prototype && p.prototype.isReactComponent || !t) return e;
    var m = e(t);
    return In(m, t, n, r);
  }
  var p;
  return e instanceof ic ? n ? (e.inject(n, r), e.getName(r)) : e : bi(e) ? function b(w, E) {
    var I, O, k = [];
    for (var N in w) w.hasOwnProperty(N) && !Zo(w[N]) && (Array.isArray(w[N]) && w[N].isCss || nr(w[N]) ? k.push(Ko(N) + ":", w[N], ";") : bi(w[N]) ? k.push.apply(k, b(w[N], N)) : k.push(Ko(N) + ": " + (I = N, (O = w[N]) == null || typeof O == "boolean" || O === "" ? "" : typeof O != "number" || O === 0 || I in wl || I.startsWith("--") ? String(O).trim() : O + "px") + ";"));
    return E ? [E + " {"].concat(k, ["}"]) : k;
  }(e) : e.toString();
}
var Jo = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function cc(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return nr(e) || bi(e) ? Jo(In(qo(Fr, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Jo(In(qo(e, n)));
}
var uc = function(e, t, n) {
  return n === void 0 && (n = rn), e.theme !== n.theme && e.theme || t || n.theme;
}, dc = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fc = /(^-|-$)/g;
function hi(e) {
  return e.replace(dc, "-").replace(fc, "");
}
var pc = function(e) {
  return wi(Fs(e) >>> 0);
};
function Cr(e) {
  return typeof e == "string" && rt.env.NODE_ENV === "production";
}
var ki = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, hc = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function mc(e, t, n) {
  var r = e[n];
  ki(t) && ki(r) ? zs(r, t) : e[n] = t;
}
function zs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var i = 0, a = n; i < a.length; i++) {
    var d = a[i];
    if (ki(d)) for (var h in d) hc(h) && mc(e, d[h], h);
  }
  return e;
}
var Hs = He.createContext();
Hs.Consumer;
var mi = {};
function Vs(e, t, n) {
  var r = Ui(e), i = !Cr(e), a = t.attrs, d = a === void 0 ? Fr : a, h = t.componentId, m = h === void 0 ? function(D, V) {
    var W = typeof D != "string" ? "sc" : hi(D);
    mi[W] = (mi[W] || 0) + 1;
    var M = W + "-" + pc("5.3.11" + W + mi[W]);
    return V ? V + "-" + M : M;
  }(t.displayName, t.parentComponentId) : h, p = t.displayName, b = p === void 0 ? function(D) {
    return Cr(D) ? "styled." + D : "Styled(" + Yo(D) + ")";
  }(e) : p, w = t.displayName && t.componentId ? hi(t.displayName) + "-" + t.componentId : t.componentId || m, E = r && e.attrs ? Array.prototype.concat(e.attrs, d).filter(Boolean) : d, I = t.shouldForwardProp;
  r && e.shouldForwardProp && (I = t.shouldForwardProp ? function(D, V, W) {
    return e.shouldForwardProp(D, V, W) && t.shouldForwardProp(D, V, W);
  } : e.shouldForwardProp);
  var O, k = new Zl(n, w, r ? e.componentStyle : void 0), N = k.isStatic && d.length === 0, j = function(D, V) {
    return function(W, M, J, se) {
      var Oe = W.attrs, Fe = W.componentStyle, Ve = W.defaultProps, ke = W.foldedComponentIds, ye = W.shouldForwardProp, Q = W.styledComponentId, he = W.target, Ne = function(U, A, ue) {
        U === void 0 && (U = rn);
        var z = Wt({}, A, { theme: U }), pe = {};
        return ue.forEach(function(re) {
          var ie, Z, de, xe = re;
          for (ie in nr(xe) && (xe = xe(z)), xe) z[ie] = pe[ie] = ie === "className" ? (Z = pe[ie], de = xe[ie], Z && de ? Z + " " + de : Z || de) : xe[ie];
        }), [z, pe];
      }(uc(M, Bi(Hs), Ve) || rn, M, Oe), dt = Ne[0], $e = Ne[1], Be = function(U, A, ue, z) {
        var pe = nc(), re = rc(), ie = A ? U.generateAndInjectStyles(rn, pe, re) : U.generateAndInjectStyles(ue, pe, re);
        return ie;
      }(Fe, se, dt), Ye = J, ft = $e.$as || M.$as || $e.as || M.as || he, we = Cr(ft), Y = $e !== M ? Wt({}, M, {}, $e) : M, B = {};
      for (var q in Y) q[0] !== "$" && q !== "as" && (q === "forwardedAs" ? B.as = Y[q] : (ye ? ye(q, zo, ft) : !we || zo(q)) && (B[q] = Y[q]));
      return M.style && $e.style !== M.style && (B.style = Wt({}, M.style, {}, $e.style)), B.className = Array.prototype.concat(ke, Q, Be !== Q ? Be : null, M.className, $e.className).filter(Boolean).join(" "), B.ref = Ye, Na(ft, B);
    }(O, D, V, N);
  };
  return j.displayName = b, (O = He.forwardRef(j)).attrs = E, O.componentStyle = k, O.displayName = b, O.shouldForwardProp = I, O.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : Fr, O.styledComponentId = w, O.target = r ? e.target : e, O.withComponent = function(D) {
    var V = t.componentId, W = function(J, se) {
      if (J == null) return {};
      var Oe, Fe, Ve = {}, ke = Object.keys(J);
      for (Fe = 0; Fe < ke.length; Fe++) Oe = ke[Fe], se.indexOf(Oe) >= 0 || (Ve[Oe] = J[Oe]);
      return Ve;
    }(t, ["componentId"]), M = V && V + "-" + (Cr(D) ? D : hi(Yo(D)));
    return Vs(D, Wt({}, W, { attrs: E, componentId: M }), n);
  }, Object.defineProperty(O, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(D) {
    this._foldedDefaultProps = r ? zs({}, e.defaultProps, D) : D;
  } }), Object.defineProperty(O, "toString", { value: function() {
    return "." + O.styledComponentId;
  } }), i && Il(O, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), O;
}
var jt = function(e) {
  return function t(n, r, i) {
    if (i === void 0 && (i = rn), !Ns.isValidElementType(r)) return ir(1, String(r));
    var a = function() {
      return n(r, i, cc.apply(void 0, arguments));
    };
    return a.withConfig = function(d) {
      return t(n, r, Wt({}, i, {}, d));
    }, a.attrs = function(d) {
      return t(n, r, Wt({}, i, { attrs: Array.prototype.concat(i.attrs, d).filter(Boolean) }));
    }, a;
  }(Vs, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  jt[e] = jt(e);
});
const gc = jt.div`
  &.sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    &.with-header {
      top: ${({ requiresAltMenuSpacing: e }) => e ? "112px" : "142px"};
      @media (max-width: 992px) {
        top: 110px;
      }
    }
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    cursor: default;
    h4 {
      align-items: center;
    }
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Pr = "On This Page", vc = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Pr
}, Ws = ({
  items: e,
  firstElementId: t,
  focusFirstFocusableElement: n = !1
}) => {
  const { isReact: r, isBootstrap: i } = kn(), a = on(null), d = Ha("(max-width: 991px)"), [h, m] = Je({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), p = d ? 110 : 142, b = () => {
    var J;
    const j = {}, D = window.scrollY, V = (J = document.getElementById(t)) == null ? void 0 : J.getBoundingClientRect().top, W = 103;
    V >= 0 && (j.sticky = !1, j.activeContainer = ""), D > a.current.getBoundingClientRect().top && (j.sticky = !0);
    const M = h.hasHeader ? p + W : W;
    e == null || e.forEach(({ targetIdName: se }) => {
      const Oe = document.getElementById(se), Fe = (Oe == null ? void 0 : Oe.getBoundingClientRect().top) - M, Ve = (Oe == null ? void 0 : Oe.getBoundingClientRect().bottom) - M;
      Fe < 0 && Ve > 0 && (j.activeContainer = se);
    }), m((se) => ({
      ...se,
      ...j
    }));
  }, w = () => {
    yi(b, 150), xi(b, 150);
  }, E = () => !!(document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader")), I = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function O(j = null) {
    if (j === null) return h.containerClass;
    const D = Object.values(j.classList).filter(
      (V) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(V)
    );
    return D.length > 0 ? D.join(" ") : O(j.parentElement);
  }
  lt(() => {
    const j = document.getElementById(t) || null, D = {
      hasHeader: E(),
      hasAltMenuSpacing: I(),
      containerClass: O(j)
    };
    m((V) => ({
      ...V,
      ...D
    }));
  }, []), lt(() => (window == null || window.addEventListener("scroll", w), () => window.removeEventListener("scroll", w)), [h.hasHeader]);
  const k = (j) => {
    var M, J;
    const D = window.scrollY - (h.hasHeader ? p + 100 : 100), V = d ? 410 : 90;
    let W = ((M = document.getElementById(j)) == null ? void 0 : M.getBoundingClientRect().top) + D;
    a.current.classList.contains("sticky") || (W -= V), n && ((J = dl(`#${j}`)) == null || J.focus()), window.scrollTo({ top: W, behavior: "smooth" });
  }, N = () => {
    m((j) => ({
      ...j,
      showMenu: !j.showMenu
    }));
  };
  return (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ f.jsx(
    gc,
    {
      requiresAltMenuSpacing: h.hasAltMenuSpacing,
      ref: a,
      id: "uds-anchor-menu",
      className: ve(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: h.sticky,
          "with-header": h.hasHeader
        }
      ),
      style: h.showMenu ? { borderBottom: 0 } : {},
      children: /* @__PURE__ */ f.jsxs("div", { className: `${h.containerClass} uds-anchor-menu-wrapper`, children: [
        d ? /* @__PURE__ */ f.jsx(
          Xe,
          {
            gaData: {
              ...vc,
              action: h.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ f.jsx(
              "button",
              {
                className: ve("mobile-menu-toggler", {
                  "show-menu": h.showMenu
                }),
                type: "button",
                onClick: N,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                children: /* @__PURE__ */ f.jsxs("h4", { children: [
                  Pr,
                  ":",
                  /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-down" })
                ] })
              }
            )
          }
        ) : /* @__PURE__ */ f.jsxs("h4", { children: [
          Pr,
          ":"
        ] }),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: ve("card", "card-body", "collapse", {
              show: h.showMenu
            }),
            children: /* @__PURE__ */ f.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Pr,
                children: e == null ? void 0 : e.map((j) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ f.jsx(
                    wn,
                    {
                      "data-testid": `anchor-item-${j.targetIdName}`,
                      classes: ve("nav-link", {
                        active: h.activeContainer === j.targetIdName
                      }).split(" "),
                      ariaLabel: j.text,
                      label: j.text,
                      icon: j.icon,
                      onClick: r && (() => k(j.targetIdName)),
                      href: i && `#${j.targetIdName}`
                    },
                    j.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Ws.propTypes = {
  /**
   * Anchor menu items
   */
  items: l.arrayOf(
    l.shape({
      text: l.string.isRequired,
      targetIdName: l.string.isRequired,
      icon: l.arrayOf(l.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: l.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: l.bool
};
var Ti = function() {
  return Ti = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ti.apply(this, arguments);
}, yc = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Vr(e) {
  var t = function(n) {
    var r = n.bgStyle, i = n.borderRadius, a = n.iconFillColor, d = n.round, h = n.size, m = yc(n, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return He.createElement(
      "svg",
      Ti({ viewBox: "0 0 64 64", width: h, height: h }, m),
      d ? He.createElement("circle", { cx: "32", cy: "32", r: "31", fill: e.color, style: r }) : He.createElement("rect", { width: "64", height: "64", rx: i, ry: i, fill: e.color, style: r }),
      He.createElement("path", { d: e.path, fill: a })
    );
  };
  return t.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, t;
}
var xc = Vr({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function Wr(e) {
  var t = Object.entries(e).filter(function(n) {
    var r = n[1];
    return r != null;
  }).map(function(n) {
    var r = n[0], i = n[1];
    return "".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(String(i)));
  });
  return t.length > 0 ? "?".concat(t.join("&")) : "";
}
var bc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ht = function() {
  return Ht = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ht.apply(this, arguments);
}, wc = function(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(d) {
      d(a);
    });
  }
  return new (n || (n = Promise))(function(a, d) {
    function h(b) {
      try {
        p(r.next(b));
      } catch (w) {
        d(w);
      }
    }
    function m(b) {
      try {
        p(r.throw(b));
      } catch (w) {
        d(w);
      }
    }
    function p(b) {
      b.done ? a(b.value) : i(b.value).then(h, m);
    }
    p((r = r.apply(e, t || [])).next());
  });
}, Sc = function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, d;
  return d = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function h(p) {
    return function(b) {
      return m([p, b]);
    };
  }
  function m(p) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (a = p[0] & 2 ? i.return : p[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, p[1])).done) return a;
      switch (i = 0, a && (p = [p[0] & 2, a.value]), p[0]) {
        case 0:
        case 1:
          a = p;
          break;
        case 4:
          return n.label++, { value: p[1], done: !1 };
        case 5:
          n.label++, i = p[1], p = [0];
          continue;
        case 7:
          p = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (p[0] === 6 || p[0] === 2)) {
            n = 0;
            continue;
          }
          if (p[0] === 3 && (!a || p[1] > a[0] && p[1] < a[3])) {
            n.label = p[1];
            break;
          }
          if (p[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = p;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(p);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      p = t.call(e, n);
    } catch (b) {
      p = [6, b], i = 0;
    } finally {
      r = a = 0;
    }
    if (p[0] & 5) throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, Us = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}, kc = function(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}, Tc = function(e, t) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
  };
}, _c = function(e, t) {
  return {
    top: (window.screen.height - t) / 2,
    left: (window.screen.width - e) / 2
  };
};
function Ec(e, t, n) {
  var r = t.height, i = t.width, a = Us(t, ["height", "width"]), d = Ht({ height: r, width: i, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, a), h = window.open(e, "", Object.keys(d).map(function(p) {
    return "".concat(p, "=").concat(d[p]);
  }).join(", "));
  if (n)
    var m = window.setInterval(function() {
      try {
        (h === null || h.closed) && (window.clearInterval(m), n(h));
      } catch (p) {
        console.error(p);
      }
    }, 1e3);
  return h;
}
var Cc = (
  /** @class */
  function(e) {
    bc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.openShareDialog = function(r) {
        var i = n.props, a = i.onShareWindowClose, d = i.windowHeight, h = d === void 0 ? 400 : d, m = i.windowPosition, p = m === void 0 ? "windowCenter" : m, b = i.windowWidth, w = b === void 0 ? 550 : b, E = Ht({ height: h, width: w }, p === "windowCenter" ? Tc(w, h) : _c(w, h));
        Ec(r, E, a);
      }, n.handleClick = function(r) {
        return wc(n, void 0, void 0, function() {
          var i, a, d, h, m, p, b, w, E, I;
          return Sc(this, function(O) {
            switch (O.label) {
              case 0:
                return i = this.props, a = i.beforeOnClick, d = i.disabled, h = i.networkLink, m = i.onClick, p = i.url, b = i.openShareDialogOnClick, w = i.opts, E = h(p, w), d ? [
                  2
                  /*return*/
                ] : (r.preventDefault(), a ? (I = a(), kc(I) ? [4, I] : [3, 2]) : [3, 2]);
              case 1:
                O.sent(), O.label = 2;
              case 2:
                return b && this.openShareDialog(E), m && m(r, E), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props;
      n.beforeOnClick;
      var r = n.children, i = n.className, a = n.disabled, d = n.disabledStyle, h = n.forwardedRef;
      n.networkLink;
      var m = n.networkName;
      n.onShareWindowClose, n.openShareDialogOnClick, n.opts;
      var p = n.resetButtonStyle, b = n.style;
      n.url, n.windowHeight, n.windowPosition, n.windowWidth;
      var w = Us(n, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), E = ve("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!a,
        disabled: !!a
      }, i), I = Ht(Ht(p ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, b), a && d);
      return He.createElement("button", Ht({}, w, { "aria-label": w["aria-label"] || m, className: E, onClick: this.handleClick, ref: h, style: I }), r);
    }, t.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, t;
  }(Pa)
), Br = function() {
  return Br = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Br.apply(this, arguments);
};
function Ur(e, t, n, r) {
  function i(a, d) {
    var h = n(a), m = Br({}, a), p = Object.keys(h);
    return p.forEach(function(b) {
      delete m[b];
    }), He.createElement(Cc, Br({}, r, m, { forwardedRef: d, networkName: e, networkLink: t, opts: n(a) }));
  }
  return i.displayName = "ShareButton-".concat(e), $i(i);
}
function Rc(e, t) {
  var n = t.subject, r = t.body, i = t.separator;
  return "mailto:" + Wr({ subject: n, body: r ? r + i + e : e });
}
var Oc = Ur("email", Rc, function(e) {
  return {
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(e, t) {
    window.location.href = t;
  }
}), Qo = Vr({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), Ac = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), jc = (
  /** @class */
  function(e) {
    Ac(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.name = "AssertionError", r;
    }
    return t;
  }(Error)
);
function tr(e, t) {
  if (!e)
    throw new jc(t);
}
function Nc(e, t) {
  var n = t.quote, r = t.hashtag;
  return tr(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + Wr({
    u: e,
    quote: n,
    hashtag: r
  });
}
var es = Ur("facebook", Nc, function(e) {
  return {
    quote: e.quote,
    hashtag: e.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), ts = Vr({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function Pc(e, t) {
  var n = t.title, r = t.summary, i = t.source;
  return tr(e, "linkedin.url"), "https://linkedin.com/shareArticle" + Wr({ url: e, mini: "true", title: n, summary: r, source: i });
}
var ns = Ur("linkedin", Pc, function(e) {
  var t = e.title, n = e.summary, r = e.source;
  return { title: t, summary: n, source: r };
}, {
  windowWidth: 750,
  windowHeight: 600
}), rs = Vr({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function Ic(e, t) {
  var n = t.title, r = t.via, i = t.hashtags, a = i === void 0 ? [] : i, d = t.related, h = d === void 0 ? [] : d;
  return tr(e, "twitter.url"), tr(Array.isArray(a), "twitter.hashtags is not an array"), tr(Array.isArray(h), "twitter.related is not an array"), "https://twitter.com/share" + Wr({
    url: e,
    text: n,
    via: r,
    hashtags: a.length > 0 ? a.join(",") : void 0,
    related: h.length > 0 ? h.join(",") : void 0
  });
}
var is = Ur("twitter", Ic, function(e) {
  return {
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
var Lc;
function Ei() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Lc;
  return t ? e.split(" ").map(function(n) {
    return t[n] || n;
  }).join(" ") : e;
}
var Mc = (typeof window > "u" ? "undefined" : _i(window)) === "object" && window.Element || function() {
};
function Dc(e, t, n) {
  if (!(e[t] instanceof Mc))
    return new Error("Invalid prop `" + t + "` supplied to `" + n + "`. Expected prop to be an instance of Element. Validation failed.");
}
l.oneOfType([l.string, l.func, Dc, l.shape({
  current: l.any
})]);
var Ci = l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
}), l.arrayOf(l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
})]))]), Fc = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Ri() {
  return Ri = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ri.apply(this, arguments);
}
function $c(e, t) {
  if (e == null) return {};
  var n = Bc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Bc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var zc = {
  /** Aria label */
  "aria-label": l.string,
  /** Pass children so this component can wrap them */
  children: l.node,
  /** Add custom class */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Add custom class to list tag */
  listClassName: l.string,
  /** Set a custom element for list tag */
  listTag: Ci,
  /** Set a custom element for this component */
  tag: Ci
};
function qs(e) {
  var t = e.className, n = e.listClassName, r = e.cssModule, i = e.children, a = e.tag, d = a === void 0 ? "nav" : a, h = e.listTag, m = h === void 0 ? "ol" : h, p = e["aria-label"], b = p === void 0 ? "breadcrumb" : p, w = $c(e, Fc), E = Ei(ve(t), r), I = Ei(ve("breadcrumb", n), r);
  return /* @__PURE__ */ He.createElement(d, Ri({}, w, {
    className: E,
    "aria-label": b
  }), /* @__PURE__ */ He.createElement(m, {
    className: I
  }, i));
}
qs.propTypes = zc;
var Hc = ["className", "cssModule", "active", "tag"];
function Oi() {
  return Oi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oi.apply(this, arguments);
}
function Vc(e, t) {
  if (e == null) return {};
  var n = Wc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Wc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Uc = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: l.bool,
  /** Add custom class to the element */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Set a custom element for this component */
  tag: Ci
};
function Ai(e) {
  var t = e.className, n = e.cssModule, r = e.active, i = e.tag, a = i === void 0 ? "li" : i, d = Vc(e, Hc), h = Ei(ve(t, r ? "active" : !1, "breadcrumb-item"), n);
  return /* @__PURE__ */ He.createElement(a, Oi({}, d, {
    className: h,
    "aria-current": r ? "page" : void 0
  }));
}
Ai.propTypes = Uc;
const qc = jt.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, Yc = jt.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Ys = ({
  type: e = "news",
  articleUrl: t,
  publicationDate: n,
  title: r,
  body: i,
  authorEmail: a,
  authorName: d,
  authorPhone: h,
  authorTitle: m,
  breadcrumbs: p,
  calendarUrl: b,
  eventLocation: w,
  eventTime: E,
  headerImageUrl: I,
  registrationUrl: O,
  zoomUrl: k
}) => {
  const N = ve("col", "col-12", {
    "col-lg-8": e === "event" && (O || k || b)
  }), j = () => O ? /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(wn, { color: "maroon", href: O, label: "Register" }) }) : /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(wn, { color: "maroon", href: k, label: "Attend on Zoom" }) }), D = () => /* @__PURE__ */ f.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ f.jsx("div", { className: "author highlight-gold", children: d }),
    m && /* @__PURE__ */ f.jsx("div", { className: "author-title", children: m }),
    a && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a })
    ] }),
    h && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `tel: ${h}`, children: h })
    ] })
  ] }) }), V = () => /* @__PURE__ */ f.jsxs(
    Yc,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author", children: d }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author-title", children: m }),
          (a || h) && /* @__PURE__ */ f.jsxs("div", { className: "event-author-info", children: [
            a && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a }) }),
            h && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `tel: ${h}`, children: h }) })
          ] })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ f.jsx(es, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              Qo,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(is, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              rs,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(Oc, { url: a, quote: r, children: /* @__PURE__ */ f.jsx(
              xc,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(ns, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              ts,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) })
          ] })
        ] })
      ]
    }
  ), W = () => /* @__PURE__ */ f.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ f.jsxs("h4", { children: [
      /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: vt(w) }),
    O && k && /* @__PURE__ */ f.jsx("a", { href: k, children: "Attend on Zoom" })
  ] }), M = (J) => /* @__PURE__ */ f.jsx(
    Ai,
    {
      active: J.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ f.jsx(Ai, { tag: "a", href: J.url, children: J.title })
    },
    J.title
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    I && e !== "event" && /* @__PURE__ */ f.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${I})`
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(qc, { className: `container ${e}-container wrapper-container`, children: [
      p && /* @__PURE__ */ f.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ f.jsx("div", { className: "col col-12", children: /* @__PURE__ */ f.jsx(qs, { listClassName: "breadcrumb", children: p.map((J) => M(J)) }) }) }),
      /* @__PURE__ */ f.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsx("h2", { "data-testid": "title", children: r }) }),
        e === "event" && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (O || k) && j(),
          b && /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(
            wn,
            {
              color: "gray",
              size: "small",
              href: b,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      e === "event" ? /* @__PURE__ */ f.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        E && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ f.jsxs("h4", { children: [
            /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              dangerouslySetInnerHTML: vt(E)
            }
          )
        ] }),
        (O && k || w) && W()
      ] }) : /* @__PURE__ */ f.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ f.jsx(es, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            Qo,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(is, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            rs,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(ns, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            ts,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) })
        ] }),
        n && /* @__PURE__ */ f.jsx("i", { className: "news-date", children: n })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: vt(i),
          "data-testid": "body"
        }
      ) }),
      e === "news" && D(),
      e === "event" && V()
    ] })
  ] });
};
Ys.propTypes = {
  /**
   * Type of article
   */
  type: l.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: l.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: l.string.isRequired,
  /**
   * Title
   */
  title: l.string.isRequired,
  /**
   * Body content for the article
   */
  body: l.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: l.string,
  /**
   * Article author full name
   */
  authorName: l.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: l.string,
  /**
   * Article author title
   */
  authorTitle: l.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: l.arrayOf(
    l.shape({
      title: l.string,
      url: l.string,
      active: l.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: l.string,
  /**
   * Article image
   */
  headerImageUrl: l.string,
  /**
   * Event location
   */
  eventLocation: l.string,
  /**
   * Event time
   */
  eventTime: l.string,
  /**
   * URL for a registation button
   */
  registrationUrl: l.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: l.string
};
const Xc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Yi = ({
  color: e = "gray",
  icon: t = void 0,
  innerRef: n = void 0,
  onClick: r = void 0,
  size: i = "small",
  cardTitle: a = "",
  className: d,
  gaData: h,
  ...m
}) => {
  const p = () => {
    r == null || r();
  };
  return /* @__PURE__ */ f.jsx(
    Xe,
    {
      gaData: {
        ...Xc,
        section: a,
        // @deprecated - remove at some point
        ...h,
        text: `${t == null ? void 0 : t[1]} icon`
      },
      children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${e} ${i === "large" && "btn-circle-large"} ${d}`,
          ref: n,
          "aria-label": "Close",
          onClick: p,
          ...m,
          children: /* @__PURE__ */ f.jsx("i", { className: `${t == null ? void 0 : t[0]} fa-${t == null ? void 0 : t[1]}` })
        }
      )
    }
  );
};
Yi.propTypes = {
  /**
    Color the button based on the background color
  */
  color: l.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    Button size
  */
  size: l.oneOf(["large", "small"]),
  className: l.string
};
const Gc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Xi = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  color: i = "gray",
  disabled: a,
  element: d = "button",
  innerRef: h,
  href: m,
  onClick: p,
  ...b
}) => {
  const w = ve("btn", "btn-tag", {
    "btn-tag-alt-white": i === "white",
    "btn-tag-alt-gray": i === "gray",
    "btn-tag-alt-dark": i === "dark",
    disabled: a
  });
  let E = d;
  return m && d === "button" && (E = "a"), /* @__PURE__ */ f.jsx(
    Xe,
    {
      gaData: {
        ...Gc,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsx(
        E,
        {
          type: E === "button" && p ? "button" : void 0,
          ...b,
          className: w,
          href: m,
          ref: h,
          onClick: p,
          "aria-label": r,
          children: e
        }
      )
    }
  );
};
Xi.propTypes = {
  /**
    Button tag label
  */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Hi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Button background color
  */
  color: l.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func
};
const Sn = ({
  src: e,
  alt: t,
  cssClasses: n,
  loading: r = "lazy",
  decoding: i = "async",
  dataTestId: a,
  fetchPriority: d = "auto",
  width: h,
  height: m,
  cardLink: p,
  title: b,
  caption: w,
  captionTitle: E,
  border: I,
  dropShadow: O
}) => {
  const k = {
    src: e,
    alt: t,
    loading: r,
    decoding: i,
    fetchpriority: d,
    // React attribute bug workaround
    ...(n == null ? void 0 : n.length) > 0 && { className: Ar(n) },
    ...a && { "data-testid": a },
    ...h && { width: h },
    ...m && { height: m }
  }, N = ve("uds-img", {
    borderless: !I,
    "uds-img-drop-shadow": O
  }), j = (V) => {
    const W = V ? `${k.className} ${V}` : k.className;
    return p ? /* @__PURE__ */ f.jsxs("a", { href: p, children: [
      /* @__PURE__ */ f.jsx("img", { ...k, className: W }),
      /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: b })
    ] }) : /* @__PURE__ */ f.jsx("img", { ...k, className: W });
  }, D = () => /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    j(),
    w && /* @__PURE__ */ f.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      E && /* @__PURE__ */ f.jsx("h3", { children: E }),
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: vt(w)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: w ? D() : j(N) });
};
Sn.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: l.string.isRequired,
  /**
   * Image alt text
   */
  alt: l.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: l.arrayOf(l.string),
  /**
   * Image loading mode
   */
  loading: l.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: l.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: l.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: l.string,
  /**
   * Height of the image
   */
  height: l.string,
  dataTestId: l.string,
  cardLink: l.string,
  title: l.string,
  caption: l.string,
  captionTitle: l.string,
  border: l.bool,
  dropShadow: l.bool
};
const Kc = jt.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, Zc = (e) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e), Jc = (e) => !e.startsWith("https://") && !e.startsWith("http://") && Zc(e) ? `mailto:${e}` : e, Qc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Vt = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r,
  imageAltText: i,
  title: a,
  icon: d,
  body: h,
  eventFormat: m = "stack",
  eventLocation: p,
  eventTime: b,
  buttons: w,
  linkLabel: E,
  linkUrl: I,
  tags: O,
  showBorders: k = !0,
  cardLink: N
}) => /* @__PURE__ */ f.jsx(
  Xs,
  {
    type: e,
    width: t,
    horizontal: n,
    image: r,
    imageAltText: i,
    title: a,
    icon: d,
    body: h,
    eventFormat: m,
    eventLocation: p,
    eventTime: b,
    buttons: w,
    linkLabel: E,
    linkUrl: I,
    tags: O,
    showBorders: k,
    cardLink: N
  }
);
Vt.propTypes = {
  /**
   * Type of card
   */
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: l.bool,
  /**
   * Card title
   */
  title: l.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * Card body content
   */
  body: l.string,
  /**
   * Event info format
   */
  eventFormat: l.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: l.string,
  /**
   * Event start time
   */
  eventTime: l.string,
  /**
   * Card header image
   */
  image: l.string,
  /**
   * Card header image alt text
   */
  imageAltText: l.string,
  /**
   * Buttons
   */
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  /**
   * Tags
   */
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: l.bool,
  /**
   * Card link
   */
  cardLink: l.string
};
const Xs = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r = "",
  imageAltText: i = "",
  title: a,
  icon: d = void 0,
  body: h = "",
  eventFormat: m = "stack",
  eventLocation: p = "",
  eventTime: b = "",
  buttons: w = void 0,
  linkLabel: E = void 0,
  linkUrl: I = void 0,
  tags: O = void 0,
  showBorders: k = !0,
  cardLink: N
}) => {
  const j = ve("card", "cards-components", {
    "card-degree": e === "degree",
    "card-event": e === "event",
    "card-story": e === "story",
    [`w-${t.replace("%", "")}`]: t !== "100%",
    "card-horizontal": n,
    borderless: !k
  });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs(Kc, { className: j, "data-testid": "card-container", children: [
    !!r && /* @__PURE__ */ f.jsx(
      Sn,
      {
        src: r,
        alt: i,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        cardLink: N,
        title: a
      }
    ),
    !r && d && /* @__PURE__ */ f.jsx(
      "i",
      {
        className: `${d == null ? void 0 : d[0]} fa-${d == null ? void 0 : d[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    n ? /* @__PURE__ */ f.jsx("div", { className: "card-content-wrapper", children: /* @__PURE__ */ f.jsx(
      ji,
      {
        type: e,
        body: h,
        eventFormat: m,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: w,
        linkLabel: E,
        linkUrl: I,
        tags: O,
        cardLink: N
      }
    ) }) : /* @__PURE__ */ f.jsx(
      ji,
      {
        type: e,
        body: h,
        eventFormat: m,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: w,
        linkLabel: E,
        linkUrl: I,
        tags: O,
        cardLink: N
      }
    )
  ] }) });
};
Xs.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: l.bool,
  title: l.string.isRequired,
  icon: l.arrayOf(l.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  image: l.string,
  imageAltText: l.string,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  showBorders: l.bool,
  cardLink: l.string
};
const ji = ({
  type: e = "default",
  body: t = "",
  eventFormat: n = "stack",
  eventLocation: r = "",
  eventTime: i = "",
  title: a,
  buttons: d = void 0,
  linkLabel: h = void 0,
  linkUrl: m = void 0,
  tags: p = void 0,
  cardLink: b
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  !!a && /* @__PURE__ */ f.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ f.jsx("h3", { className: "card-title", children: b ? /* @__PURE__ */ f.jsx("a", { href: b, children: a }) : a }) }),
  !!t && /* @__PURE__ */ f.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: vt(t) }) }),
  e === "event" && (i || r) && /* @__PURE__ */ f.jsx(
    Gs,
    {
      eventFormat: n,
      eventTime: i,
      eventLocation: r
    }
  ),
  d && /* @__PURE__ */ f.jsx("div", { className: "card-buttons", children: d.map((w) => /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "card-button",
      "data-testid": "card-button",
      children: /* @__PURE__ */ f.jsx(
        wn,
        {
          ariaLabel: w.ariaLabel,
          color: w.color,
          icon: w.icon,
          href: w.href,
          label: w.label,
          onClick: w.onClick,
          size: w.size,
          target: w.target,
          cardTitle: a
        }
      )
    },
    `${w.label}-${w.href}`
  )) }),
  m && h && /* @__PURE__ */ f.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ f.jsx(
    Xe,
    {
      gaData: {
        ...Qc,
        section: a,
        text: h
      },
      children: /* @__PURE__ */ f.jsx("a", { href: Jc(m), children: h })
    }
  ) }),
  p && /* @__PURE__ */ f.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: p.map((w) => (
    // @ts-ignore
    /* @__PURE__ */ f.jsx(
      Xi,
      {
        ariaLabel: w.ariaLabel,
        color: w.color,
        href: w.href,
        label: w.label,
        onClick: w.onClick,
        cardTitle: a
      },
      `${w.label}-${w.href}`
    )
  )) })
] });
ji.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  title: l.string.isRequired,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  cardLink: l.string
};
const Gs = ({
  eventFormat: e = "stack",
  eventLocation: t = "",
  eventTime: n = ""
}) => e === "inline" ? /* @__PURE__ */ f.jsxs("div", { className: "card-event-details", children: [
  n && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: vt(n) })
  ] }),
  t && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: vt(t)
      }
    )
  ] })
] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  n && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: vt(n) })
  ] }) }),
  t && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx("span", { children: /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: vt(t)
      }
    ) })
  ] }) })
] });
Gs.propTypes = {
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string
};
const os = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, ss = {
  OPEN: "open",
  CLOSE: "close"
}, eu = {
  SMALL: "small"
}, Ks = (e) => e === eu.SMALL, Zs = ({ imageSize: e, body: t, heading: n, readMoreLink: r }) => {
  const [i, a] = Je(!1), d = Fi(), { isReact: h, isBootstrap: m } = kn(), p = `info-layer-${d}`, b = Ks(e), w = (E) => {
    (E.type === "click" || E.key === "Enter" || E.key === " ") && a(!i);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: ve("info-layer", { show: i }),
      "data-testid": "info-layer",
      id: p,
      children: /* @__PURE__ */ f.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            className: ve("header", {
              closed: b && !i
            }),
            children: [
              b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: vt(t) }),
              /* @__PURE__ */ f.jsx(
                Xe,
                {
                  gaData: {
                    ...os,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: i ? ss.OPEN : ss.CLOSE,
                    section: n
                  },
                  children: /* @__PURE__ */ f.jsxs(
                    "button",
                    {
                      "data-bs-toggle": m && "collapse",
                      "data-bs-target": m && `#${p}`,
                      onClick: h && w,
                      className: ve("btn-expand", {
                        btn: b
                      }),
                      type: "button",
                      "aria-expanded": i,
                      "aria-controls": p,
                      children: [
                        b ? /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }) : /* @__PURE__ */ f.jsx("h4", { children: n }),
                        /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: vt(t) }),
        r && /* @__PURE__ */ f.jsx(
          Xe,
          {
            gaData: {
              ...os,
              section: n,
              text: "read more"
            },
            children: /* @__PURE__ */ f.jsxs("a", { href: r, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }),
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Zs.propTypes = {
  imageSize: l.oneOf(["small", "large"]),
  body: l.string.isRequired,
  heading: l.string.isRequired,
  readMoreLink: l.string
};
const Gi = ({
  imageSize: e = "large",
  image: t,
  imageAlt: n,
  heading: r,
  body: i,
  readMoreLink: a = "",
  citation: d
}) => {
  const h = Ks(e);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("card-ranking", {
        "large-image": !h,
        "small-image": h
      }),
      children: [
        h ? /* @__PURE__ */ f.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ f.jsx(Sn, { src: t, alt: n, fetchPriority: "high" }) }) : /* @__PURE__ */ f.jsx(Sn, { src: t, alt: n, fetchPriority: "high" }),
        h && /* @__PURE__ */ f.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ f.jsx("h4", { children: r }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            "— ",
            d
          ] })
        ] }),
        /* @__PURE__ */ f.jsx(
          Zs,
          {
            imageSize: e,
            body: i,
            heading: r,
            readMoreLink: a
          }
        )
      ]
    }
  );
};
Gi.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: l.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: l.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: l.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: l.string.isRequired,
  /**
   * Ranking card body content
   */
  body: l.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: l.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: l.string
};
const tu = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Js = ({ cards: e, cardType: t = "card", columns: n }) => {
  if (!e || e.length === 0)
    return null;
  let r;
  switch (t) {
    case "ranking":
      r = Gi;
      break;
    case "image":
      r = Sn;
      break;
    default:
      r = Vt;
      break;
  }
  const i = tu[n] || "col-12 col-md-auto";
  return /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "card-arrangement", children: e.map((a, d) => /* @__PURE__ */ f.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${a.horizontal ? "col-12 col-md-6" : i} mb-4`,
      children: /* @__PURE__ */ f.jsx(r, { ...a })
    },
    d
  )) });
};
Js.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: l.arrayOf(l.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: l.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: l.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const nu = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Qs = ({
  backgroundImage: e,
  icon: t,
  title: n,
  highlightText: r,
  description: i,
  button: a
}) => {
  const d = () => {
    if (!t) return null;
    let h = "";
    return Array.isArray(t) ? h = t.join(" ") : h = t.includes(" ") ? t : `fas fa-${t}`, /* @__PURE__ */ f.jsx("i", { className: h, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ f.jsx(
        "img",
        {
          src: e,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-content", children: [
      t && /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-icon", children: d() }),
      /* @__PURE__ */ f.jsxs("h2", { className: "content-spotlight-title", children: [
        n,
        r && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          n && r && /* @__PURE__ */ f.jsx("br", {}),
          /* @__PURE__ */ f.jsx("span", { className: "highlight", children: r })
        ] })
      ] }),
      i && /* @__PURE__ */ f.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: vt(i)
        }
      ),
      a && /* @__PURE__ */ f.jsx(
        Xe,
        {
          gaData: {
            ...nu,
            text: a.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ f.jsx(
            "a",
            {
              href: a.href,
              className: `btn ${a.color ? `btn-${a.color}` : "btn-gold"}`,
              children: a.label
            }
          )
        }
      )
    ] })
  ] });
};
Qs.propTypes = {
  backgroundImage: l.string.isRequired,
  icon: l.oneOfType([
    l.string,
    l.arrayOf(l.string)
  ]),
  title: l.node.isRequired,
  highlightText: l.string,
  description: l.string,
  button: l.shape({
    label: l.string.isRequired,
    href: l.string.isRequired,
    color: l.string
  })
};
var ru = /* @__PURE__ */ ((e) => (e.COPY = "copy", e))(ru || {});
const iu = ({ type: e }) => e == "copy" ? /* @__PURE__ */ f.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ f.jsx("hr", {}), ou = jt.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, su = () => /* @__PURE__ */ f.jsxs(ou, { children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] }), au = jt.section``, lu = Ia(null), cu = ({
  defaultProps: e,
  dataSource: t,
  noFeedText: n,
  renderHeader: r,
  renderBody: i,
  dataTransformer: a,
  dataFilter: d,
  maxItems: h
}) => {
  const [{ data: m, loading: p, error: b }, w] = za(), [E, I] = Je([]), O = { ...e.dataSource, ...t };
  return lt(() => {
    w(O == null ? void 0 : O.url);
  }, [O == null ? void 0 : O.url]), lt(() => {
    const k = m == null ? void 0 : m.nodes.map(a), N = k == null ? void 0 : k.filter(
      (j) => d(j, t == null ? void 0 : t.filters)
    );
    I(h ? N == null ? void 0 : N.slice(0, h) : N);
  }, [m]), // Init the context to be used on its childrens
  /* @__PURE__ */ f.jsx(lu.Provider, { value: { feeds: E }, children: /* @__PURE__ */ f.jsxs(au, { children: [
    r,
    b ? /* @__PURE__ */ f.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      p && !(E != null && E.length) && /* @__PURE__ */ f.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ f.jsx(su, {}) }),
      E != null && E.length ? i : !p && /* @__PURE__ */ f.jsx("p", { className: "text-center", children: n })
    ] })
  ] }) });
};
cu.propTypes = {
  renderHeader: l.element,
  renderBody: l.element,
  maxItems: l.number,
  dataTransformer: l.func,
  dataFilter: l.func,
  noFeedText: l.string
};
const ea = l.shape({
  color: l.oneOf(["white", "dark"]),
  text: l.string
}), ta = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string
}), zd = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string,
  size: l.string
}), uu = l.shape({
  url: l.string,
  filters: l.string
}), du = l.shape({
  header: ea,
  ctaButton: ta,
  dataSource: uu,
  maxItems: l.number
}), fu = jt.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, pu = ({
  defaultProps: e,
  header: t,
  ctaButton: n
}) => {
  const r = { ...e.header, ...t }, i = { ...e.ctaButton, ...n }, a = r.tag || "h2", d = a !== "h2", h = `text-${r.color} ${d ? "h2" : ""}`.trim();
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ f.jsx(a, { className: h, children: r.text }) }),
        /* @__PURE__ */ f.jsx(fu, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ f.jsx(
          Xe,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: r.text,
              text: i.text
            },
            children: /* @__PURE__ */ f.jsx("a", { className: `btn btn-${i.color}`, href: i.url, children: i.text })
          }
        ) })
      ]
    }
  );
};
pu.propTypes = {
  defaultProps: du,
  header: ea,
  ctaButton: ta
};
const hu = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ f.jsx("div", { className: "col", children: e }) });
hu.propTypes = {
  children: l.element
};
const mu = jt.img`
  width: 100%;
`;
function gu({ image: e, title: t, contents: n }) {
  return console.log({ image: e, title: t, contents: n }), /* @__PURE__ */ f.jsx("div", { children: "TODO: to be implemented" });
}
function vu({
  image: e,
  subTitle: t,
  title: n,
  contents: r,
  contentsColor: i
}) {
  const a = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, d = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, h = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("uds-hero", {
        [a[e == null ? void 0 : e.size]]: e == null ? void 0 : e.size
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ f.jsx(
          mu,
          {
            className: "hero",
            src: e == null ? void 0 : e.url,
            alt: e == null ? void 0 : e.altText,
            "data-testid": "hero-image"
          }
        ),
        t && /* @__PURE__ */ f.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: ve({
              [h[t.color]]: t.color,
              [d[t.highlightColor]]: t.highlightColor
            }),
            children: t.text
          }
        ) }),
        n && /* @__PURE__ */ f.jsx("h1", { style: { maxWidth: n.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: ve({
              [h[n.color]]: n.color,
              [d[n.highlightColor]]: n.highlightColor
            }),
            children: n.text
          }
        ) }),
        r && /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: ve("content", {
              [h[i]]: i
            }),
            children: r.map((m, p) => /* @__PURE__ */ f.jsx("p", { children: m.text }, `content-${p}`))
          }
        )
      ]
    }
  );
}
const na = (e) => {
  const t = e.type || "heading-hero";
  return {
    "heading-hero": () => vu(e),
    "story-hero": () => gu(e),
    undefined: () => (console.error(
      `the type '${t}' is not supported by the 'Hero' component.`
    ), null)
  }[t]();
};
na.propTypes = {
  type: l.oneOf(["heading-hero", "story-hero"]),
  image: hl,
  title: pi,
  subTitle: pi,
  contents: l.arrayOf(pi),
  contentsColor: l.string
};
const Ot = ({
  dataId: e,
  isClickeable: t = !1,
  disabled: n = !1,
  pageLinkIcon: r = !1,
  selectedPage: i = !1,
  onClick: a = () => {
  },
  ellipses: d,
  ariaLabel: h,
  children: m,
  ariaDisabled: p
}) => /* @__PURE__ */ f.jsx(
  "li",
  {
    className: ve("page-item", {
      disabled: n,
      active: i,
      elipses: d
    }),
    children: t ? /* @__PURE__ */ f.jsxs(
      "button",
      {
        type: "button",
        "aria-label": h,
        className: ve("page-link", {
          "page-link-icon": r
        }),
        onClick: a,
        "data-testid": e ? `pagination-${e}` : "page-link",
        "data-id": e,
        "aria-current": i ? "page" : null,
        "aria-disabled": p,
        children: [
          m,
          i && /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ f.jsx("span", { className: "page-link", "data-testid": "page-link", children: m })
  }
);
Ot.propTypes = {
  isClickeable: l.bool,
  disabled: l.bool,
  pageLinkIcon: l.bool,
  selectedPage: l.bool,
  dataId: l.string,
  onClick: l.func,
  children: l.node,
  ellipses: l.bool,
  ariaLabel: l.string,
  ariaDisabled: l.bool
};
const yu = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, ra = ({
  type: e,
  background: t,
  currentPage: n = 1,
  totalPages: r = 10,
  onChange: i
}) => {
  const [a, d] = Je(null);
  lt(() => {
    d(n);
  }, [n]);
  const h = (b) => {
    Ts({ ...yu, text: `page ${b}` });
  }, m = (b, w) => {
    const I = {
      first: 1,
      prev: a === 1 ? 1 : a - 1,
      next: a === r ? r : a + 1,
      last: r
    }[w] ?? w;
    d(I), h(I), i == null || i(b, I);
  }, p = () => {
    if (r < 5)
      return /* @__PURE__ */ f.jsx(f.Fragment, { children: Array.from({ length: r }, (N, j) => {
        const D = j + 1;
        return /* @__PURE__ */ f.jsx(
          Ot,
          {
            ariaLabel: `Page ${D} of ${r}`,
            isClickeable: !0,
            selectedPage: a === D,
            onClick: (V) => m(V, D),
            children: D
          },
          D
        );
      }) });
    const b = 2, w = To(
      a === r - 1,
      1,
      a === r ? 2 : 1
    ), E = To(
      a === 1,
      2,
      1
    ), I = Lo(
      a - w,
      a,
      r
    ), O = Lo(
      a,
      a + 1 + E,
      r
    ), k = [...I, ...O];
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      k[0] !== 1 && /* @__PURE__ */ f.jsx(
        Ot,
        {
          ariaLabel: `Page 1 of ${r}`,
          isClickeable: !0,
          selectedPage: a === 1,
          onClick: (N) => m(N, "first"),
          children: "1"
        }
      ),
      a > r - b && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${r}`,
          selectedPage: a === 2,
          onClick: (N) => m(N, 2),
          children: "2"
        }
      ),
      k[0] > 2 && /* @__PURE__ */ f.jsx(Ot, { ellipses: !0, children: "..." }),
      k.map((N) => /* @__PURE__ */ f.jsx(
        Ot,
        {
          ariaLabel: `Page ${N} of ${r}`,
          isClickeable: !0,
          selectedPage: a === N,
          onClick: (j) => m(j, N),
          children: N
        },
        N
      )),
      k[k.length - 1] < r - 1 && /* @__PURE__ */ f.jsx(Ot, { ellipses: !0, children: "..." }),
      a < b + 1 && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r - 1} of ${r}`,
          selectedPage: a === r - 1,
          onClick: (N) => m(N, r - 1),
          children: r - 1
        }
      ),
      k[k.length - 1] !== r && /* @__PURE__ */ f.jsx(
        Ot,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r} of ${r}`,
          selectedPage: a === r,
          onClick: (N) => m(N, "last"),
          children: r
        }
      )
    ] });
  };
  return /* @__PURE__ */ f.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ f.jsxs(
    "ul",
    {
      className: ve(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: e === "bordered",
          "uds-bg-gray1": t === "gray1",
          "uds-bg-gray": t === "gray2",
          "uds-bg-dark": t === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ f.jsx(
          Ot,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: a === 1,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "prev"),
            ariaDisabled: a === 1,
            ariaLabel: "Previous Page"
          }
        ),
        p(),
        /* @__PURE__ */ f.jsx(
          Ot,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: a === r,
            disabled: a === r,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
ra.propTypes = {
  /**
   * Type of pagination
   */
  type: l.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: l.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: l.number,
  /**
   * Total number of pages
   */
  totalPages: l.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: l.func.isRequired
};
var xu = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e))(xu || {});
const bu = ({
  type: e,
  dismissable: t,
  children: n
}) => {
  var p, b, w;
  const { isBootstrap: r, isReact: i } = kn(), [a, d] = Je(!0), h = () => d(!1), m = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return a && /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("alert", {
        "alert-dismissable": t,
        [`alert-${(p = m[e]) == null ? void 0 : p.alertClass}`]: e
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            title: (b = m[e]) == null ? void 0 : b.iconTitle,
            className: `fa fa-icon fa-${(w = m[e]) == null ? void 0 : w.iconName}`
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "alert-content", children: n }),
        t && /* @__PURE__ */ f.jsx("div", { className: "alert-close", children: /* @__PURE__ */ f.jsx(
          Yi,
          {
            icon: ["fas", "times"],
            onClick: i && h,
            "data-bs-dismiss": r && "alert"
          }
        ) })
      ]
    }
  );
}, wu = jt.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, ia = ({ gaData: e, hidePrev: t, hideNext: n, slideNav: r }) => {
  const { isReact: i, isBootstrap: a } = kn();
  return /* @__PURE__ */ f.jsxs(wu, { children: [
    (!t || a) && /* @__PURE__ */ f.jsx(Xe, { gaData: { ...e, text: "left chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: i && (() => r(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!n || a) && /* @__PURE__ */ f.jsx(Xe, { gaData: { ...e, text: "right chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: i && (() => r(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
ia.propTypes = {
  gaData: l.object,
  hidePrev: l.bool,
  hideNext: l.bool,
  slideNav: l.func.isRequired
};
const oa = $i(function(t, n) {
  const {
    id: r,
    selected: i,
    title: a,
    selectTab: d,
    leftKeyPressed: h,
    rightKeyPressed: m,
    icon: p,
    gaData: b
  } = t, { isReact: w, isBootstrap: E } = kn(), I = on(null);
  La(n, () => ({
    focus() {
      I.current.focus();
    },
    scrollIntoView() {
      var j, D, V, W, M, J, se;
      const k = ((j = I.current) == null ? void 0 : j.offsetWidth) / 2 + I.current.offsetLeft, N = ((V = (D = I.current) == null ? void 0 : D.offsetParent) == null ? void 0 : V.scrollLeft) + ((M = (W = I.current) == null ? void 0 : W.offsetParent) == null ? void 0 : M.offsetWidth) / 2;
      (se = (J = I.current) == null ? void 0 : J.offsetParent) == null || se.scrollBy({
        left: k - N
      });
    }
  }), []);
  const O = (k) => {
    k.keyCode === 37 ? (k.preventDefault(), h()) : k.keyCode === 39 && (k.preventDefault(), m());
  };
  return /* @__PURE__ */ f.jsx(Xe, { gaData: { ...b, text: a }, children: /* @__PURE__ */ f.jsxs(
    "a",
    {
      ref: I,
      className: `nav-item nav-link ${i ? "active" : ""}`,
      id: r,
      href: `#nav-${r}`,
      role: "tab",
      "aria-controls": `nav-${r}`,
      "aria-selected": i,
      "data-bs-toggle": E && "tab",
      onClick: w && ((k) => d(k, r, a)),
      onKeyDown: w && O,
      tabIndex: i ? "" : "-1",
      children: [
        a,
        " ",
        p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` })
      ]
    }
  ) });
});
oa.propTypes = {
  gaData: l.object,
  id: l.string.isRequired,
  selected: l.bool.isRequired,
  title: l.string.isRequired,
  selectTab: l.func.isRequired,
  leftKeyPressed: l.func.isRequired,
  rightKeyPressed: l.func.isRequired,
  icon: l.arrayOf(l.string)
};
function Su() {
  const e = on({}), t = jn(
    (n) => (r) => {
      e.current[n] = r;
    },
    []
  );
  return [e, t];
}
const ku = ({ id: e, bgColor: t, selected: n, children: r }) => {
  const { isBootstrap: i } = kn();
  return n || i ? /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `tab-pane fade show ${n ? "show active" : ""} ${t === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${e}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${e}-tab`,
      children: r
    }
  ) : null;
};
ku.propTypes = {
  id: l.string.isRequired,
  bgColor: l.string,
  selected: l.bool,
  children: l.oneOfType([l.array, l.element])
};
const sa = ({
  initialTab: e = "",
  children: t,
  bgColor: n = "",
  onTabChange: r = (i) => {
  }
}) => {
  var ke, ye;
  const i = He.Children.toArray(t), a = on(!1), [d, h] = Je(
    e && e !== "null" ? e : ((ye = (ke = i[0]) == null ? void 0 : ke.props) == null ? void 0 : ye.id) || ""
  ), m = on(null), [p, b] = Su(), [w, E] = Je(0), [I, O] = Je(), k = jn(() => {
    var Q, he;
    O(
      ((Q = m.current) == null ? void 0 : Q.scrollWidth) - ((he = m.current) == null ? void 0 : he.offsetWidth)
    );
  }, []), N = jn(() => {
    var Q;
    E((Q = m.current) == null ? void 0 : Q.scrollLeft);
  }, []), j = jn(() => {
    yi(N, 150), xi(N, 150);
  }, [N]), D = jn(() => {
    yi(k, 150), xi(k, 150);
  }, [k]);
  if (lt(() => {
    const Q = m.current;
    return Q && (Q.addEventListener("scroll", j), N()), () => {
      Q && Q.removeEventListener("scroll", j);
    };
  }, [I, j, N]), lt(() => (window.addEventListener("resize", D), k(), () => {
    window.removeEventListener("resize", D);
  }), [D, k]), lt(() => {
    p.current[d] && p.current[d].scrollIntoView();
  }, [d, p]), lt(() => {
    a.current && e && e !== "null" && d !== e && h(e);
  }, [e, d]), lt(() => {
    a.current = !0;
  }, []), i.length === 0)
    return null;
  const V = (Q) => {
    var he;
    r(Q), (he = p.current[Q]) == null || he.focus(), h(Q);
  }, W = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, M = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, J = i.map((Q) => He.cloneElement(Q, {
    bgColor: n,
    selected: d === Q.props.id
  })), se = (Q) => {
    const he = m.current, Ne = he.scrollWidth - he.clientWidth;
    let $e = he.scrollLeft + 200 * Q;
    $e = Math.max(0, Math.min(Ne, $e)), he.scrollTo({
      left: $e,
      behavior: "smooth"
    });
  }, Oe = (Q, he, Ne) => {
    Q.preventDefault(), V(he);
  }, Fe = (Q = !0) => {
    const he = i.length, Ne = Q ? 1 : -1, dt = i.findIndex((Be) => Be.props.id === d), $e = i[(he + dt + Ne) % he].props.id;
    V($e);
  };
  let Ve = "uds-tabbed-panels";
  return n === "bg-dark" && (Ve += " uds-tabbed-panels-dark"), /* @__PURE__ */ f.jsxs("div", { className: n, children: [
    /* @__PURE__ */ f.jsxs("nav", { className: Ve, children: [
      /* @__PURE__ */ f.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: m, children: i.map((Q, he) => /* @__PURE__ */ f.jsx(
        oa,
        {
          ref: b(Q.props.id),
          id: Q.props.id,
          title: Q.props.title,
          selected: d === Q.props.id,
          gaData: M,
          selectTab: Oe,
          leftKeyPressed: () => Fe(!1),
          rightKeyPressed: () => Fe(),
          icon: Q.props.icon,
          index: he
        },
        Q.props.id
      )) }),
      /* @__PURE__ */ f.jsx(
        ia,
        {
          hidePrev: w <= 0,
          hideNext: w >= I,
          gaData: W,
          slideNav: se
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: J
      }
    )
  ] });
};
sa.propTypes = {
  initialTab: l.string,
  children: l.arrayOf(l.element).isRequired,
  bgColor: l.string,
  onTabChange: l.func
};
const Ki = ({ imageSource: e, imageAltText: t, quote: n, itemStyle: r = {} }) => {
  var i, a;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${e ? "with-image" : ""} ${Ar(r.containerCssClass)}`,
      children: [
        e && /* @__PURE__ */ f.jsx(
          Sn,
          {
            src: e,
            alt: t,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ f.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ f.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ f.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          n.title && /* @__PURE__ */ f.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ f.jsx("span", { className: Ar(r.titleCssClass), children: n.title }) }),
          n.content && /* @__PURE__ */ f.jsx(
            "p",
            {
              className: Ar(r.contentCssClass),
              "data-testid": "testimonial-content",
              children: n.content
            }
          ),
          (!!((i = n.cite) != null && i.name) || !!((a = n.cite) != null && a.description)) && /* @__PURE__ */ f.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ f.jsx("cite", { className: "name", children: n.cite.name }),
            n.cite && /* @__PURE__ */ f.jsx("cite", { className: "description", children: n.cite.description })
          ] })
        ] })
      ]
    }
  );
};
Ki.propTypes = {
  quote: l.shape({
    title: l.string,
    content: l.string,
    cite: l.shape({
      name: l.string,
      description: l.string
    })
  }).isRequired,
  imageSource: l.string,
  imageAltText: l.string,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  })
};
let Tu = 0;
const _u = ({
  title: e,
  content: t,
  triggerElement: n
}) => {
  const [r] = Je(`tooltip-${Tu++}`), i = on(null);
  return /* @__PURE__ */ f.jsxs("span", { className: "uds-tooltip-container", children: [
    He.cloneElement(n, {
      ref: i,
      "aria-describedby": r,
      tabindex: 0
    }),
    /* @__PURE__ */ f.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: r, children: [
      e && /* @__PURE__ */ f.jsx("span", { className: "uds-tooltip-heading", children: e }),
      t
    ] })
  ] });
}, Eu = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, Cu = ({
  url: e = "",
  vttUrl: t,
  caption: n,
  title: r = "",
  className: i,
  controls: a = !0
}) => {
  const d = on(null);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve(`uds-video-container ${i}`, {
        "uds-video-with-caption": n
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ f.jsx(Xe, { gaData: { ...Eu, section: r }, children: /* @__PURE__ */ f.jsxs(
          "video",
          {
            ref: d,
            title: r,
            playsInline: !0,
            controls: a || !0,
            children: [
              /* @__PURE__ */ f.jsx("source", { src: e }),
              /* @__PURE__ */ f.jsx(
                "track",
                {
                  src: t,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        n && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: n }) })
      ]
    }
  );
}, Ru = ({ title: e = "", caption: t, url: n = "", className: r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: ve(`uds-video-container ${r}`, {
      "uds-video-with-caption": t
    }),
    children: [
      /* @__PURE__ */ f.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ f.jsx("iframe", { title: e, src: n }) }),
      t && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: t }) })
    ]
  }
), aa = (e) => {
  const {
    type: t = "video",
    url: n = "",
    vttUrl: r,
    title: i = "",
    caption: a,
    className: d,
    controls: h = !0
  } = e;
  return t === "youtube" ? Ru({ url: n, title: i, caption: a, className: d }) : Cu({
    url: n,
    vttUrl: r,
    title: i,
    caption: a,
    className: d,
    controls: h
  });
};
aa.propTypes = {
  type: l.oneOf(["video", "youtube"]),
  url: l.string,
  vttUrl: l.string,
  title: l.string,
  className: l.string,
  caption: l.string,
  controls: l.bool
};
const Ou = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, Zi = ({ children: e }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (t) => t.stopPropagation(),
    onKeyDown: (t) => t.stopPropagation(),
    children: e
  }
);
Zi.propTypes = {
  children: l.oneOfType([
    l.element,
    l.arrayOf(l.element)
  ]).isRequired
};
const la = ({ buttonCount: e }) => {
  const t = [];
  for (let n = 0; n < e; n += 1)
    t.push(
      /* @__PURE__ */ f.jsx(Xe, { gaData: Ou, children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${n}`,
          "aria-label": `Slide view ${n + 1}`
        }
      ) }, `bullet-${n}`)
    );
  return /* @__PURE__ */ f.jsx(Zi, { children: t });
};
la.propTypes = {
  buttonCount: l.number.isRequired
};
const ca = ({ imageItems: e, onItemClick: t = () => null }) => {
  const n = (i, a) => {
    const { ariaSelected: d } = i.currentTarget.dataset;
    i.currentTarget.dataset.ariaSelected = String(!d), i.stopPropagation(), t(a);
  }, r = e.map((i, a) => /* @__PURE__ */ f.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${a}`,
      "aria-label": `Slide view ${a + 1}`,
      "aria-selected": "false",
      onClick: (d) => n(d, a),
      onKeyDown: (d) => n(d, a),
      children: /* @__PURE__ */ f.jsx(
        "img",
        {
          src: i,
          alt: `Slide ${a + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${a}`
  ));
  return /* @__PURE__ */ f.jsx(Zi, { children: r });
};
ca.propTypes = {
  imageItems: l.arrayOf(l.string).isRequired,
  onItemClick: l.func
};
const Ji = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
Ji.propTypes = {
  onClick: l.func
};
const Qi = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
Qi.propTypes = {
  onClick: l.func
};
const as = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, eo = ({ children: e = null }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: e
  }
);
eo.propTypes = {
  children: l.arrayOf(l.element)
};
const ua = ({ onClick: e = () => null, children: t = null }) => /* @__PURE__ */ f.jsxs(eo, { children: [
  /* @__PURE__ */ f.jsx(Xe, { gaData: { ...as, text: "left chevron" }, children: /* @__PURE__ */ f.jsx(Qi, { onClick: e }) }),
  t,
  /* @__PURE__ */ f.jsx(Xe, { gaData: { ...as, text: "right chevron" }, children: /* @__PURE__ */ f.jsx(Ji, { onClick: e }) })
] });
ua.propTypes = {
  children: l.element,
  onClick: l.func
};
const da = ({ carouselItems: e }) => {
  const t = e.map((n) => /* @__PURE__ */ f.jsx("li", { className: "glide__slide slider", children: n.item }, n.id.toString()));
  return /* @__PURE__ */ f.jsx("ul", { className: "glide__slides", children: t });
};
da.propTypes = {
  carouselItems: l.arrayOf(l.object)
};
function ls(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ls(Object(n), !0).forEach(function(r) {
      ju(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ls(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ir(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ir = function(t) {
    return typeof t;
  } : Ir = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ir(e);
}
function qr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Au(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Yr(e, t, n) {
  return t && Au(e.prototype, t), e;
}
function ju(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Nu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Ni(e, t);
}
function Ln(e) {
  return Ln = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ln(e);
}
function Ni(e, t) {
  return Ni = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Ni(e, t);
}
function Pu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Iu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Lu(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Iu(e);
}
function Mu(e) {
  var t = Pu();
  return function() {
    var r = Ln(e), i;
    if (t) {
      var a = Ln(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return Lu(this, i);
  };
}
function Du(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Ln(e), e !== null); )
    ;
  return e;
}
function Lr() {
  return typeof Reflect < "u" && Reflect.get ? Lr = Reflect.get : Lr = function(t, n, r) {
    var i = Du(t, n);
    if (i) {
      var a = Object.getOwnPropertyDescriptor(i, n);
      return a.get ? a.get.call(arguments.length < 3 ? t : r) : a.value;
    }
  }, Lr.apply(this, arguments);
}
var Fu = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function Ut(e) {
  console.error("[Glide warn]: ".concat(e));
}
function tt(e) {
  return parseInt(e);
}
function $u(e) {
  return parseFloat(e);
}
function Pi(e) {
  return typeof e == "string";
}
function Mn(e) {
  var t = Ir(e);
  return t === "function" || t === "object" && !!e;
}
function zr(e) {
  return typeof e == "function";
}
function fa(e) {
  return typeof e > "u";
}
function Ii(e) {
  return e.constructor === Array;
}
function Bu(e, t, n) {
  var r = {};
  for (var i in t)
    zr(t[i]) ? r[i] = t[i](e, r, n) : Ut("Extension must be a function");
  for (var a in r)
    zr(r[a].mount) && r[a].mount();
  return r;
}
function De(e, t, n) {
  Object.defineProperty(e, t, n);
}
function zu(e) {
  return Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t[n], t;
  }, {});
}
function Li(e, t) {
  var n = Object.assign({}, e, t);
  if (t.hasOwnProperty("classes")) {
    n.classes = Object.assign({}, e.classes, t.classes);
    var r = ["direction", "type", "slide", "arrow", "nav"];
    r.forEach(function(i) {
      t.classes.hasOwnProperty(i) && (n.classes[i] = cs(cs({}, e.classes[i]), t.classes[i]));
    });
  }
  return t.hasOwnProperty("breakpoints") && (n.breakpoints = Object.assign({}, e.breakpoints, t.breakpoints)), n;
}
var Hu = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    qr(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }
  return Yr(e, [{
    key: "on",
    value: function(n, r) {
      if (Ii(n)) {
        for (var i = 0; i < n.length; i++)
          this.on(n[i], r);
        return;
      }
      this.hop.call(this.events, n) || (this.events[n] = []);
      var a = this.events[n].push(r) - 1;
      return {
        remove: function() {
          delete this.events[n][a];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(n, r) {
      if (Ii(n)) {
        for (var i = 0; i < n.length; i++)
          this.emit(n[i], r);
        return;
      }
      this.hop.call(this.events, n) && this.events[n].forEach(function(a) {
        a(r || {});
      });
    }
  }]), e;
}(), Vu = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    qr(this, e), this._c = {}, this._t = [], this._e = new Hu(), this.disabled = !1, this.selector = t, this.settings = Li(Fu, n), this.index = this.settings.startAt;
  }
  return Yr(e, [{
    key: "mount",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Mn(n) ? this._c = Bu(this, n, this._e) : Ut("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Ii(n) ? this._t = n : Ut("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Li(this.settings, n), n.hasOwnProperty("startAt") && (this.index = n.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(n) {
      return this._c.Run.make(n), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(n) {
      return this._c.Transition.disable(), this._c.Move.make(n), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return n && (this.settings.autoplay = n), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(n, r) {
      return this._e.on(n, r), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(n) {
      return this.settings.type === n;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(n) {
      Mn(n) ? this._o = n : Ut("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(n) {
      this._i = tt(n);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(n) {
      this._d = !!n;
    }
  }]), e;
}();
function Wu(e, t, n) {
  var r = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(p) {
      var b = this;
      e.disabled || (!e.settings.waitForTransition || e.disable(), this.move = p, n.emit("run.before", this.move), this.calculate(), n.emit("run", this.move), t.Transition.after(function() {
        b.isStart() && n.emit("run.start", b.move), b.isEnd() && n.emit("run.end", b.move), b.isOffset() && (b._o = !1, n.emit("run.offset", b.move)), n.emit("run.after", b.move), e.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var p = this.move, b = this.length, w = p.steps, E = p.direction, I = 1;
      if (E === "=") {
        if (e.settings.bound && tt(w) > b) {
          e.index = b;
          return;
        }
        e.index = w;
        return;
      }
      if (E === ">" && w === ">") {
        e.index = b;
        return;
      }
      if (E === "<" && w === "<") {
        e.index = 0;
        return;
      }
      if (E === "|" && (I = e.settings.perView || 1), E === ">" || E === "|" && w === ">") {
        var O = i(I);
        O > b && (this._o = !0), e.index = a(O, I);
        return;
      }
      if (E === "<" || E === "|" && w === "<") {
        var k = d(I);
        k < 0 && (this._o = !0), e.index = h(k, I);
        return;
      }
      Ut("Invalid direction pattern [".concat(E).concat(w, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return e.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return e.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return p ? this._o ? p === "|>" ? this.move.direction === "|" && this.move.steps === ">" : p === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === p : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return e.isType("slider") && e.settings.focusAt !== "center" && e.settings.bound;
    }
  };
  function i(m) {
    var p = e.index;
    return e.isType("carousel") ? p + m : p + (m - p % m);
  }
  function a(m, p) {
    var b = r.length;
    return m <= b ? m : e.isType("carousel") ? m - (b + 1) : e.settings.rewind ? r.isBound() && !r.isEnd() ? b : 0 : r.isBound() ? b : Math.floor(b / p) * p;
  }
  function d(m) {
    var p = e.index;
    if (e.isType("carousel"))
      return p - m;
    var b = Math.ceil(p / m);
    return (b - 1) * m;
  }
  function h(m, p) {
    var b = r.length;
    return m >= 0 ? m : e.isType("carousel") ? m + (b + 1) : e.settings.rewind ? r.isBound() && r.isStart() ? b : Math.floor(b / p) * p : 0;
  }
  return De(r, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(p) {
      var b = p.substr(1);
      this._m = {
        direction: p.substr(0, 1),
        steps: b ? tt(b) ? tt(b) : b : 0
      };
    }
  }), De(r, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var p = e.settings, b = t.Html.slides.length;
      return this.isBound() ? b - 1 - (tt(p.perView) - 1) + tt(p.focusAt) : b - 1;
    }
  }), De(r, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), r;
}
function us() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Xr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, i, a, d, h = 0, m = function() {
    h = n.leading === !1 ? 0 : us(), r = null, d = e.apply(i, a), r || (i = a = null);
  }, p = function() {
    var w = us();
    !h && n.leading === !1 && (h = w);
    var E = t - (w - h);
    return i = this, a = arguments, E <= 0 || E > t ? (r && (clearTimeout(r), r = null), h = w, d = e.apply(i, a), r || (i = a = null)) : !r && n.trailing !== !1 && (r = setTimeout(m, E)), d;
  };
  return p.cancel = function() {
    clearTimeout(r), h = 0, r = i = a = null;
  }, p;
}
var Rr = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function Uu(e, t, n) {
  var r = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(a) {
      for (var d = 0, h = a.length; d < h; d++) {
        var m = a[d].style, p = t.Direction.value;
        d !== 0 ? m[Rr[p][0]] = "".concat(this.value / 2, "px") : m[Rr[p][0]] = "", d !== a.length - 1 ? m[Rr[p][1]] = "".concat(this.value / 2, "px") : m[Rr[p][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(a) {
      for (var d = 0, h = a.length; d < h; d++) {
        var m = a[d].style;
        m.marginLeft = "", m.marginRight = "";
      }
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return tt(e.settings.gap);
    }
  }), De(r, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return r.value * t.Sizes.length;
    }
  }), De(r, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var a = e.settings.perView;
      return r.value * (a - 1) / a;
    }
  }), n.on(["build.after", "update"], Xr(function() {
    r.apply(t.Html.wrapper.children);
  }, 30)), n.on("destroy", function() {
    r.remove(t.Html.wrapper.children);
  }), r;
}
function pa(e) {
  if (e && e.parentNode) {
    for (var t = e.parentNode.firstChild, n = []; t; t = t.nextSibling)
      t.nodeType === 1 && t !== e && n.push(t);
    return n;
  }
  return [];
}
function Mi(e) {
  return Array.prototype.slice.call(e);
}
var qu = '[data-glide-el="track"]';
function Yu(e, t, n) {
  var r = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = e.selector, this.track = this.root.querySelector(qu), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = Mi(this.wrapper.children).filter(function(a) {
        return !a.classList.contains(e.settings.classes.slide.clone);
      });
    }
  };
  return De(r, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return r._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(a) {
      Pi(a) && (a = document.querySelector(a)), a !== null ? r._r = a : Ut("Root element must be a existing Html node");
    }
  }), De(r, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return r._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(a) {
      r._t = a;
    }
  }), De(r, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return r.track.children[0];
    }
  }), n.on("update", function() {
    r.collectSlides();
  }), r;
}
function Xu(e, t, n) {
  var r = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.peek;
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(a) {
      Mn(a) ? (a.before = tt(a.before), a.after = tt(a.after)) : a = tt(a), r._v = a;
    }
  }), De(r, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var a = r.value, d = e.settings.perView;
      return Mn(a) ? a.before / d + a.after / d : a * 2 / d;
    }
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), r;
}
function Gu(e, t, n) {
  var r = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var a = this, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = d, n.emit("move", {
        movement: this.value
      }), t.Transition.after(function() {
        n.emit("move.after", {
          movement: a.value
        });
      });
    }
  };
  return De(r, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return r._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(a) {
      r._o = fa(a) ? 0 : tt(a);
    }
  }), De(r, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return t.Sizes.slideWidth * e.index;
    }
  }), De(r, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var a = this.offset, d = this.translate;
      return t.Direction.is("rtl") ? d + a : d - a;
    }
  }), n.on(["build.before", "run"], function() {
    r.make();
  }), r;
}
function Ku(e, t, n) {
  var r = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var a = "".concat(this.slideWidth, "px"), d = t.Html.slides, h = 0; h < d.length; h++)
        d[h].style.width = a;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var a = t.Html.slides, d = 0; d < a.length; d++)
        a[d].style.width = "";
      t.Html.wrapper.style.width = "";
    }
  };
  return De(r, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.slides.length;
    }
  }), De(r, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.track.offsetWidth;
    }
  }), De(r, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return r.slideWidth * r.length + t.Gaps.grow + t.Clones.grow;
    }
  }), De(r, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return r.width / e.settings.perView - t.Peek.reductor - t.Gaps.reductor;
    }
  }), n.on(["build.before", "resize", "update"], function() {
    r.setupSlides(), r.setupWrapper();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function Zu(e, t, n) {
  var r = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      n.emit("build.before"), this.typeClass(), this.activeClass(), n.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      t.Html.root.classList.add(e.settings.classes.type[e.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var a = e.settings.classes, d = t.Html.slides[e.index];
      d && (d.classList.add(a.slide.active), pa(d).forEach(function(h) {
        h.classList.remove(a.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var a = e.settings.classes, d = a.type, h = a.slide;
      t.Html.root.classList.remove(d[e.settings.type]), t.Html.slides.forEach(function(m) {
        m.classList.remove(h.active);
      });
    }
  };
  return n.on(["destroy", "update"], function() {
    r.removeClasses();
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), n.on("move.after", function() {
    r.activeClass();
  }), r;
}
function Ju(e, t, n) {
  var r = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], e.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = t.Html.slides, h = e.settings, m = h.perView, p = h.classes, b = h.cloningRatio;
      if (d.length > 0)
        for (var w = +!!e.settings.peek, E = m + w + Math.round(m / 2), I = d.slice(0, E).reverse(), O = d.slice(E * -1), k = 0; k < Math.max(b, Math.floor(m / d.length)); k++) {
          for (var N = 0; N < I.length; N++) {
            var j = I[N].cloneNode(!0);
            j.classList.add(p.slide.clone), a.push(j);
          }
          for (var D = 0; D < O.length; D++) {
            var V = O[D].cloneNode(!0);
            V.classList.add(p.slide.clone), a.unshift(V);
          }
        }
      return a;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var a = this.items, d = t.Html, h = d.wrapper, m = d.slides, p = Math.floor(a.length / 2), b = a.slice(0, p).reverse(), w = a.slice(p * -1).reverse(), E = "".concat(t.Sizes.slideWidth, "px"), I = 0; I < w.length; I++)
        h.appendChild(w[I]);
      for (var O = 0; O < b.length; O++)
        h.insertBefore(b[O], m[0]);
      for (var k = 0; k < a.length; k++)
        a[k].style.width = E;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var a = this.items, d = 0; d < a.length; d++)
        t.Html.wrapper.removeChild(a[d]);
    }
  };
  return De(r, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (t.Sizes.slideWidth + t.Gaps.value) * r.items.length;
    }
  }), n.on("update", function() {
    r.remove(), r.mount(), r.append();
  }), n.on("build.before", function() {
    e.isType("carousel") && r.append();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
var sn = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    qr(this, e), this.listeners = t;
  }
  return Yr(e, [{
    key: "on",
    value: function(n, r, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Pi(n) && (n = [n]);
      for (var d = 0; d < n.length; d++)
        this.listeners[n[d]] = i, r.addEventListener(n[d], this.listeners[n[d]], a);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Pi(n) && (n = [n]);
      for (var a = 0; a < n.length; a++)
        r.removeEventListener(n[a], this.listeners[n[a]], i);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), e;
}();
function Qu(e, t, n) {
  var r = new sn(), i = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("resize", window, Xr(function() {
        n.emit("resize");
      }, e.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("resize", window);
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
var ed = ["ltr", "rtl"], td = {
  ">": "<",
  "<": ">",
  "=": "="
};
function nd(e, t, n) {
  var r = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(a) {
      var d = a.slice(0, 1);
      return this.is("rtl") ? a.split(d).join(td[d]) : a;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(a) {
      return this.value === a;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      t.Html.root.classList.add(e.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      t.Html.root.classList.remove(e.settings.classes.direction[this.value]);
    }
  };
  return De(r, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(a) {
      ed.indexOf(a) > -1 ? r._v = a : Ut("Direction value must be `ltr` or `rtl`");
    }
  }), n.on(["destroy", "update"], function() {
    r.removeClass();
  }), n.on("update", function() {
    r.mount();
  }), n.on(["build.before", "update"], function() {
    r.addClass();
  }), r;
}
function rd(e, t) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return t.Direction.is("rtl") ? -r : r;
    }
  };
}
function id(e, t) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = Math.floor(r / t.Sizes.slideWidth);
      return r + t.Gaps.value * i;
    }
  };
}
function od(e, t) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return r + t.Clones.grow / 2;
    }
  };
}
function sd(e, t) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      if (e.settings.focusAt >= 0) {
        var i = t.Peek.value;
        return Mn(i) ? r - i.before : r - i;
      }
      return r;
    }
  };
}
function ad(e, t) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = t.Gaps.value, a = t.Sizes.width, d = e.settings.focusAt, h = t.Sizes.slideWidth;
      return d === "center" ? r - (a / 2 - h / 2) : r - h * d - i * d;
    }
  };
}
function ld(e, t, n) {
  var r = [id, od, sd, ad].concat(e._t, [rd]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(a) {
      for (var d = 0; d < r.length; d++) {
        var h = r[d];
        zr(h) && zr(h().modify) ? a = h(e, t, n).modify(a) : Ut("Transformer should be a function that returns an object with `modify()` method");
      }
      return a;
    }
  };
}
function cd(e, t, n) {
  var r = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(a) {
      var d = ld(e, t).mutate(a), h = "translate3d(".concat(-1 * d, "px, 0px, 0px)");
      t.Html.wrapper.style.mozTransform = h, t.Html.wrapper.style.webkitTransform = h, t.Html.wrapper.style.transform = h;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var a = t.Sizes.length, d = e.index, h = e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a + (d - h) : (d + h) % a;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var a = t.Sizes.slideWidth * e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a * -1 : a;
    }
  };
  return n.on("move", function(i) {
    if (!e.isType("carousel") || !t.Run.isOffset())
      return r.set(i.movement);
    t.Transition.after(function() {
      n.emit("translate.jump"), r.set(t.Sizes.slideWidth * e.index);
    });
    var a = t.Sizes.slideWidth * t.Translate.getStartIndex();
    return r.set(a - t.Translate.getTravelDistance());
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function ud(e, t, n) {
  var r = !1, i = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(d) {
      var h = e.settings;
      return r ? "".concat(d, " 0ms ").concat(h.animationTimingFunc) : "".concat(d, " ").concat(this.duration, "ms ").concat(h.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      t.Html.wrapper.style.transition = this.compose(d);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(d) {
      setTimeout(function() {
        d();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      r = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      r = !0, this.set();
    }
  };
  return De(i, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var d = e.settings;
      return e.isType("slider") && t.Run.offset ? d.rewindDuration : d.animationDuration;
    }
  }), n.on("move", function() {
    i.set();
  }), n.on(["build.before", "resize", "translate.jump"], function() {
    i.disable();
  }), n.on("run", function() {
    i.enable();
  }), n.on("destroy", function() {
    i.remove();
  }), i;
}
var ha = !1;
try {
  var ds = Object.defineProperty({}, "passive", {
    get: function() {
      ha = !0;
    }
  });
  window.addEventListener("testPassive", null, ds), window.removeEventListener("testPassive", null, ds);
} catch {
}
var Di = ha, Or = ["touchstart", "mousedown"], fs = ["touchmove", "mousemove"], ps = ["touchend", "touchcancel", "mouseup", "mouseleave"], hs = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function dd(e, t, n) {
  var r = new sn(), i = 0, a = 0, d = 0, h = !1, m = Di ? {
    passive: !0
  } : !1, p = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(w) {
      if (!h && !e.disabled) {
        this.disable();
        var E = this.touches(w);
        i = null, a = tt(E.pageX), d = tt(E.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), n.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(w) {
      if (!e.disabled) {
        var E = e.settings, I = E.touchAngle, O = E.touchRatio, k = E.classes, N = this.touches(w), j = tt(N.pageX) - a, D = tt(N.pageY) - d, V = Math.abs(j << 2), W = Math.abs(D << 2), M = Math.sqrt(V + W), J = Math.sqrt(W);
        if (i = Math.asin(J / M), i * 180 / Math.PI < I)
          w.stopPropagation(), t.Move.make(j * $u(O)), t.Html.root.classList.add(k.dragging), n.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(w) {
      if (!e.disabled) {
        var E = e.settings, I = E.perSwipe, O = E.touchAngle, k = E.classes, N = this.touches(w), j = this.threshold(w), D = N.pageX - a, V = i * 180 / Math.PI;
        this.enable(), D > j && V < O ? t.Run.make(t.Direction.resolve("".concat(I, "<"))) : D < -j && V < O ? t.Run.make(t.Direction.resolve("".concat(I, ">"))) : t.Move.make(), t.Html.root.classList.remove(k.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), n.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var w = this, E = e.settings, I = E.swipeThreshold, O = E.dragThreshold;
      I && r.on(Or[0], t.Html.wrapper, function(k) {
        w.start(k);
      }, m), O && r.on(Or[1], t.Html.wrapper, function(k) {
        w.start(k);
      }, m);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      r.off(Or[0], t.Html.wrapper, m), r.off(Or[1], t.Html.wrapper, m);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var w = this;
      r.on(fs, t.Html.wrapper, Xr(function(E) {
        w.move(E);
      }, e.settings.throttle), m);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      r.off(fs, t.Html.wrapper, m);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var w = this;
      r.on(ps, t.Html.wrapper, function(E) {
        w.end(E);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      r.off(ps, t.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(w) {
      return hs.indexOf(w.type) > -1 ? w : w.touches[0] || w.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(w) {
      var E = e.settings;
      return hs.indexOf(w.type) > -1 ? E.dragThreshold : E.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return h = !1, t.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return h = !0, t.Transition.disable(), this;
    }
  };
  return n.on("build.after", function() {
    t.Html.root.classList.add(e.settings.classes.swipeable);
  }), n.on("destroy", function() {
    p.unbindSwipeStart(), p.unbindSwipeMove(), p.unbindSwipeEnd(), r.destroy();
  }), p;
}
function fd(e, t, n) {
  var r = new sn(), i = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("dragstart", t.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("dragstart", t.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(d) {
      d.preventDefault();
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
function pd(e, t, n) {
  var r = new sn(), i = !1, a = !1, d = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = t.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("click", t.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("click", t.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(m) {
      a && (m.stopPropagation(), m.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (a = !0, !i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !1;
        i = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (a = !1, i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !0;
        i = !1;
      }
      return this;
    }
  };
  return De(d, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return d._a;
    }
  }), n.on("swipe.move", function() {
    d.detach();
  }), n.on("swipe.end", function() {
    t.Transition.after(function() {
      d.attach();
    });
  }), n.on("destroy", function() {
    d.attach(), d.unbind(), r.destroy();
  }), d;
}
var hd = '[data-glide-el="controls[nav]"]', to = '[data-glide-el^="controls"]', md = "".concat(to, ' [data-glide-dir*="<"]'), gd = "".concat(to, ' [data-glide-dir*=">"]');
function vd(e, t, n) {
  var r = new sn(), i = Di ? {
    passive: !0
  } : !1, a = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = t.Html.root.querySelectorAll(hd), this._c = t.Html.root.querySelectorAll(to), this._arrowControls = {
        previous: t.Html.root.querySelectorAll(md),
        next: t.Html.root.querySelectorAll(gd)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.addClass(this._n[h].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.removeClass(this._n[h].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(h) {
      var m = e.settings, p = h[e.index];
      p && (p.classList.add(m.classes.nav.active), pa(p).forEach(function(b) {
        b.classList.remove(m.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(h) {
      var m = h[e.index];
      m == null || m.classList.remove(e.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!e.settings.rewind) {
        var h = a._arrowControls.next, m = a._arrowControls.previous;
        this.resetArrowState(h, m), e.index === 0 && this.disableArrow(m), e.index === t.Run.length && this.disableArrow(h);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var h = e.settings, m = arguments.length, p = new Array(m), b = 0; b < m; b++)
        p[b] = arguments[b];
      p.forEach(function(w) {
        Mi(w).forEach(function(E) {
          E.classList.remove(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var h = e.settings, m = arguments.length, p = new Array(m), b = 0; b < m; b++)
        p[b] = arguments[b];
      p.forEach(function(w) {
        Mi(w).forEach(function(E) {
          E.classList.add(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.bind(this._c[h].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.unbind(this._c[h].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(h) {
      for (var m = 0; m < h.length; m++)
        r.on("click", h[m], this.click), r.on("touchstart", h[m], this.click, i);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(h) {
      for (var m = 0; m < h.length; m++)
        r.off(["click", "touchstart"], h[m]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(h) {
      !Di && h.type === "touchstart" && h.preventDefault();
      var m = h.currentTarget.getAttribute("data-glide-dir");
      t.Run.make(t.Direction.resolve(m));
    }
  };
  return De(a, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return a._c;
    }
  }), n.on(["mount.after", "move.after"], function() {
    a.setActive();
  }), n.on(["mount.after", "run"], function() {
    a.setArrowState();
  }), n.on("destroy", function() {
    a.removeBindings(), a.removeActive(), r.destroy();
  }), a;
}
function yd(e, t, n) {
  var r = new sn(), i = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      e.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(d) {
      var h = e.settings.perSwipe, m = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(d.code) && t.Run.make(t.Direction.resolve("".concat(h).concat(m[d.code])));
    }
  };
  return n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function xd(e, t, n) {
  var r = new sn(), i = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), e.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var d = this;
      this._e && (this.enable(), e.settings.autoplay && fa(this._i) && (this._i = setInterval(function() {
        d.stop(), t.Run.make(">"), d.start(), n.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var d = this;
      r.on("mouseover", t.Html.root, function() {
        d._e && d.stop();
      }), r.on("mouseout", t.Html.root, function() {
        d._e && d.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      r.off(["mouseover", "mouseout"], t.Html.root);
    }
  };
  return De(i, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var d = t.Html.slides[e.index].getAttribute("data-glide-autoplay");
      return tt(d || e.settings.autoplay);
    }
  }), n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on(["run.before", "swipe.start", "update"], function() {
    i.stop();
  }), n.on(["pause", "destroy"], function() {
    i.disable(), i.stop();
  }), n.on(["run.after", "swipe.end"], function() {
    i.start();
  }), n.on(["play"], function() {
    i.enable(), i.start();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function ms(e) {
  return Mn(e) ? zu(e) : (Ut("Breakpoints option must be an object"), {});
}
function bd(e, t, n) {
  var r = new sn(), i = e.settings, a = ms(i.breakpoints), d = Object.assign({}, i), h = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(p) {
      if (typeof window.matchMedia < "u") {
        for (var b in p)
          if (p.hasOwnProperty(b) && window.matchMedia("(max-width: ".concat(b, "px)")).matches)
            return p[b];
      }
      return d;
    }
  };
  return Object.assign(i, h.match(a)), r.on("resize", window, Xr(function() {
    e.settings = Li(i, h.match(a));
  }, e.settings.throttle)), n.on("update", function() {
    a = ms(a), d = Object.assign({}, i);
  }), n.on("destroy", function() {
    r.off("resize", window);
  }), h;
}
var wd = {
  // Required
  Html: Yu,
  Translate: cd,
  Transition: ud,
  Direction: nd,
  Peek: Xu,
  Sizes: Ku,
  Gaps: Uu,
  Move: Gu,
  Clones: Ju,
  Resize: Qu,
  Build: Zu,
  Run: Wu,
  // Optional
  Swipe: dd,
  Images: fd,
  Anchors: pd,
  Controls: vd,
  Keyboard: yd,
  Autoplay: xd,
  Breakpoints: bd
}, Sd = /* @__PURE__ */ function(e) {
  Nu(n, e);
  var t = Mu(n);
  function n() {
    return qr(this, n), t.apply(this, arguments);
  }
  return Yr(n, [{
    key: "mount",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Lr(Ln(n.prototype), "mount", this).call(this, Object.assign({}, wd, i));
    }
  }]), n;
}(Vu);
function kd(e) {
  let t, n, r;
  switch (e) {
    case 3:
      t = 1, n = 2, r = 3;
      break;
    case 2:
      t = 1, n = 2, r = 2;
      break;
    case 1:
    default:
      t = 1, n = 1, r = 1;
  }
  return {
    perViewSm: t,
    perViewMd: n,
    perViewLg: r
  };
}
function Td(e = 1, t, n = !0, r) {
  const { perViewSm: i, perViewMd: a, perViewLg: d } = kd(e), h = n ? 24 : 0, m = n ? { before: 48, after: 48 } : 0, p = n ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: h,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: r ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: d,
    // Can be overwritten at breakpoints
    peek: p,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: t ? null : {
      576: {
        // BS4 sm
        perView: i,
        peek: m
      },
      768: {
        // BS4 md
        perView: a,
        peek: m
      },
      992: {
        // BS4 lg
        perView: d,
        peek: m
      },
      1260: {
        // BS4 xl
        perView: d,
        peek: m
      },
      1400: {
        perView: d,
        peek: p
      },
      1920: {
        perView: d,
        peek: p
      }
    }
  };
}
function _d(e, t, n) {
  const r = e.querySelector(".glide__arrow--prev"), i = e.querySelector(".glide__arrow--next"), a = e.querySelector(".glide__track"), d = e.querySelector(
    ".image-navigator-images"
  );
  if (!(r || i)) return;
  const h = ["slider-start", "slider-mid", "slider-end"], m = "glide__arrow--disabled";
  a == null || a.classList.remove(...h), d == null || d.classList.remove(...h), t === 0 ? (a == null || a.classList.add("slider-start"), d == null || d.classList.add("slider-start"), r == null || r.classList.add(m), r == null || r.setAttribute("aria-disabled", "true"), i == null || i.classList.remove(m), i == null || i.setAttribute("aria-disabled", "false")) : t >= n - 1 ? (a == null || a.classList.add("slider-end"), d == null || d.classList.add("slider-end"), r == null || r.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.classList.add(m), i == null || i.setAttribute("aria-disabled", "true")) : (a == null || a.classList.add("slider-mid"), d == null || d.classList.add("slider-mid"), r == null || r.classList.remove(m), i == null || i.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.setAttribute("aria-disabled", "false"));
}
function Ed(e, t, n) {
  const r = e.querySelectorAll(".glide__slide"), i = t, a = Math.min(
    r.length - 1,
    t + n - 1
  );
  r.forEach((d, h) => {
    h < i || h > a ? (d.setAttribute("aria-hidden", "true"), d.setAttribute("tabindex", "-1"), d.setAttribute("inert", "")) : (d.setAttribute("aria-hidden", "false"), d.removeAttribute("tabindex"), d.removeAttribute("inert"));
  });
}
function Cd({
  instanceName: e,
  perView: t,
  buttonCount: n,
  isFullWidth: r = !1,
  onItemClick: i,
  hasPeek: a = !0,
  isDraggable: d
}) {
  const h = Td(t, r, a, d), m = new Sd(`#${e}`, h);
  let p = document.querySelector(`#${e}`);
  return p.addEventListener("keyup", (b) => {
    const w = b;
    w.keyCode === 39 ? m.go(">") : w.keyCode === 37 ? m.go("<") : w.keyCode === 13 && m.go(document.activeElement.dataset.glideDir);
  }), m.on("build.before", () => {
    p = document.querySelector(`#${e}`), p && p.classList.add("slider-start");
  }), m.on("move", () => {
    if (p = document.querySelector(`#${e}`), !p) return;
    const b = m.index;
    Ed(p, b, t);
    const w = p.querySelector(".navigation-slider"), E = p.querySelector(".image-navigator-images");
    if (w && E) {
      const I = w.querySelectorAll(
        ".bullet-image-container"
      ), O = w.clientWidth, k = 82, N = I[b], j = E.getBoundingClientRect().x, D = w.getBoundingClientRect().x - j, V = N.getBoundingClientRect().x - j, W = N.getBoundingClientRect().x + N.getBoundingClientRect().width - j;
      if (b === 0 || V <= 0 + k)
        w.style.left = `${D - V + k}px`;
      else if (W >= O - k) {
        const M = W - O;
        w.style.left = `${D - M - k}px`;
      }
    }
    _d(p, b, n), p.setAttribute("data-current-index", b), i && i(b);
  }), m.mount(), m;
}
function Rd(e, t) {
  let n;
  const r = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return n = e, r >= 992 && (t >= 2 && (n = e - 1), t >= 3 && (n = e - 2)), n;
}
const or = ({
  perView: e = 1,
  width: t,
  maxWidth: n,
  carouselItems: r,
  cssClass: i = "",
  CustomNavComponent: a,
  role: d,
  ariaLabelledBy: h,
  isFullWidth: m,
  removeSideBackground: p = !1,
  hasNavButtons: b = !0,
  hasPositionIndicators: w = !0,
  imageAutoSize: E = !0,
  onItemClick: I = () => null,
  hasPeek: O = !0,
  isDraggable: k = !0,
  hasShadow: N = !0
}) => {
  const j = `glide-${Math.ceil(Math.random() * 1e4)}`, D = Rd(r.length, e);
  return lt(() => {
    Cd({
      instanceName: j,
      perView: e,
      buttonCount: D,
      isFullWidth: m,
      onItemClick: I,
      hasPeek: O,
      isDraggable: k
    });
  }, [
    j,
    e,
    D,
    m,
    I,
    O,
    k
  ]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: d,
      "aria-labelledby": h,
      className: `glide ${i}`,
      id: j,
      style: { width: t, maxWidth: n },
      "data-remove-side-background": p,
      "data-image-auto-size": E,
      "data-has-shadow": N,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ f.jsx(da, { carouselItems: r }) }),
        a ? (
          // @ts-ignore
          /* @__PURE__ */ f.jsx(a, { instanceName: j })
        ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          w && /* @__PURE__ */ f.jsx(la, { buttonCount: D }),
          b && /* @__PURE__ */ f.jsx(ua, {})
        ] })
      ]
    }
  );
};
or.propTypes = {
  perView: l.number,
  width: l.string,
  maxWidth: l.string,
  carouselItems: l.arrayOf(l.object).isRequired,
  cssClass: l.string,
  CustomNavComponent: l.func,
  role: l.string,
  ariaLabelledBy: l.string,
  onItemClick: l.func,
  isFullWidth: l.bool,
  removeSideBackground: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool,
  imageAutoSize: l.bool,
  hasPeek: l.bool,
  isDraggable: l.bool,
  hasShadow: l.bool
};
const Od = ({
  id: e,
  imageSource: t,
  imageAltText: n,
  title: r,
  content: i,
  eventLocation: a,
  eventTime: d,
  buttons: h,
  linkLabel: m,
  linkUrl: p,
  tags: b
}, w, E, I) => {
  var O;
  return {
    // @ts-ignore
    id: e,
    item: /* @__PURE__ */ f.jsx(
      Vt,
      {
        type: w,
        horizontal: E,
        image: t,
        imageAltText: n,
        title: r,
        body: i,
        eventFormat: I,
        eventLocation: a,
        eventTime: d,
        buttons: h,
        linkLabel: m,
        linkUrl: p || ((O = h == null ? void 0 : h[0]) == null ? void 0 : O.href),
        tags: b
      }
    )
  };
}, ma = ({
  perView: e = 0,
  cardItems: t = [],
  cardType: n = "default",
  cardEventFormat: r = "stack",
  cardHorizontal: i = !1,
  width: a = void 0,
  maxWidth: d = void 0,
  imageAutoSize: h = !0
}) => {
  const m = parseInt(`${e}`, 10), [p, b] = Je(m), w = 1024, E = 768;
  lt(() => {
    const k = () => {
      const N = window.innerWidth;
      let j;
      switch (m) {
        case 3:
          N > w ? j = 3 : N > E ? j = 2 : j = 1;
          break;
        case 2:
          j = N < E ? 1 : 2;
          break;
        default:
          j = 1;
          break;
      }
      b(j);
    };
    return k(), window.addEventListener("resize", k), () => window.removeEventListener("resize", k);
  }, [m]);
  const I = t.map(
    (k) => Od(k, n, i, r)
  ), O = t.length > p;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: +p,
      maxWidth: d,
      width: a,
      carouselItems: I,
      cssClass: "aligned-carousel",
      imageAutoSize: h,
      removeSideBackground: t.length <= p,
      hasPositionIndicators: O,
      hasNavButtons: O,
      isDraggable: O,
      hasShadow: !0
    }
  );
};
ma.propTypes = {
  perView: l.string.isRequired,
  cardItems: l.arrayOf(
    l.shape({
      title: l.string.isRequired,
      content: l.string,
      eventLocation: l.string,
      eventTime: l.string,
      image: l.string,
      imageAltText: l.string,
      buttons: Vt.propTypes.buttons,
      linkLabel: l.string,
      linkUrl: l.string,
      tags: Vt.propTypes.tags
    })
  ).isRequired,
  cardType: Vt.propTypes.type,
  cardEventFormat: Vt.propTypes.eventFormat,
  cardHorizontal: Vt.propTypes.horizontal,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Ad = ({ id: e, imageSource: t, imageAltText: n, title: r, content: i }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: t,
        className: "uds-img figure-img img-fluid",
        alt: n,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (r || i) && /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ f.jsx("div", { className: "uds-caption-text", children: r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx("h3", { children: r }),
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } })
        ] }) : /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } }) })
      }
    )
  ] }) })
}), ga = ({
  perView: e = 0,
  imageItems: t = [],
  width: n = void 0,
  maxWidth: r = void 0,
  imageAutoSize: i = !0
}) => {
  if (!t || t.length === 0)
    return null;
  const a = parseInt(`${e}`, 10), d = t.map(Ad) || [], h = t.length > a;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: +a,
      maxWidth: r,
      width: n,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: d,
      imageAutoSize: i,
      removeSideBackground: t.length <= a,
      hasPositionIndicators: h,
      hasNavButtons: h,
      isDraggable: h,
      hasShadow: !0
    }
  );
};
ga.propTypes = {
  perView: l.number.isRequired,
  imageItems: l.arrayOf(l.object).isRequired,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const jd = (e, t) => {
  if (!e)
    return 0;
  const n = (e.match(/<br/g) || []).length, r = t / 6;
  return (parseInt(`${e.length / r}`, 10) + n) * 20;
}, Hr = {
  imageItems: l.arrayOf(
    l.shape({
      id: l.number,
      imageSource: l.string,
      thumbnailSource: l.string,
      imageAltText: l.string,
      content: l.oneOfType([l.string, l.element])
    })
  ),
  hasContent: l.bool
}, Nd = ({ id: e, imageSource: t, imageAltText: n }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsx(
    "img",
    {
      src: t,
      className: "uds-img figure-img img-fluid",
      alt: n,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), va = ({ instanceName: e, imageItems: t, hasContent: n }) => {
  var b, w;
  const r = "data-current-index", [i, a] = Je(((b = t == null ? void 0 : t[0]) == null ? void 0 : b.title) || ""), [d, h] = Je(((w = t == null ? void 0 : t[0]) == null ? void 0 : w.content) || ""), m = jn(
    (E) => {
      const I = t == null ? void 0 : t[E];
      I && (a(I.title), h(I.content));
    },
    [t]
  );
  if (lt(() => {
    if (!t || t.length === 0)
      return;
    const E = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (E) {
      const N = parseInt(
        window.getComputedStyle(E, null).getPropertyValue("width").split("px")[0],
        10
      ), j = t.reduce((D, V) => {
        const W = jd(V.content, N);
        return W > D ? W : D;
      }, 0);
      E.style.height = `${j}px`;
    }
    const I = document.querySelector(`#${e}`);
    if (!I)
      return;
    function O(N) {
      for (const j of N)
        if (j && j.attributeName === r) {
          const D = I.getAttribute(r);
          D !== null && m(+D);
          return;
        }
    }
    const k = new MutationObserver(O);
    return k.observe(I, {
      attributes: !0
    }), () => {
      k.disconnect();
    };
  }, [e, t, m]), !t || t.length === 0)
    return null;
  const p = t.map((E) => E.imageSource);
  return /* @__PURE__ */ f.jsxs("div", { className: "image-gallery-action-area", "data-has-content": n, children: [
    /* @__PURE__ */ f.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ f.jsxs(eo, { children: [
      /* @__PURE__ */ f.jsx(Qi, {}),
      /* @__PURE__ */ f.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ f.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ f.jsx(
        ca,
        {
          imageItems: p,
          onItemClick: (E) => m(E)
        }
      ) }) }),
      /* @__PURE__ */ f.jsx(Ji, {})
    ] }) }),
    n && (i || d) ? /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ f.jsxs("div", { className: "uds-caption-text", children: [
          i ? /* @__PURE__ */ f.jsx("h3", { children: i }) : null,
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: d } })
        ] })
      }
    ) : null
  ] });
};
va.propTypes = {
  instanceName: l.string,
  imageItems: Hr.imageItems,
  hasContent: Hr.hasContent
};
const ya = ({
  width: e,
  maxWidth: t,
  imageItems: n = [],
  hasContent: r = !1,
  imageAutoSize: i = !0
}) => {
  const a = n.map(Nd), d = n.length > 1;
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: a,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: r ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: i,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: h }) => /* @__PURE__ */ f.jsx(
        va,
        {
          instanceName: h,
          hasContent: r,
          imageItems: n
        }
      ),
      removeSideBackground: n.length <= 1,
      hasPositionIndicators: d,
      hasNavButtons: d,
      isDraggable: d,
      hasShadow: !0
    }
  );
};
ya.propTypes = {
  imageItems: Hr.imageItems.isRequired,
  hasContent: Hr.hasContent,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Pd = ({ id: e, imageSource: t, imageAltText: n, quote: r }, i = {}) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx(
    Ki,
    {
      imageSource: t,
      imageAltText: n,
      quote: r,
      itemStyle: i
    }
  )
}), xa = ({
  width: e,
  maxWidth: t,
  testimonialItems: n = [],
  itemStyle: r = {},
  hasNavButtons: i = !1,
  hasPositionIndicators: a = !1,
  imageAutoSize: d = !0
}) => {
  const h = n.map(
    (m) => Pd(m, r)
  );
  return /* @__PURE__ */ f.jsx(
    or,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: h,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: i,
      hasPositionIndicators: a,
      imageAutoSize: d,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
xa.propTypes = {
  testimonialItems: l.arrayOf(
    l.shape({
      title: l.string,
      content: l.string,
      cite: l.shape({
        name: l.string,
        description: l.string
      })
    })
  ).isRequired,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  }),
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool
};
var Dt = /* @__PURE__ */ ((e) => (e.UNORDERED = "unordered", e.ORDERED = "ordered", e.ICON = "icon", e.STEP = "step", e.DISPLAY = "display", e))(Dt || {}), Mr = /* @__PURE__ */ ((e) => (e.UL = "ul", e.OL = "ol", e))(Mr || {}), bn = /* @__PURE__ */ ((e) => (e.NONE = "none", e.LIGHT = "light", e.MEDIUM = "medium", e.DARK = "dark", e))(bn || {}), Dr = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(Dr || {});
const ba = (e) => {
  switch (e) {
    case Mr.OL:
    case Dt.ORDERED:
    case Dt.STEP:
      return Mr.OL;
    default:
      return Mr.UL;
  }
}, wa = ({
  listType: e,
  content: t,
  icon: n,
  nestedType: r,
  nestedItems: i
}) => {
  const [a, ...d] = Array.isArray(t) ? t : [t];
  let h = null;
  if (i != null && i.length) {
    const m = r || e, p = ba(m);
    h = /* @__PURE__ */ f.jsx(p, { children: i.map((b, w) => /* @__PURE__ */ f.jsx(wa, { listType: m, ...b }, w)) });
  }
  return /* @__PURE__ */ f.jsxs("li", { children: [
    n && /* @__PURE__ */ f.jsx("span", { className: `fa-li ${n == null ? void 0 : n[0]} fa-${n == null ? void 0 : n[1]}` }),
    a,
    " ",
    d.map((m, p) => [/* @__PURE__ */ f.jsx("br", {}, `br-${p}`), /* @__PURE__ */ f.jsx("span", { children: m }, p)]),
    h
  ] });
}, Id = ({
  listType: e = Dt.UNORDERED,
  backgroundColor: t = bn.NONE,
  listItemStyleColor: n = Dr.DEFAULT,
  items: r
}) => {
  const i = ba(e);
  let a = "maroon", d = "maroon";
  t === bn.DARK && (a = "gold", d = "gold"), e === Dt.STEP && (a = "uds-steplist-maroon", d = "uds-steplist-gold", t === bn.DARK && (a = "uds-steplist-gold"));
  const h = ve({
    "uds-list": e === Dt.UNORDERED || e === Dt.ORDERED,
    "uds-list fa-ul": e === Dt.ICON,
    "uds-list uds-steplist": e === Dt.STEP,
    "uds-list uds-display-list": e === Dt.DISPLAY,
    "light-smokemode": t === bn.LIGHT,
    smokemode: t === bn.MEDIUM,
    darkmode: t === bn.DARK,
    [`${a}`]: n === Dr.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${d}`]: n === Dr.SECONDARY
  });
  return /* @__PURE__ */ f.jsx(i, { className: h || null, children: r.map((m, p) => /* @__PURE__ */ f.jsx(wa, { listType: e, ...m }, p)) });
}, Ld = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, Md = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Dd = ({
  gridLinkItems: e,
  numColumns: t,
  textColor: n,
  children: r
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        t,
        Ld[n]
      ].join(" "),
      children: e && e.map((i) => /* @__PURE__ */ f.jsx(
        Xe,
        {
          gaData: {
            ...Md,
            text: i.label,
            section: `grid links ${i.label}`
          },
          children: /* @__PURE__ */ f.jsxs("a", { href: i.href, children: [
            /* @__PURE__ */ f.jsx("span", { className: `fa fa-fw ${i.icon}` }),
            i.label
          ] })
        },
        i.label + i.href
      ))
    }
  ),
  /* @__PURE__ */ f.jsx("div", { children: r })
] });
var no, gs = Ma;
no = gs.createRoot, gs.hydrateRoot;
const Fd = (e, t, n) => {
  no(n).render(He.createElement(e, t));
}, Gr = ({ typeCarousel: e, targetSelector: t, props: n }) => {
  const i = {
    card: ma,
    testimonial: xa,
    image: ga,
    "image-gallery": ya
  }[e];
  i && Fd(i, n, document.querySelector(t));
}, Hd = ({ targetSelector: e, props: t }) => Gr({
  typeCarousel: "card",
  targetSelector: e,
  props: t
}), Vd = ({ targetSelector: e, props: t }) => {
  Gr({
    typeCarousel: "testimonial",
    targetSelector: e,
    props: t
  });
}, Wd = ({ targetSelector: e, props: t }) => {
  Gr({ typeCarousel: "image", targetSelector: e, props: t });
}, Ud = ({ targetSelector: e, props: t }) => {
  Gr({
    typeCarousel: "image-gallery",
    targetSelector: e,
    props: t
  });
}, qe = (e, t, n) => {
  no(n).render(He.createElement(e, t));
}, qd = ({ targetSelector: e, props: t }) => qe(As, t, document.querySelector(e)), Yd = ({ targetSelector: e, props: t }) => qe(Ws, t, document.querySelector(e)), Xd = ({ targetSelector: e, props: t }) => qe(Ys, t, document.querySelector(e)), Gd = ({ targetSelector: e, props: t }) => qe(wn, t, document.querySelector(e)), Kd = ({ targetSelector: e, props: t }) => qe(Yi, t, document.querySelector(e)), Zd = ({ targetSelector: e, props: t }) => qe(Xi, t, document.querySelector(e)), Jd = ({ targetSelector: e, props: t }) => qe(Vt, t, document.querySelector(e)), Qd = ({ targetSelector: e, props: t }) => qe(Js, t, document.querySelector(e)), ef = ({ targetSelector: e, props: t }) => qe(Qs, t, document.querySelector(e)), tf = ({ targetSelector: e, props: t }) => qe(Dd, t, document.querySelector(e)), nf = ({ targetSelector: e, props: t }) => qe(na, t, document.querySelector(e)), rf = ({ targetSelector: e, props: t }) => qe(Sn, t, document.querySelector(e)), of = ({ targetSelector: e, props: t }) => qe(ra, t, document.querySelector(e)), sf = ({ targetSelector: e, props: t }) => qe(Gi, t, document.querySelector(e)), af = ({ targetSelector: e, props: t }) => qe(sa, t, document.querySelector(e)), lf = ({ targetSelector: e, props: t }) => qe(Ki, t, document.querySelector(e)), cf = ({ targetSelector: e, props: t }) => qe(aa, t, document.querySelector(e)), uf = ({ targetSelector: e, props: t }) => qe(bu, t, document.querySelector(e)), df = ({ targetSelector: e, props: t }) => qe(iu, t, document.querySelector(e)), ff = ({ targetSelector: e, props: t }) => qe(_u, t, document.querySelector(e)), pf = ({ targetSelector: e, props: t }) => qe(Id, t, document.querySelector(e));
export {
  As as Accordion,
  Ws as AnchorMenu,
  Ys as Article,
  wn as Button,
  Yi as ButtonIconOnly,
  Xi as ButtonTag,
  Vt as Card,
  Js as CardArrangement,
  ma as CardCarousel,
  Qs as ContentSpotlight,
  iu as Divider,
  ru as DividerType,
  hu as FeedBody,
  cu as FeedContainerProvider,
  lu as FeedContext,
  pu as FeedHeader,
  Dd as GridLinks,
  na as Hero,
  Sn as Image,
  ga as ImageCarousel,
  ya as ImageGalleryCarousel,
  Id as List,
  ia as NavControls,
  ra as Pagination,
  Gi as RankingCard,
  bu as SystemAlert,
  xu as SystemAlertType,
  ku as Tab,
  oa as TabHeader,
  sa as TabbedPanels,
  Ki as Testimonial,
  xa as TestimonialCarousel,
  _u as Tooltip,
  aa as Video,
  zd as feedCardButtonShape,
  du as feedComponentShape,
  ta as feedCtaButtonShape,
  uu as feedDataSourceShape,
  ea as feedHeaderShape,
  qd as initAccordion,
  Yd as initAnchorMenu,
  Xd as initArticle,
  Gd as initButton,
  Kd as initButtonIconOnly,
  Zd as initButtonTag,
  Jd as initCard,
  Qd as initCardArrangement,
  Hd as initCardCarousel,
  ef as initContentSpotlight,
  df as initDivider,
  tf as initGridLinks,
  nf as initHero,
  rf as initImage,
  Wd as initImageCarousel,
  Ud as initImageGalleryCarousel,
  pf as initList,
  of as initPagination,
  sf as initRankingCard,
  uf as initSystemAlert,
  af as initTabbedPanels,
  lf as initTestimonial,
  Vd as initTestimonialCarousel,
  ff as initTooltip,
  cf as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.6.2
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width: 1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width: 576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width: 576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width: 1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();